
if (typeof (window) !== 'undefined' && window.performance && window.performance.mark) {
  window.performance.mark('yotpo:loader:loaded');
}
var yotpoWidgetsContainer = yotpoWidgetsContainer || { guids: {} };
(function(){
    var guid = "pc-_zsvJHOoRaZ3ebWa_rg";
    var loader = {
        loadDep: function (link, onLoad, strategy) {
            var script = document.createElement('script');
            script.onload = onLoad || function(){};
            script.src = link;
            if (strategy === 'defer') {
                script.defer = true;
            } else if (strategy === 'async') {
                script.async = true;
            }
            script.setAttribute("type", "text/javascript");
            script.setAttribute("charset", "utf-8");
            document.head.appendChild(script);
        },
        config: {
            data: {
                guid: guid
            },
            widgets: {
            
                "1141266": {
                    instanceId: "1141266",
                    instanceVersionId: "345869984",
                    templateAssetUrl: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widget-product-points/app.v0.3.26-7158.js",
                    cssOverrideAssetUrl: "https://cdn-widget-assets.yotpo.com/ProductPoints/pc-_zsvJHOoRaZ3ebWa_rg/css-overrides/css-overrides.2025_06_03_11_48_02_239.css",
                    customizationCssUrl: "",
                    customizations: {
                      "icon-color": "#1C1D21",
                      "icon-type": "customIcon",
                      "icon-url": "https://cdn-widget-assets.yotpo.com/static_assets/pc-_zsvJHOoRaZ3ebWa_rg/images/image_2025_06_03_11_36_43_571",
                      "logged-in-non-member-confirmation-text": "Sie sind jetzt Mitglied unseres Prämienprogramms!",
                      "logged-in-non-member-popover-background-color": "#FFFFFF",
                      "logged-in-non-member-popover-button-color": "rgba(0,0,0,1)",
                      "logged-in-non-member-popover-button-style": 2,
                      "logged-in-non-member-popover-button-text-color": "#FFFFFF",
                      "logged-in-non-member-popover-disclaimer-text-size": "8px",
                      "logged-in-non-member-popover-text-color": "#000000",
                      "logged-in-non-member-popover-title-text": "Sie sind nur einen Schritt von Belohnungen entfernt!",
                      "logged-in-non-member-popover-title-text-size": "16px",
                      "logged-in-non-member-text": "Sammeln Sie **{{points_amount}} Punkte** für dieses Produkt.",
                      "logged-in-text": "Sammeln Sie **{{points_amount}} Punkte** für dieses Produkt.",
                      "logged-out-text": "Sammeln Sie **{{points_amount}} Punkte** für dieses Produkt.",
                      "non-member-rewards-disclaimer-text": "I agree to the program’s [terms](http://example.net/terms) and [privacy policy](http://example.net/privacy-policy)",
                      "non-member-rewards-join-button-text": "Schließen Sie die Programmanmeldung ab",
                      "show-background-enabled": false,
                      "view-background-color": "#FCEEF1",
                      "view-link-color": "rgba(0,0,0,1)",
                      "view-link-style-underline": true,
                      "view-points-color": "#1C1D21",
                      "view-primary-font": "founders-grotesk-regular@400|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK/founders-grotesk-regular/founders-grotesk-regular-400.css",
                      "view-secondary-font": "founders-grotesk-regular@400|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK/founders-grotesk-regular/founders-grotesk-regular-400.css",
                      "view-text-color": "#1C1D21",
                      "view-text-size": "14px"
                    },
                    staticContent: {
                      "cssEditorEnabled": true,
                      "currency": "PLN",
                      "isHidden": false,
                      "isOptInFlowEnabled": true,
                      "isShopifyNewAccountsVersion": false,
                      "merchantId": "181985",
                      "platformName": "shopify",
                      "storeId": "yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK",
                      "storeLoginUrl": "https://theodderside.com/account/login"
                    },
                    className: "ProductPoints",
                    dependencyGroupId: null
                },
            
                "1141265": {
                    instanceId: "1141265",
                    instanceVersionId: "347404899",
                    templateAssetUrl: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widget-product-points/app.v0.3.26-7158.js",
                    cssOverrideAssetUrl: "https://cdn-widget-assets.yotpo.com/ProductPoints/pc-_zsvJHOoRaZ3ebWa_rg/css-overrides/css-overrides.2025_06_03_11_47_46_923.css",
                    customizationCssUrl: "",
                    customizations: {
                      "icon-color": "#1C1D21",
                      "icon-type": "customIcon",
                      "icon-url": "https://cdn-widget-assets.yotpo.com/static_assets/pc-_zsvJHOoRaZ3ebWa_rg/images/image_2025_06_03_11_35_27_650",
                      "logged-in-non-member-confirmation-text": "Vous êtes désormais membre de notre programme de récompenses !",
                      "logged-in-non-member-popover-background-color": "#FFFFFF",
                      "logged-in-non-member-popover-button-color": "rgba(0,0,0,1)",
                      "logged-in-non-member-popover-button-style": 2,
                      "logged-in-non-member-popover-button-text-color": "#FFFFFF",
                      "logged-in-non-member-popover-disclaimer-text-size": "8px",
                      "logged-in-non-member-popover-text-color": "#000000",
                      "logged-in-non-member-popover-title-text": "Vous êtes à un pas des récompenses !",
                      "logged-in-non-member-popover-title-text-size": "16px",
                      "logged-in-non-member-text": "Gagnez **{{points_amount}} shells** pour ce produit. ",
                      "logged-in-text": "Gagnez **{{points_amount}} shells** pour ce produit. ",
                      "logged-out-text": "Gagnez **{{points_amount}} shells** pour ce produit. ",
                      "non-member-rewards-disclaimer-text": "I agree to the program’s [terms](http://example.net/terms) and [privacy policy](http://example.net/privacy-policy)",
                      "non-member-rewards-join-button-text": "Inscription complète au programme",
                      "show-background-enabled": false,
                      "view-background-color": "#FCEEF1",
                      "view-link-color": "rgba(0,0,0,1)",
                      "view-link-style-underline": true,
                      "view-points-color": "#1C1D21",
                      "view-primary-font": "founders-grotesk-regular@400|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK/founders-grotesk-regular/founders-grotesk-regular-400.css",
                      "view-secondary-font": "founders-grotesk-regular@400|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK/founders-grotesk-regular/founders-grotesk-regular-400.css",
                      "view-text-color": "#1C1D21",
                      "view-text-size": "14px"
                    },
                    staticContent: {
                      "cssEditorEnabled": true,
                      "currency": "PLN",
                      "isHidden": false,
                      "isOptInFlowEnabled": true,
                      "isShopifyNewAccountsVersion": false,
                      "merchantId": "181985",
                      "platformName": "shopify",
                      "storeId": "yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK",
                      "storeLoginUrl": "https://theodderside.com/account/login"
                    },
                    className: "ProductPoints",
                    dependencyGroupId: null
                },
            
                "1141264": {
                    instanceId: "1141264",
                    instanceVersionId: "347404898",
                    templateAssetUrl: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widget-product-points/app.v0.3.26-7158.js",
                    cssOverrideAssetUrl: "https://cdn-widget-assets.yotpo.com/ProductPoints/pc-_zsvJHOoRaZ3ebWa_rg/css-overrides/css-overrides.2025_06_03_11_47_28_588.css",
                    customizationCssUrl: "",
                    customizations: {
                      "icon-color": "#1C1D21",
                      "icon-type": "customIcon",
                      "icon-url": "https://cdn-widget-assets.yotpo.com/static_assets/pc-_zsvJHOoRaZ3ebWa_rg/images/image_2025_06_03_11_33_57_411",
                      "logged-in-non-member-confirmation-text": "You’re now a member of our rewards program!",
                      "logged-in-non-member-popover-background-color": "#FFFFFF",
                      "logged-in-non-member-popover-button-color": "rgba(0,0,0,1)",
                      "logged-in-non-member-popover-button-style": 2,
                      "logged-in-non-member-popover-button-text-color": "#FFFFFF",
                      "logged-in-non-member-popover-disclaimer-text-size": "8px",
                      "logged-in-non-member-popover-text-color": "#000000",
                      "logged-in-non-member-popover-title-text": "You’re a step away from rewards!",
                      "logged-in-non-member-popover-title-text-size": "16px",
                      "logged-in-non-member-text": "Earn **{{points_amount}} shells** for this product.",
                      "logged-in-text": "Earn **{{points_amount}} shells** for this product.",
                      "logged-out-text": "Earn **{{points_amount}} shells** for this product.",
                      "non-member-rewards-disclaimer-text": "I agree to the program’s [terms](http://example.net/terms) and [privacy policy](http://example.net/privacy-policy)",
                      "non-member-rewards-join-button-text": "Complete program signup",
                      "show-background-enabled": false,
                      "view-background-color": "#FCEEF1",
                      "view-link-color": "rgba(0,0,0,1)",
                      "view-link-style-underline": true,
                      "view-points-color": "#1C1D21",
                      "view-primary-font": "founders-grotesk-regular@400|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK/founders-grotesk-regular/founders-grotesk-regular-400.css",
                      "view-secondary-font": "founders-grotesk-regular@400|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK/founders-grotesk-regular/founders-grotesk-regular-400.css",
                      "view-text-color": "#1C1D21",
                      "view-text-size": "14px"
                    },
                    staticContent: {
                      "cssEditorEnabled": true,
                      "currency": "PLN",
                      "isHidden": false,
                      "isOptInFlowEnabled": true,
                      "isShopifyNewAccountsVersion": false,
                      "merchantId": "181985",
                      "platformName": "shopify",
                      "storeId": "yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK",
                      "storeLoginUrl": "https://theodderside.com/account/login"
                    },
                    className: "ProductPoints",
                    dependencyGroupId: null
                },
            
                "1090279": {
                    instanceId: "1090279",
                    instanceVersionId: "349833743",
                    templateAssetUrl: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widget-product-points/app.v0.3.26-7158.js",
                    cssOverrideAssetUrl: "https://cdn-widget-assets.yotpo.com/ProductPoints/pc-_zsvJHOoRaZ3ebWa_rg/css-overrides/css-overrides.2025_06_03_11_47_10_783.css",
                    customizationCssUrl: "",
                    customizations: {
                      "icon-color": "rgba(43,42,165,1)",
                      "icon-type": "customIcon",
                      "icon-url": "https://cdn-widget-assets.yotpo.com/static_assets/pc-_zsvJHOoRaZ3ebWa_rg/images/image_2025_05_13_13_48_10_330",
                      "logged-in-non-member-confirmation-text": "Vous êtes désormais membre de notre programme de récompenses !",
                      "logged-in-non-member-popover-background-color": "#FFFFFF",
                      "logged-in-non-member-popover-button-color": "rgba(0,0,0,1)",
                      "logged-in-non-member-popover-button-style": 2,
                      "logged-in-non-member-popover-button-text-color": "#FFFFFF",
                      "logged-in-non-member-popover-disclaimer-text-size": "8px",
                      "logged-in-non-member-popover-text-color": "#000000",
                      "logged-in-non-member-popover-title-text": "Vous êtes à un pas des récompenses !",
                      "logged-in-non-member-popover-title-text-size": "16px",
                      "logged-in-non-member-text": "Zdobądź **{{points_amount}} shells** za ten produkt.",
                      "logged-in-text": "Zdobądź **{{points_amount}} shells** dla tego produktu.",
                      "logged-out-text": "Zdobądź **{{points_amount}} shells** za ten produkt.",
                      "non-member-rewards-disclaimer-text": "I agree to the program’s [terms](http://example.net/terms) and [privacy policy](http://example.net/privacy-policy)",
                      "non-member-rewards-disclaimer-type": "no-disclaimer",
                      "non-member-rewards-join-button-text": "Inscription complète au programme",
                      "show-background-enabled": false,
                      "view-background-color": "#FCEEF1",
                      "view-link-color": "rgba(0,0,0,1)",
                      "view-link-style-underline": true,
                      "view-points-color": "rgba(43,42,165,1)",
                      "view-primary-font": "founders-grotesk-regular@400|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK/founders-grotesk-regular/founders-grotesk-regular-400.css",
                      "view-secondary-font": "founders-grotesk-regular@400|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK/founders-grotesk-regular/founders-grotesk-regular-400.css",
                      "view-text-color": "rgba(43,42,165,1)",
                      "view-text-size": "14px"
                    },
                    staticContent: {
                      "cssEditorEnabled": true,
                      "currency": "PLN",
                      "isHidden": false,
                      "isOptInFlowEnabled": true,
                      "isShopifyNewAccountsVersion": false,
                      "merchantId": "181985",
                      "platformName": "shopify",
                      "storeId": "yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK",
                      "storeLoginUrl": "https://theodderside.com/account/login"
                    },
                    className: "ProductPoints",
                    dependencyGroupId: null
                },
            
                "1056904": {
                    instanceId: "1056904",
                    instanceVersionId: "327451063",
                    templateAssetUrl: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widget-visual-redemption/app.v1.1.3-6746.js",
                    cssOverrideAssetUrl: "https://cdn-widget-assets.yotpo.com/VisualRedemptionWidget/pc-_zsvJHOoRaZ3ebWa_rg/css-overrides/css-overrides.2025_03_11_03_14_08_617.css",
                    customizationCssUrl: "",
                    customizations: {
                      "description-color": "rgba(43,42,165,1)",
                      "description-font-size": 14,
                      "headline-color": "rgba(43,42,165,1)",
                      "headline-font-size": 40,
                      "layout-add-background": "true",
                      "layout-background-color": "rgba(254,253,249,1)",
                      "primary-font-name-and-url": "founders-grotesk-regular@400|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK/founders-grotesk-regular/founders-grotesk-regular-400.css",
                      "redemption-1-displayname": "Tile 1",
                      "redemption-1-settings-cost": "x 500",
                      "redemption-1-settings-cost-color": "rgba(43,42,165,1)",
                      "redemption-1-settings-cost-font-size": 20,
                      "redemption-1-settings-frame-color": "rgba(0,0,0,0)",
                      "redemption-1-settings-reward": "20 PLN OFF",
                      "redemption-1-settings-reward-color": "rgba(43,42,165,1)",
                      "redemption-1-settings-reward-font-size": 55,
                      "redemption-2-displayname": "Tile 2",
                      "redemption-2-settings-cost": "x 1000",
                      "redemption-2-settings-cost-color": "rgba(43,42,165,1)",
                      "redemption-2-settings-cost-font-size": 20,
                      "redemption-2-settings-frame-color": "rgba(0,0,0,0)",
                      "redemption-2-settings-reward": "40 PLN OFF",
                      "redemption-2-settings-reward-color": "rgba(43,42,165,1)",
                      "redemption-2-settings-reward-font-size": 55,
                      "redemption-3-displayname": "Tile 3",
                      "redemption-3-settings-cost": "x 2000",
                      "redemption-3-settings-cost-color": "rgba(43,42,165,1)",
                      "redemption-3-settings-cost-font-size": 20,
                      "redemption-3-settings-frame-color": "rgba(0,0,0,0)",
                      "redemption-3-settings-reward": "80 PLN OFF",
                      "redemption-3-settings-reward-color": "rgba(43,42,165,1)",
                      "redemption-3-settings-reward-font-size": 55,
                      "rule-color": "rgba(43,42,165,1)",
                      "rule-dots-color": "rgba(0,0,0,0)",
                      "rule-font-size": 20,
                      "secondary-font-name-and-url": "founders-grotesk-regular@400|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK/founders-grotesk-regular/founders-grotesk-regular-400.css",
                      "selected-extensions": [
                        "1",
                        "2",
                        "3"
                      ],
                      "view-layout": "full-layout",
                      "visual-redemption-description": "REDEEMING YOUR SHELLS IS EASY! \nJUST CLICK REDEEM MY SHELLS, AND SELECT AN ELIGIBLE REWARD.",
                      "visual-redemption-headline": "HOW TO USE YOUR SHELLS",
                      "visual-redemption-rule": "x 100 EQUALS 1 PLN"
                    },
                    staticContent: {
                      "cssEditorEnabled": true,
                      "currency": "PLN",
                      "isHidden": false,
                      "isMultiCurrencyEnabled": true,
                      "isShopifyNewAccountsVersion": false,
                      "platformName": "shopify",
                      "storeId": "yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK"
                    },
                    className: "VisualRedemptionWidget",
                    dependencyGroupId: 2
                },
            
                "1056903": {
                    instanceId: "1056903",
                    instanceVersionId: "347075640",
                    templateAssetUrl: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widget-referral-share/app.v0.4.24-7079.js",
                    cssOverrideAssetUrl: "https://cdn-widget-assets.yotpo.com/ReferralShareWidget/pc-_zsvJHOoRaZ3ebWa_rg/css-overrides/css-overrides.2025_03_12_00_32_47_060.css",
                    customizationCssUrl: "",
                    customizations: {
                      "background-color": "rgba(0,0,0,0)",
                      "customer-email-view-button-text": "Next",
                      "customer-email-view-description-discount-discount": "Give your friends {{friend_reward}} their first purchase of {{min_spent}}, and get {{customer_reward}} for each successful referral.",
                      "customer-email-view-description-discount-points": "Give your friends {{friend_reward}} their first purchase of {{min_spent}}, and get {{customer_reward}} points for each successful referral.",
                      "customer-email-view-description-nothing-discount": "Get {{customer_reward}} for each successful referral.",
                      "customer-email-view-description-nothing-points": "Get {{customer_reward}} points for each successful referral.",
                      "customer-email-view-description-points-discount": "Give your friends {{friend_reward}} points, and get {{customer_reward}} for each successful referral.",
                      "customer-email-view-description-points-points": "Give your friends {{friend_reward}} points, and get {{customer_reward}} points for each successful referral.",
                      "customer-email-view-header": "Refer a Friend",
                      "customer-email-view-input-placeholder": "Your email address",
                      "customer-email-view-title-discount-discount": "GIVE {{friend_reward}}, GET {{customer_reward}}",
                      "customer-email-view-title-discount-points": "GIVE {{friend_reward}}, GET {{customer_reward}} POINTS",
                      "customer-email-view-title-nothing-discount": "REFER A FRIEND, GET {{customer_reward}} FOR REFERRALS",
                      "customer-email-view-title-nothing-points": "REFER A FRIEND, GET {{customer_reward}} POINTS FOR REFERRALS",
                      "customer-email-view-title-points-discount": "GIVE {{friend_reward}} POINTS, GET {{customer_reward}}",
                      "customer-email-view-title-points-points": "GIVE {{friend_reward}} POINTS, GET {{customer_reward}} POINTS",
                      "customer-name-view-input-placeholder": "Your name",
                      "default-toggle": true,
                      "description-color": "rgba(252,250,238,1)",
                      "description-font-size": "24px",
                      "desktop-background-image-url": "https://cdn-widget-assets.yotpo.com/static_assets/pc-_zsvJHOoRaZ3ebWa_rg/images/image_2025_03_11_04_49_21_356",
                      "disabled-referral-code-error": "Ihr Empfehlungslink scheint deaktiviert worden zu sein.",
                      "email-fill-color": "#F6F1EE",
                      "email-input-type": "rounded_rectangle",
                      "email-outline-color": "#000000",
                      "email-text-color": "#000000",
                      "final-view-button-text": "Empfehlen Sie weitere Freunde",
                      "final-view-description": "Remind your friends to check their email",
                      "final-view-error-description": "Wir konnten den Empfehlungslink nicht freigeben. Gehen Sie zum vorherigen Schritt zurück, um es erneut zu versuchen.",
                      "final-view-error-text": "Zurück",
                      "final-view-error-title": "Etwas ist schief gelaufen",
                      "final-view-title": "Vielen Dank für die Empfehlung!",
                      "fonts-primary-font-name-and-url": "founders-grotesk-regular@400|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK/founders-grotesk-regular/founders-grotesk-regular-400.css",
                      "fonts-secondary-font-name-and-url": "founders-grotesk-regular@400|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK/founders-grotesk-regular/founders-grotesk-regular-400.css",
                      "header-color": "rgba(252,250,238,1)",
                      "header-font-size": "14px",
                      "headline-color": "rgba(43,42,165,1)",
                      "headline-font-size": 40,
                      "login-view-description-discount-discount": "Give your friends {{friend_reward}} their first purchase of {{min_spent}}, and get {{customer_reward}} for each successful referral.",
                      "login-view-description-discount-points": "Give your friends {{friend_reward}} their first purchase of {{min_spent}}, and get {{customer_reward}} points for each successful referral.",
                      "login-view-description-nothing-discount": "Get {{customer_reward}} for each successful referral.",
                      "login-view-description-nothing-points": "DENN JEDE FREUNDSCHAFT BEGINNT MIT EINEM ERSTEN SCHRITT!",
                      "login-view-description-points-discount": "Give your friends {{friend_reward}} points, and get {{customer_reward}} for each successful referral.",
                      "login-view-description-points-points": "Give your friends {{friend_reward}} points, and get {{customer_reward}} points for each successful referral.",
                      "login-view-header": "LADEN SIE IHRE FREUNDE EIN UND VERDIENEN SIE SHELLS",
                      "login-view-log-in-button-text": "EINLOGGEN",
                      "login-view-sign-up-button-text": "JETZT BEITRETEN",
                      "login-view-title-discount-discount": "GIVE {{friend_reward}}, GET {{customer_reward}}",
                      "login-view-title-discount-points": "GIVE {{friend_reward}}, GET {{customer_reward}} POINTS",
                      "login-view-title-nothing-discount": "REFER A FRIEND, GET {{customer_reward}} FOR REFERRALS",
                      "login-view-title-nothing-points": "ERHALTE 500 MUSCHELN",
                      "login-view-title-points-discount": "GIVE {{friend_reward}} POINTS, GET {{customer_reward}}",
                      "login-view-title-points-points": "GIVE {{friend_reward}} POINTS, GET {{customer_reward}} POINTS",
                      "main-share-option-desktop": "main_share_copy_link",
                      "main-share-option-mobile": "main_share_sms",
                      "mobile-background-image-url": "https://cdn-widget-assets.yotpo.com/static_assets/pc-_zsvJHOoRaZ3ebWa_rg/images/image_2025_03_11_04_49_26_424",
                      "more-share-ways-text": "MORE WAYS TO SHARE",
                      "primary-button-background-color": "rgba(43,42,165,1)",
                      "primary-button-font-size": "16px",
                      "primary-button-size": "standard",
                      "primary-button-text-color": "rgba(252,250,238,1)",
                      "primary-button-type": "filled_rectangle",
                      "reduced-picture": true,
                      "referral-history-completed-points-text": "{{points}} POINTS",
                      "referral-history-completed-status-type": "text",
                      "referral-history-confirmed-status": "Completed",
                      "referral-history-pending-status": "Pending",
                      "referral-history-redeem-text": "You can redeem your points for a reward, or apply your reward code at checkout.",
                      "referral-history-sumup-line-points-text": "{{points}} POINTS",
                      "referral-history-sumup-line-text": "Your Rewards",
                      "referral-views-button-text": "Next",
                      "referral-views-copy-link-button-text": "Copy link",
                      "referral-views-description-discount-discount": "Give your friends {{friend_reward}} their first purchase of {{min_spent}}, and get {{customer_reward}} for each successful referral.",
                      "referral-views-description-discount-points": "Give your friends {{friend_reward}} their first purchase of {{min_spent}}, and get {{customer_reward}} points for each successful referral.",
                      "referral-views-description-nothing-discount": "Get {{customer_reward}} for each successful referral.",
                      "referral-views-description-nothing-points": "DENN JEDE FREUNDSCHAFT BEGINNT MIT EINEM ERSTEN SCHRITT!",
                      "referral-views-description-points-discount": "Give your friends {{friend_reward}} points, and get {{customer_reward}} for each successful referral.",
                      "referral-views-description-points-points": "Give your friends {{friend_reward}} points, and get {{customer_reward}} points for each successful referral.",
                      "referral-views-email-share-body": "How does a discount off your first order at {{company_name}} sound? Use the link below and once you've shopped, I'll get a reward too.\n{{referral_link}}",
                      "referral-views-email-share-subject": "Discount to a Store You'll Love!",
                      "referral-views-email-share-type": "personal_email",
                      "referral-views-friends-input-placeholder": "Friend’s email address",
                      "referral-views-header": "LADEN SIE IHRE FREUNDE EIN UND VERDIENEN SIE SHELLS",
                      "referral-views-personal-email-button-text": "Share via email",
                      "referral-views-sms-button-text": "Per SMS teilen",
                      "referral-views-title-discount-discount": "GIVE {{friend_reward}}, GET {{customer_reward}}",
                      "referral-views-title-discount-points": "GIVE {{friend_reward}}, GET {{customer_reward}} POINTS",
                      "referral-views-title-nothing-discount": "REFER A FRIEND, GET {{customer_reward}} FOR REFERRALS",
                      "referral-views-title-nothing-points": "ERHALTE 500 MUSCHELN",
                      "referral-views-title-points-discount": "GIVE {{friend_reward}} POINTS, GET {{customer_reward}}",
                      "referral-views-title-points-points": "GIVE {{friend_reward}} POINTS, GET {{customer_reward}} POINTS",
                      "referral-views-whatsapp-button-text": "Share via WhatsApp",
                      "secondary-button-background-color": "rgba(43,42,165,1)",
                      "secondary-button-text-color": "rgba(252,250,238,1)",
                      "secondary-button-type": "filled_rectangle",
                      "share-allow-copy-link": true,
                      "share-allow-email": true,
                      "share-allow-sms": true,
                      "share-allow-whatsapp": true,
                      "share-headline-text-color": "rgba(252,250,238,1)",
                      "share-icons-color": "rgba(252,250,238,1)",
                      "share-settings-copyLink": true,
                      "share-settings-default-checkbox": true,
                      "share-settings-default-mobile-checkbox": true,
                      "share-settings-email": true,
                      "share-settings-mobile-copyLink": true,
                      "share-settings-mobile-email": true,
                      "share-settings-mobile-sms": true,
                      "share-settings-mobile-whatsapp": true,
                      "share-settings-whatsapp": true,
                      "share-sms-message": "I love {{company_name}}! Shop through my link to get a reward {{referral_link}}",
                      "share-whatsapp-message": "I love {{company_name}}! Shop through my link to get a reward {{referral_link}}",
                      "tab-size": "small",
                      "tab-type": "lower_line",
                      "tab-view-primary-tab-text": "Refer a Friend",
                      "tab-view-secondary-tab-text": "Your Referrals",
                      "tile-color": "rgba(0,0,0,0)",
                      "title-color": "rgba(252,250,238,1)",
                      "title-font-size": "40px",
                      "view-exit-intent-enabled": false,
                      "view-exit-intent-mobile-timeout-ms": 10000,
                      "view-is-popup": false,
                      "view-layout": "centered",
                      "view-popup-delay-ms": 0,
                      "view-show-customer-name": false,
                      "view-show-popup-on-exit": false,
                      "view-show-referral-history": false,
                      "view-table-rectangular-dark-pending-color": "rgba( 0, 0, 0, 0.6 )",
                      "view-table-rectangular-light-pending-color": "#FFFFFF",
                      "view-table-selected-color": "#0F8383",
                      "view-table-theme": "dark",
                      "view-table-type": "lines",
                      "wadmin-text-and-share-choose-sreen": "step_3"
                    },
                    staticContent: {
                      "advocateLoggedInRequirement": true,
                      "advocateRewardType": "POINTS",
                      "companyName": "The Odder Side",
                      "cssEditorEnabled": true,
                      "currency": "PLN",
                      "friendRewardType": "NOTHING",
                      "hasPrimaryFontsFeature": true,
                      "isFreeMerchant": false,
                      "isHidden": false,
                      "isMultiCurrencyEnabled": true,
                      "merchantId": "181985",
                      "migrateTabColorToBackground": true,
                      "platformName": "shopify",
                      "referralHistoryEnabled": true,
                      "referralHost": "http://rwrd.io",
                      "storeId": "yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK"
                    },
                    className: "ReferralShareWidget",
                    dependencyGroupId: null
                },
            
                "1056902": {
                    instanceId: "1056902",
                    instanceVersionId: "327451059",
                    templateAssetUrl: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widget-vip-tiers/app.v2.2.4-6882.js",
                    cssOverrideAssetUrl: "https://cdn-widget-assets.yotpo.com/VipTiersWidget/pc-_zsvJHOoRaZ3ebWa_rg/css-overrides/css-overrides.2025_03_12_13_18_03_502.css",
                    customizationCssUrl: "",
                    customizations: {
                      "background-color": "rgba(254,253,249,1)",
                      "background-enabled": "true",
                      "benefits-font-size": "14px",
                      "benefits-icon-color": "#89BABA",
                      "benefits-icon-type": "custom",
                      "benefits-icon-url": "https://cdn-widget-assets.yotpo.com/static_assets/pc-_zsvJHOoRaZ3ebWa_rg/images/image_2025_03_11_03_18_04_364",
                      "benefits-text-color": "rgba(43,42,165,1)",
                      "card-background-border-color": "rgba(0,0,0,0)",
                      "card-background-color": "rgba(252,250,238,1)",
                      "card-background-shadow": "false",
                      "card-separator-color": "#BCBCBC",
                      "card-separator-enabled": "false",
                      "current-status-bg-color": "rgba(252,250,238,1)",
                      "current-status-tag": "true",
                      "current-status-text": "IHR AKTUELLER STATUS",
                      "current-status-text-color": "rgba(43,42,165,1)",
                      "current-tier-border-color": "rgba(0,0,0,0)",
                      "grid-lines-color": "#ACB5D4",
                      "headline-color": "rgba(43,42,165,1)",
                      "headline-font-size": 120,
                      "headline-text-color": "rgba(43,42,165,1)",
                      "layout": "card",
                      "primary-font-name-and-url": "founders-grotesk-regular@400|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK/founders-grotesk-regular/founders-grotesk-regular-400.css",
                      "progress-bar-current-status": "{{amount_spent}} Ausgegeben",
                      "progress-bar-enabled": "true",
                      "progress-bar-headline-font-size": "14px",
                      "progress-bar-primary-color": "rgba(43,42,165,1)",
                      "progress-bar-secondary-color": "rgba(43,42,165,1)",
                      "progress-bar-summary-current": "Sie haben {{current_vip_tier_name}} bis zum nächsten Verdienstzeitraum.",
                      "progress-bar-summary-font-size": "14px",
                      "progress-bar-summary-maintain": "Geben Sie {{spend_needed}} bis {{tier_expiration_date}} aus, um {{current_vip_tier_name}} beizubehalten",
                      "progress-bar-summary-next": "Geben Sie {{spend_needed}} aus, um {{next_vip_tier_name}} freizuschalten.",
                      "progress-bar-tier-status": "Tier status",
                      "progress-bar-you": "DU",
                      "secondary-font-name-and-url": "founders-grotesk-regular@400|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK/founders-grotesk-regular/founders-grotesk-regular-400.css",
                      "selected-extensions": [
                        "30768",
                        "30769",
                        "30770",
                        "30846"
                      ],
                      "show-less-text": "- Weniger sehen",
                      "show-more-text": "+ Mehr sehen",
                      "tier-spacing": "small",
                      "tiers-30768-design-header-bg-color": "#FFFFFF",
                      "tiers-30768-design-icon-fill-color": "#0F8383",
                      "tiers-30768-design-icon-type": "custom",
                      "tiers-30768-design-icon-url": "https://cdn-widget-assets.yotpo.com/static_assets/pc-_zsvJHOoRaZ3ebWa_rg/images/image_2025_03_11_04_16_57_463",
                      "tiers-30768-design-include-header-bg": "false",
                      "tiers-30768-design-name-font-size": "24px",
                      "tiers-30768-design-name-text-color": "rgba(43,42,165,1)",
                      "tiers-30768-design-threshold-font-size": "14px",
                      "tiers-30768-design-threshold-text-color": "rgba(43,42,165,1)",
                      "tiers-30768-text-benefits": "GEBURTSTAGSGESCHENK||VERDIENE MULDEN MIT JEDEM EINKAUF",
                      "tiers-30768-text-name": "NEUER FREUND",
                      "tiers-30768-text-rank": 1,
                      "tiers-30768-text-threshold": "VERBINDEN",
                      "tiers-30769-design-header-bg-color": "#FFFFFF",
                      "tiers-30769-design-icon-fill-color": "#0F8383",
                      "tiers-30769-design-icon-type": "custom",
                      "tiers-30769-design-icon-url": "https://cdn-widget-assets.yotpo.com/static_assets/pc-_zsvJHOoRaZ3ebWa_rg/images/image_2025_03_11_04_17_26_894",
                      "tiers-30769-design-include-header-bg": "false",
                      "tiers-30769-design-name-font-size": "24px",
                      "tiers-30769-design-name-text-color": "rgba(43,42,165,1)",
                      "tiers-30769-design-threshold-font-size": "14px",
                      "tiers-30769-design-threshold-text-color": "rgba(43,42,165,1)",
                      "tiers-30769-text-benefits": "BESONDERES GEBURTSTAGSGESCHENK FÜR DEN GESCHENKKREIS||VERDIENEN SIE MEHR SHELLS PRO AUSGABE||STUFENEINSTIEGSGESCHENK: 500 SHELLS",
                      "tiers-30769-text-name": "KREIS SCHLIESSEN",
                      "tiers-30769-text-rank": 2,
                      "tiers-30769-text-threshold": "AUSGEBEN {{amount_spent}}",
                      "tiers-30770-design-header-bg-color": "#FFFFFF",
                      "tiers-30770-design-icon-fill-color": "#0F8383",
                      "tiers-30770-design-icon-type": "custom",
                      "tiers-30770-design-icon-url": "https://cdn-widget-assets.yotpo.com/static_assets/pc-_zsvJHOoRaZ3ebWa_rg/images/image_2025_03_11_04_18_12_525",
                      "tiers-30770-design-include-header-bg": "false",
                      "tiers-30770-design-name-font-size": "24px",
                      "tiers-30770-design-name-text-color": "rgba(43,42,165,1)",
                      "tiers-30770-design-threshold-font-size": "14px",
                      "tiers-30770-design-threshold-text-color": "rgba(43,42,165,1)",
                      "tiers-30770-text-benefits": "EXKLUSIVER PARTNER IN DER KRIMINALITÄT||GEBURTSTAGSGESCHENK||NOCH MEHR SHELLS PRO AUSGABE||STUFENEINSTIEGSGESCHENK: 1.000 SHELLS||KOSTENLOS STANDARDVERSAND||FRÜHER ZUGRIFF AUF NEUE KOLLEKTIONEN||PUNKTEMULTIPLIKATOR X1,25",
                      "tiers-30770-text-name": "PARTNER IN DER VERBRECHENSWEISE",
                      "tiers-30770-text-rank": 3,
                      "tiers-30770-text-threshold": "AUSGEBEN {{amount_spent}}",
                      "tiers-30846-design-header-bg-color": "#FFFFFF",
                      "tiers-30846-design-icon-fill-color": "#0F8383",
                      "tiers-30846-design-icon-type": "custom",
                      "tiers-30846-design-icon-url": "https://cdn-widget-assets.yotpo.com/static_assets/pc-_zsvJHOoRaZ3ebWa_rg/images/image_2025_03_11_04_18_48_624",
                      "tiers-30846-design-include-header-bg": "false",
                      "tiers-30846-design-name-font-size": "24px",
                      "tiers-30846-design-name-text-color": "rgba(43,42,165,1)",
                      "tiers-30846-design-threshold-font-size": "14px",
                      "tiers-30846-design-threshold-text-color": "rgba(43,42,165,1)",
                      "tiers-30846-text-benefits": "DAS ULTIMATIVE GEBURTSTAGSGESCHENK FÜR DIE BESTEN FREUNDE||MAXIMALE MUSCHELN PRO AUSGABE||STUFENEINSTIEGSGESCHENK: 3.000 SHELLS||KOSTENLOSER EXPRESSVERSAND||FRÜHER ZUGANG ZU DEN NEUEN KOLLEKTIONEN||EINLADUNGEN ZU VIP-EVENTS||PUNKTEMULTIPLIKATOR X1,5",
                      "tiers-30846-text-name": "BESTE",
                      "tiers-30846-text-rank": 4,
                      "tiers-30846-text-threshold": "AUSGEBEN {{amount_spent}}",
                      "widget-headline": "BESTIES VERDIENEN NOCH MEHR"
                    },
                    staticContent: {
                      "cssEditorEnabled": true,
                      "currency": "PLN",
                      "isHidden": false,
                      "isMultiCurrencyEnabled": true,
                      "merchantId": "181985",
                      "platformName": "shopify",
                      "storeId": "yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK"
                    },
                    className: "VipTiersWidget",
                    dependencyGroupId: 2
                },
            
                "1056901": {
                    instanceId: "1056901",
                    instanceVersionId: "327451070",
                    templateAssetUrl: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widget-coupons-redemption/app.v1.1.13-7015.js",
                    cssOverrideAssetUrl: "https://cdn-widget-assets.yotpo.com/CouponsRedemptionWidget/pc-_zsvJHOoRaZ3ebWa_rg/css-overrides/css-overrides.2025_03_12_05_30_43_654.css",
                    customizationCssUrl: "",
                    customizations: {
                      "confirmation-step-cancel-option": "No",
                      "confirmation-step-confirm-option": "Yes",
                      "confirmation-step-title": "Are you sure?",
                      "coupon-background-type": "no-background",
                      "coupon-code-copied-message-body": "Thank you for redeeming your points. Please paste the code at checkout",
                      "coupon-code-copied-message-color": "#707997",
                      "coupon-code-copied-message-title": "",
                      "coupons-redemption-description": "Das Einlösen deiner Shells ist ganz einfach!\nKlicke einfach auf „Meine Shells einlösen“ und wähle eine gültige Belohnung aus.",
                      "coupons-redemption-headline": "SO VERWENDEN SIE IHRE SCHALEN",
                      "coupons-redemption-rule": "x 100 GLEICH {{1_local_currency}}",
                      "description-color": "rgba(43,42,165,1)",
                      "description-font-size": 14,
                      "discount-bigger-than-subscription-cost-text": "Your next subscription is lower than the redemption amount",
                      "donate-button-text": "Donate",
                      "donation-success-message-body": "Thank you for donating ${{donation_amount}} to {{company_name}}",
                      "donation-success-message-color": "#707997",
                      "donation-success-message-title": "Success",
                      "error-message-color": "#f04860",
                      "error-message-title": "",
                      "headline-color": "rgba(43,42,165,1)",
                      "headline-font-size": 40,
                      "layout-add-background": "true",
                      "layout-background-color": "rgba(254,253,249,1)",
                      "local-enable-opt-in-flow": false,
                      "local-member-optin-disclaimer": "Add a disclaimer and button asking non-members to join your program.",
                      "local-member-optin-disclaimer-part2": "To customize them, go to \u003cb\u003ePage Settings.\u003c/b\u003e",
                      "login-button-color": "rgba(43,42,165,1)",
                      "login-button-text": "Redeem my points",
                      "login-button-text-color": "white",
                      "login-button-type": "filled_rectangle",
                      "message-font-size": "14",
                      "missing-points-amount-text": "You don't have enough points to redeem",
                      "next-subscription-headline-text": "NEXT ORDER",
                      "next-subscription-subtitle-text": "{{product_name}} {{next_order_amount}}",
                      "no-subscription-subtitle-text": "No ongoing subscriptions",
                      "point-balance-text": "Du hast {{current_point_balance}} Muscheln",
                      "points-balance-color": "rgba(43,42,165,1)",
                      "points-balance-font-size": 20,
                      "points-balance-number-color": "rgba(43,42,165,1)",
                      "primary-font-name-and-url": "founders-grotesk-regular@400|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK/founders-grotesk-regular/founders-grotesk-regular-400.css",
                      "redeem-button-color": "#0F8383",
                      "redeem-button-text": "Redeem",
                      "redeem-button-text-color": "#FFFFFF",
                      "redeem-button-type": "rounded_filled_rectangle",
                      "redeem-frame-color": "#BCBCBC",
                      "redemption-942586-displayname": "20 zł off",
                      "redemption-942586-settings-button-color": "rgba(43,42,165,1)",
                      "redemption-942586-settings-button-text": "LÖSE MEINE MUSCHELN EIN",
                      "redemption-942586-settings-button-text-color": "#FFFFFF",
                      "redemption-942586-settings-button-type": "filled_rectangle",
                      "redemption-942586-settings-call-to-action-button-text": "Redeem",
                      "redemption-942586-settings-cost": 500,
                      "redemption-942586-settings-cost-color": "rgba(43,42,165,1)",
                      "redemption-942586-settings-cost-font-size": 20,
                      "redemption-942586-settings-cost-text": "x {{points}}",
                      "redemption-942586-settings-coupon-cost-font-size": "15",
                      "redemption-942586-settings-coupon-reward-font-size": "20",
                      "redemption-942586-settings-discount-amount-cents": 2000,
                      "redemption-942586-settings-discount-type": "fixed_amount",
                      "redemption-942586-settings-frame-color": "rgba(0,0,0,0)",
                      "redemption-942586-settings-reward": "{{20_local_currency}}",
                      "redemption-942586-settings-reward-color": "rgba(43,42,165,1)",
                      "redemption-942586-settings-reward-font-size": 55,
                      "redemption-942586-settings-success-message-text": "Reward Applied",
                      "redemption-942587-displayname": "40 zł off",
                      "redemption-942587-settings-button-color": "rgba(43,42,165,1)",
                      "redemption-942587-settings-button-text": "LÖSE MEINE MUSCHELN EIN",
                      "redemption-942587-settings-button-text-color": "#FFFFFF",
                      "redemption-942587-settings-button-type": "filled_rectangle",
                      "redemption-942587-settings-call-to-action-button-text": "Redeem",
                      "redemption-942587-settings-cost": 1000,
                      "redemption-942587-settings-cost-color": "rgba(43,42,165,1)",
                      "redemption-942587-settings-cost-font-size": 20,
                      "redemption-942587-settings-cost-text": "x {{points}}",
                      "redemption-942587-settings-coupon-cost-font-size": "15",
                      "redemption-942587-settings-coupon-reward-font-size": "20",
                      "redemption-942587-settings-discount-amount-cents": 4000,
                      "redemption-942587-settings-discount-type": "fixed_amount",
                      "redemption-942587-settings-frame-color": "rgba(0,0,0,0)",
                      "redemption-942587-settings-reward": "{{40_local_currency}}",
                      "redemption-942587-settings-reward-color": "rgba(43,42,165,1)",
                      "redemption-942587-settings-reward-font-size": 55,
                      "redemption-942587-settings-success-message-text": "Reward Applied",
                      "redemption-944048-displayname": "80 zł off",
                      "redemption-944048-settings-button-color": "rgba(43,42,165,1)",
                      "redemption-944048-settings-button-text": "LÖSE MEINE MUSCHELN EIN",
                      "redemption-944048-settings-button-text-color": "#FFFFFF",
                      "redemption-944048-settings-button-type": "filled_rectangle",
                      "redemption-944048-settings-call-to-action-button-text": "Redeem",
                      "redemption-944048-settings-cost": "2000",
                      "redemption-944048-settings-cost-color": "rgba(43,42,165,1)",
                      "redemption-944048-settings-cost-font-size": 20,
                      "redemption-944048-settings-cost-text": "x {{points}}",
                      "redemption-944048-settings-coupon-cost-font-size": "15",
                      "redemption-944048-settings-coupon-reward-font-size": "20",
                      "redemption-944048-settings-discount-amount-cents": "8000",
                      "redemption-944048-settings-discount-type": "fixed_amount",
                      "redemption-944048-settings-frame-color": "rgba(0,0,0,0)",
                      "redemption-944048-settings-reward": "{{80_local_currency}}",
                      "redemption-944048-settings-reward-color": "rgba(43,42,165,1)",
                      "redemption-944048-settings-reward-font-size": 55,
                      "redemption-944048-settings-success-message-text": "Reward Applied",
                      "reward-opt-in-join-now-button-label": "Complete program signup",
                      "rewards-disclaimer-text": "I agree to the program’s [terms](http://example.net/terms) and [privacy policy](http://example.net/privacy-policy)",
                      "rewards-disclaimer-text-color": "#00000",
                      "rewards-disclaimer-text-size": "12px",
                      "rewards-disclaimer-type": "no-disclaimer",
                      "rule-color": "rgba(43,42,165,1)",
                      "rule-dots-color": "rgba(0,0,0,0)",
                      "rule-font-size": 20,
                      "secondary-font-name-and-url": "founders-grotesk-regular@400|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK/founders-grotesk-regular/founders-grotesk-regular-400.css",
                      "selected-extensions": [
                        "942586",
                        "942587",
                        "944048"
                      ],
                      "selected-redemptions-modes": "regular",
                      "subscription-coupon-applied-message-body": "The discount was applied to your upcoming subscription order. You’ll be able to get another discount once the next order is processed.",
                      "subscription-coupon-applied-message-color": "#707997",
                      "subscription-coupon-applied-message-title": "",
                      "subscription-divider-color": "#c2cdf4",
                      "subscription-headline-color": "#666d8b",
                      "subscription-headline-font-size": "14",
                      "subscription-points-headline-text": "YOUR POINT BALANCE",
                      "subscription-points-subtitle-text": "{{current_point_balance}} Points",
                      "subscription-redemptions-description": "Choose a discount option that will automatically apply to your next subscription order.",
                      "subscription-redemptions-headline": "Redeem for Subscription Discount",
                      "subscription-subtitle-color": "#768cdc",
                      "subscription-subtitle-font-size": "20",
                      "undefined": "Only for brands using Shopify’s new customer accounts and have program eligibility set to “only members who signed up.”",
                      "view-layout": "full-layout"
                    },
                    staticContent: {
                      "cssEditorEnabled": true,
                      "currency": "PLN",
                      "isHidden": false,
                      "isMultiCurrencyEnabled": true,
                      "isOptInFlowEnabled": false,
                      "isShopifyNewAccountsVersion": false,
                      "merchantId": "181985",
                      "platformName": "shopify",
                      "storeId": "yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK",
                      "storeLoginUrl": "/account/login",
                      "subunitsPerUnit": 100
                    },
                    className: "CouponsRedemptionWidget",
                    dependencyGroupId: 2
                },
            
                "1056900": {
                    instanceId: "1056900",
                    instanceVersionId: "347075646",
                    templateAssetUrl: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widget-loyalty-campaigns/app.v1.2.5-6990.js",
                    cssOverrideAssetUrl: "https://cdn-widget-assets.yotpo.com/CampaignWidget/pc-_zsvJHOoRaZ3ebWa_rg/css-overrides/css-overrides.2025_03_12_02_37_48_399.css",
                    customizationCssUrl: "",
                    customizations: {
                      "campaign-description-font-color": "#6C6C6C",
                      "campaign-description-size": "16px",
                      "campaign-item-1436740-background-color": "rgba(252,250,238,1)",
                      "campaign-item-1436740-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-1436740-background-type": "color",
                      "campaign-item-1436740-border-color": "rgba(0,0,0,0)",
                      "campaign-item-1436740-description-font-color": "rgba(43,42,165,1)",
                      "campaign-item-1436740-description-font-size": 14,
                      "campaign-item-1436740-exclude_audience_names": [],
                      "campaign-item-1436740-hover-view-tile-message": "Earn 1 point for every {{1_local_currency}} spent",
                      "campaign-item-1436740-icon-color": "#60a3a3",
                      "campaign-item-1436740-icon-type": "customIcon",
                      "campaign-item-1436740-icon-url": "https://cdn-widget-assets.yotpo.com/static_assets/pc-_zsvJHOoRaZ3ebWa_rg/images/image_2025_03_11_02_49_37_052",
                      "campaign-item-1436740-include_audience_ids": "1",
                      "campaign-item-1436740-include_audience_names": [
                        "All customers"
                      ],
                      "campaign-item-1436740-special-reward-enabled": "false",
                      "campaign-item-1436740-special-reward-headline-background-color": "#D2E3E3",
                      "campaign-item-1436740-special-reward-headline-text": "Just for you!",
                      "campaign-item-1436740-special-reward-headline-title-font-color": "#000000",
                      "campaign-item-1436740-special-reward-headline-title-font-size": "12",
                      "campaign-item-1436740-special-reward-tile-border-color": "#000000",
                      "campaign-item-1436740-tile-description": "FÜR JEDEN AUSGEGEBENEN {{1_local_currency}}",
                      "campaign-item-1436740-tile-reward": "1 Schale",
                      "campaign-item-1436740-title-font-color": "rgba(43,42,165,1)",
                      "campaign-item-1436740-title-font-size": 26,
                      "campaign-item-1436740-type": "PointsForPurchasesCampaign",
                      "campaign-item-1462605-action-tile-ask-year": "true",
                      "campaign-item-1462605-action-tile-birthday-required-field-message": "This field is required",
                      "campaign-item-1462605-action-tile-birthday-thank-you-message": "Thanks! We're looking forward to helping you celebrate :)",
                      "campaign-item-1462605-action-tile-european-date-format": "true",
                      "campaign-item-1462605-action-tile-message-text": "If your birthday is within the next 30 days, your reward will be granted in delay, up to 30 days.",
                      "campaign-item-1462605-action-tile-month-names": "January,February,March,April,May,June,July,August,September,October,November,December",
                      "campaign-item-1462605-action-tile-title": "Earn 500 points on your birthday",
                      "campaign-item-1462605-background-color": "rgba(252,250,238,1)",
                      "campaign-item-1462605-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-1462605-background-type": "color",
                      "campaign-item-1462605-border-color": "rgba(0,0,0,0)",
                      "campaign-item-1462605-description-font-color": "rgba(43,42,165,1)",
                      "campaign-item-1462605-description-font-size": 14,
                      "campaign-item-1462605-exclude_audience_names": [],
                      "campaign-item-1462605-icon-color": "#60a3a3",
                      "campaign-item-1462605-icon-type": "customIcon",
                      "campaign-item-1462605-icon-url": "https://cdn-widget-assets.yotpo.com/static_assets/pc-_zsvJHOoRaZ3ebWa_rg/images/image_2025_03_11_02_52_50_057",
                      "campaign-item-1462605-include_audience_ids": "1",
                      "campaign-item-1462605-include_audience_names": [
                        "All customers"
                      ],
                      "campaign-item-1462605-special-reward-enabled": "false",
                      "campaign-item-1462605-special-reward-headline-background-color": "#D2E3E3",
                      "campaign-item-1462605-special-reward-headline-text": "Just for you!",
                      "campaign-item-1462605-special-reward-headline-title-font-color": "#000000",
                      "campaign-item-1462605-special-reward-headline-title-font-size": "12",
                      "campaign-item-1462605-special-reward-tile-border-color": "#000000",
                      "campaign-item-1462605-tile-description": "GEBURTSTAGSBELOHNUNG",
                      "campaign-item-1462605-tile-reward": "200 Muscheln",
                      "campaign-item-1462605-title-font-color": "rgba(43,42,165,1)",
                      "campaign-item-1462605-title-font-size": 26,
                      "campaign-item-1462605-type": "BirthdayCampaign",
                      "campaign-item-1466325-action-tile-action-text": "@the_odderside",
                      "campaign-item-1466325-action-tile-title": "Verdienen Sie 20 Punkte, wenn Sie uns auf Instagram folgen",
                      "campaign-item-1466325-background-color": "rgba(252,250,238,1)",
                      "campaign-item-1466325-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-1466325-background-type": "color",
                      "campaign-item-1466325-border-color": "rgba(0,0,0,0)",
                      "campaign-item-1466325-description-font-color": "rgba(43,42,165,1)",
                      "campaign-item-1466325-description-font-size": 14,
                      "campaign-item-1466325-exclude_audience_names": [],
                      "campaign-item-1466325-icon-color": "#60a3a3",
                      "campaign-item-1466325-icon-type": "customIcon",
                      "campaign-item-1466325-icon-url": "https://cdn-widget-assets.yotpo.com/static_assets/pc-_zsvJHOoRaZ3ebWa_rg/images/image_2025_03_11_02_53_55_706",
                      "campaign-item-1466325-include_audience_ids": "1",
                      "campaign-item-1466325-include_audience_names": [
                        "All customers"
                      ],
                      "campaign-item-1466325-special-reward-enabled": "false",
                      "campaign-item-1466325-special-reward-headline-background-color": "#D2E3E3",
                      "campaign-item-1466325-special-reward-headline-text": "Just for you!",
                      "campaign-item-1466325-special-reward-headline-title-font-color": "#000000",
                      "campaign-item-1466325-special-reward-headline-title-font-size": "12",
                      "campaign-item-1466325-special-reward-tile-border-color": "#000000",
                      "campaign-item-1466325-tile-description": "INSTAGRAM FOLGEN",
                      "campaign-item-1466325-tile-reward": "20 Muscheln",
                      "campaign-item-1466325-title-font-color": "rgba(43,42,165,1)",
                      "campaign-item-1466325-title-font-size": 26,
                      "campaign-item-1466325-type": "InstagramFollowCampaign",
                      "campaign-item-1466686-action-tile-action-text": "Seite besuchen",
                      "campaign-item-1466686-action-tile-title": "Verdienen Sie 20 Punkte, wenn Sie unsere Seite besuchen",
                      "campaign-item-1466686-background-color": "rgba(252,250,238,1)",
                      "campaign-item-1466686-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-1466686-background-type": "color",
                      "campaign-item-1466686-border-color": "rgba(0,0,0,0)",
                      "campaign-item-1466686-description-font-color": "rgba(43,42,165,1)",
                      "campaign-item-1466686-description-font-size": 14,
                      "campaign-item-1466686-exclude_audience_names": [],
                      "campaign-item-1466686-icon-color": "#60a3a3",
                      "campaign-item-1466686-icon-type": "customIcon",
                      "campaign-item-1466686-icon-url": "https://cdn-widget-assets.yotpo.com/static_assets/pc-_zsvJHOoRaZ3ebWa_rg/images/image_2025_03_11_02_53_30_141",
                      "campaign-item-1466686-include_audience_ids": "1",
                      "campaign-item-1466686-include_audience_names": [
                        "All customers"
                      ],
                      "campaign-item-1466686-special-reward-enabled": "false",
                      "campaign-item-1466686-special-reward-headline-background-color": "#D2E3E3",
                      "campaign-item-1466686-special-reward-headline-text": "Just for you!",
                      "campaign-item-1466686-special-reward-headline-title-font-color": "#000000",
                      "campaign-item-1466686-special-reward-headline-title-font-size": "12",
                      "campaign-item-1466686-special-reward-tile-border-color": "#000000",
                      "campaign-item-1466686-tile-description": "TIKTOK FOLGEN",
                      "campaign-item-1466686-tile-reward": "600 Granaten",
                      "campaign-item-1466686-title-font-color": "rgba(43,42,165,1)",
                      "campaign-item-1466686-title-font-size": 26,
                      "campaign-item-1466686-type": "FacebookPageVisitCampaign",
                      "campaign-item-1569314-action-tile-action-text": "Seite besuchen",
                      "campaign-item-1569314-action-tile-title": "Verdienen Sie 20 Punkte, wenn Sie unsere Seite besuchen",
                      "campaign-item-1569314-background-color": "rgba(252,250,238,1)",
                      "campaign-item-1569314-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-1569314-background-type": "color",
                      "campaign-item-1569314-border-color": "rgba(0,0,0,0)",
                      "campaign-item-1569314-description-font-color": "rgba(43,42,165,1)",
                      "campaign-item-1569314-description-font-size": 14,
                      "campaign-item-1569314-exclude_audience_names": [],
                      "campaign-item-1569314-icon-color": "#60a3a3",
                      "campaign-item-1569314-icon-type": "customIcon",
                      "campaign-item-1569314-icon-url": "https://cdn-widget-assets.yotpo.com/static_assets/pc-_zsvJHOoRaZ3ebWa_rg/images/image_2025_03_11_02_54_25_355",
                      "campaign-item-1569314-include_audience_ids": "1",
                      "campaign-item-1569314-include_audience_names": [
                        "All customers"
                      ],
                      "campaign-item-1569314-special-reward-enabled": "false",
                      "campaign-item-1569314-special-reward-headline-background-color": "#D2E3E3",
                      "campaign-item-1569314-special-reward-headline-text": "Just for you!",
                      "campaign-item-1569314-special-reward-headline-title-font-color": "#000000",
                      "campaign-item-1569314-special-reward-headline-title-font-size": "12",
                      "campaign-item-1569314-special-reward-tile-border-color": "#000000",
                      "campaign-item-1569314-tile-description": "FACEBOOK FOLGEN",
                      "campaign-item-1569314-tile-reward": "20 Muscheln",
                      "campaign-item-1569314-title-font-color": "rgba(43,42,165,1)",
                      "campaign-item-1569314-title-font-size": 26,
                      "campaign-item-1569314-type": "FacebookPageVisitCampaign",
                      "campaign-item-1569340-action-tile-action-text": "Abonnieren",
                      "campaign-item-1569340-action-tile-title": "Verdienen Sie 40 Punkte, wenn Sie diese Aktion abschließen",
                      "campaign-item-1569340-background-color": "rgba(252,250,238,1)",
                      "campaign-item-1569340-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-1569340-background-type": "color",
                      "campaign-item-1569340-border-color": "rgba(0,0,0,0)",
                      "campaign-item-1569340-custom-action-tile-action-url": "https://theodderside.com/#:~:text=BEZ%20U%C5%BBYCIA%20PLASTIKU.-,JOIN%20THE%20CLUB,-Zapisz%20si%C4%99%20do",
                      "campaign-item-1569340-description-font-color": "rgba(43,42,165,1)",
                      "campaign-item-1569340-description-font-size": 14,
                      "campaign-item-1569340-exclude_audience_names": [],
                      "campaign-item-1569340-icon-color": "#60a3a3",
                      "campaign-item-1569340-icon-type": "customIcon",
                      "campaign-item-1569340-icon-url": "https://cdn-widget-assets.yotpo.com/static_assets/pc-_zsvJHOoRaZ3ebWa_rg/images/image_2025_03_11_02_54_45_089",
                      "campaign-item-1569340-include_audience_ids": "1",
                      "campaign-item-1569340-include_audience_names": [
                        "All customers"
                      ],
                      "campaign-item-1569340-special-reward-enabled": "false",
                      "campaign-item-1569340-special-reward-headline-background-color": "#D2E3E3",
                      "campaign-item-1569340-special-reward-headline-text": "Just for you!",
                      "campaign-item-1569340-special-reward-headline-title-font-color": "#000000",
                      "campaign-item-1569340-special-reward-headline-title-font-size": "12",
                      "campaign-item-1569340-special-reward-tile-border-color": "#000000",
                      "campaign-item-1569340-tile-description": "ABONNIEREN SIE UNSEREN NEWSLETTER",
                      "campaign-item-1569340-tile-reward": "40 Muscheln",
                      "campaign-item-1569340-title-font-color": "rgba(43,42,165,1)",
                      "campaign-item-1569340-title-font-size": 26,
                      "campaign-item-1569340-type": "CustomActionCampaign",
                      "campaign-item-1569340-view-show-custom-action-button": "true",
                      "campaign-item-1589237-background-color": "rgba(252,250,238,1)",
                      "campaign-item-1589237-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-1589237-background-type": "color",
                      "campaign-item-1589237-border-color": "rgba(0,0,0,0)",
                      "campaign-item-1589237-description-font-color": "rgba(43,42,165,1)",
                      "campaign-item-1589237-description-font-size": 14,
                      "campaign-item-1589237-exclude_audience_names": "",
                      "campaign-item-1589237-hover-view-tile-message": "Earn 250 points when you make 1 purchase",
                      "campaign-item-1589237-icon-color": "#60a3a3",
                      "campaign-item-1589237-icon-type": "customIcon",
                      "campaign-item-1589237-icon-url": "https://cdn-widget-assets.yotpo.com/static_assets/pc-_zsvJHOoRaZ3ebWa_rg/images/image_2025_03_26_10_17_21_846",
                      "campaign-item-1589237-include_audience_ids": "1",
                      "campaign-item-1589237-include_audience_names": "All customers",
                      "campaign-item-1589237-special-reward-enabled": "false",
                      "campaign-item-1589237-special-reward-headline-background-color": "#D2E3E3",
                      "campaign-item-1589237-special-reward-headline-text": "Just for you!",
                      "campaign-item-1589237-special-reward-headline-title-font-color": "#000000",
                      "campaign-item-1589237-special-reward-headline-title-font-size": "12",
                      "campaign-item-1589237-special-reward-tile-border-color": "#000000",
                      "campaign-item-1589237-tile-description": "Make your first purchase  | Pierwsze zamówienie w klubie",
                      "campaign-item-1589237-tile-reward": "500 points",
                      "campaign-item-1589237-title-font-color": "rgba(43,42,165,1)",
                      "campaign-item-1589237-title-font-size": 26,
                      "campaign-item-1589237-type": "TransactionBasedCampaign",
                      "campaign-title-font-color": "#000000",
                      "campaign-title-size": "20px",
                      "completed-tile-headline": "Vollendet",
                      "completed-tile-message": "Sie haben diese Option bereits verwendet",
                      "container-headline": "VERDIENUNGSMÖGLICHKEITEN",
                      "general-hover-tile-button-color": "rgba(43,42,165,1)",
                      "general-hover-tile-button-text-color": "#FFFFFF",
                      "general-hover-tile-button-type": "filled_rectangle",
                      "general-hover-tile-color-overlay": "rgba(220,218,225,1)",
                      "general-hover-tile-text-color": "rgba(43,42,165,1)",
                      "headline-color": "rgba(43,42,165,1)",
                      "headline-font-color": "rgba(43,42,165,1)",
                      "headline-font-size": 40,
                      "layout-background-color": "rgba(254,253,249,1)",
                      "layout-background-enabled": "true",
                      "logged-in-non-member-button-text": "Join now",
                      "logged-in-non-member-link-destination": "banner_section",
                      "logged-out-is-redirect-after-login-to-current-page": "true",
                      "logged-out-message": "BEREITS MITGLIED? ANMELDEN",
                      "logged-out-sign-in-text": "EINLOGGEN",
                      "logged-out-sign-up-text": "DEM CLUB BEITRETEN",
                      "main-text-font-name-and-url": "founders-grotesk-regular@400|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK/founders-grotesk-regular/founders-grotesk-regular-400.css",
                      "secondary-text-font-name-and-url": "founders-grotesk-regular@400|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK/founders-grotesk-regular/founders-grotesk-regular-400.css",
                      "selected-audiences": "1",
                      "selected-extensions": [
                        "1436740",
                        "1589237",
                        "1462605",
                        "1466686",
                        "1466325",
                        "1569314",
                        "1569340"
                      ],
                      "special-reward-enabled": "false",
                      "special-reward-headline-background-color": "#D2E3E3",
                      "special-reward-headline-text": "Special for you",
                      "special-reward-headline-title-font-color": "#000000",
                      "special-reward-headline-title-font-size": "12",
                      "special-reward-tile-border-color": "#000000",
                      "tile-border-color": "#BCBCBC",
                      "tile-spacing-type": "small",
                      "tiles-background-color": "#FFFFFF",
                      "time-between-rewards-days": "Sie sind in *|Tagen|* Tagen wieder berechtigt",
                      "time-between-rewards-hours": "Sie sind in *|Stunden|* Stunden wieder berechtigt"
                    },
                    staticContent: {
                      "companyName": "The Odder Side",
                      "cssEditorEnabled": true,
                      "currency": "PLN",
                      "facebookAppId": "1647129615540489",
                      "isHidden": false,
                      "isMultiCurrencyEnabled": true,
                      "isOptInFlowEnabled": false,
                      "isSegmentationsPickerEnabled": true,
                      "isShopifyNewAccountsVersion": false,
                      "merchantId": "181985",
                      "platformName": "shopify",
                      "storeAccountLoginUrl": "//theodderside.com/account/login",
                      "storeAccountRegistrationUrl": "//theodderside.com/account/register",
                      "storeId": "yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK"
                    },
                    className: "CampaignWidget",
                    dependencyGroupId: 2
                },
            
                "1056899": {
                    instanceId: "1056899",
                    instanceVersionId: "347175226",
                    templateAssetUrl: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widget-my-rewards/app.v1.4.7-7088.js",
                    cssOverrideAssetUrl: "https://cdn-widget-assets.yotpo.com/MyRewardsWidget/pc-_zsvJHOoRaZ3ebWa_rg/css-overrides/css-overrides.2025_03_12_02_48_50_268.css",
                    customizationCssUrl: "",
                    customizations: {
                      "headline-color": "rgba(43,42,165,1)",
                      "headline-font-size": 40,
                      "layout-add-background": "true",
                      "layout-background-color": "rgba(254,253,249,1)",
                      "logged-in-description-color": "rgba(43,42,165,1)",
                      "logged-in-description-font-size": 40,
                      "logged-in-description-text": "{{current_point_balance}}",
                      "logged-in-description-tier-status-text": "{{current_vip_tier_name}} tier",
                      "logged-in-headline-color": "rgba(43,42,165,1)",
                      "logged-in-headline-font-size": 40,
                      "logged-in-headline-text": "Hallo {{first_name}}!",
                      "logged-in-primary-button-cta-type": "redemptionWidget",
                      "logged-in-primary-button-text": "LÖSE MEINE MUSCHELN EIN",
                      "logged-in-secondary-button-text": "PRÄMIENGESCHICHTE",
                      "logged-out-headline-color": "rgba(43,42,165,1)",
                      "logged-out-headline-font-size": 40,
                      "logged-out-headline-text": "WIE ES FUNKTIONIERT",
                      "logged-out-selected-step-name": "step_1",
                      "primary-button-background-color": "rgba(43,42,165,1)",
                      "primary-button-text-color": "#FFFFFF",
                      "primary-button-type": "filled_rectangle",
                      "primary-font-name-and-url": "founders-grotesk-regular@400|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK/founders-grotesk-regular/founders-grotesk-regular-400.css",
                      "reward-step-1-displayname": "Step 1",
                      "reward-step-1-settings-description": "ERSTELLEN SIE EIN KONTO UND STARTEN SIE MIT 100 SHELLS – DENN JEDE FREUNDSCHAFT BEGINNT MIT EINEM ERSTEN SCHRITT!",
                      "reward-step-1-settings-description-color": "rgba(43,42,165,1)",
                      "reward-step-1-settings-description-font-size": 14,
                      "reward-step-1-settings-icon": "custom",
                      "reward-step-1-settings-icon-color": "#000000",
                      "reward-step-1-settings-icon-url": "https://cdn-widget-assets.yotpo.com/static_assets/pc-_zsvJHOoRaZ3ebWa_rg/images/image_2025_03_11_02_24_37_427",
                      "reward-step-1-settings-title": "DEM CLUB BEITRETEN",
                      "reward-step-1-settings-title-color": "rgba(43,42,165,1)",
                      "reward-step-1-settings-title-font-size": 30,
                      "reward-step-2-displayname": "Step 2",
                      "reward-step-2-settings-description": "COLLECT SHELLS EVERY TIME YOU SHOP \u0026 MOVE CLOSER TO BESTIES STATUS!",
                      "reward-step-2-settings-description-color": "rgba(43,42,165,1)",
                      "reward-step-2-settings-description-font-size": 14,
                      "reward-step-2-settings-icon": "custom",
                      "reward-step-2-settings-icon-color": "#000000",
                      "reward-step-2-settings-icon-url": "https://cdn-widget-assets.yotpo.com/static_assets/pc-_zsvJHOoRaZ3ebWa_rg/images/image_2025_03_11_02_25_42_389",
                      "reward-step-2-settings-title": "EARN SHELLS",
                      "reward-step-2-settings-title-color": "rgba(43,42,165,1)",
                      "reward-step-2-settings-title-font-size": 30,
                      "reward-step-3-displayname": "Step 3",
                      "reward-step-3-settings-description": "USE YOUR SHELLS TO GET EXCLUSIVE PERKS - BECAUSE REAL FRIENDS DESERVE SPECIAL TREATMENT!",
                      "reward-step-3-settings-description-color": "rgba(43,42,165,1)",
                      "reward-step-3-settings-description-font-size": 14,
                      "reward-step-3-settings-icon": "custom",
                      "reward-step-3-settings-icon-color": "#000000",
                      "reward-step-3-settings-icon-url": "https://cdn-widget-assets.yotpo.com/static_assets/pc-_zsvJHOoRaZ3ebWa_rg/images/image_2025_03_11_02_26_00_729",
                      "reward-step-3-settings-title": "UNLOCK REWARDS",
                      "reward-step-3-settings-title-color": "rgba(43,42,165,1)",
                      "reward-step-3-settings-title-font-size": 30,
                      "rewards-history-approved-text": "Genehmigt",
                      "rewards-history-background-color": "rgba(255,255,255,0.83)",
                      "rewards-history-headline-color": "rgba(43,42,165,1)",
                      "rewards-history-headline-font-size": "26",
                      "rewards-history-headline-text": "PRÄMIENGESCHICHTE",
                      "rewards-history-pending-text": "Ausstehend",
                      "rewards-history-refunded-text": "Erstattet",
                      "rewards-history-reversed-text": "Umgedreht",
                      "rewards-history-table-action-col-text": "Aktion",
                      "rewards-history-table-date-col-text": "Datum",
                      "rewards-history-table-expiration-col-text": "Punkte verfallen am",
                      "rewards-history-table-points-col-text": "Punkte",
                      "rewards-history-table-status-col-text": "Status",
                      "rewards-history-table-store-col-text": "Store",
                      "secondary-button-background-color": "rgba(43,42,165,1)",
                      "secondary-button-text-color": "rgba(254,253,249,1)",
                      "secondary-button-type": "filled_rectangle",
                      "secondary-font-name-and-url": "founders-grotesk-regular@400|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK/founders-grotesk-regular/founders-grotesk-regular-400.css",
                      "show-logged-in-description-points-balance": true,
                      "show-logged-in-description-tier-status": false,
                      "view-grid-points-column-color": "rgba(43,42,165,1)",
                      "view-grid-rectangular-background-color": "#F6F1EE",
                      "view-grid-type": "border"
                    },
                    staticContent: {
                      "cssEditorEnabled": true,
                      "currency": "PLN",
                      "isHidden": false,
                      "isMultiCurrencyEnabled": true,
                      "isMultiStoreMerchant": false,
                      "isOptInFlowEnabled": false,
                      "isShopifyNewAccountsVersion": false,
                      "isVipTiersEnabled": true,
                      "merchantId": "181985",
                      "platformName": "shopify",
                      "storeId": "yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK"
                    },
                    className: "MyRewardsWidget",
                    dependencyGroupId: 2
                },
            
                "1056898": {
                    instanceId: "1056898",
                    instanceVersionId: "327451051",
                    templateAssetUrl: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widget-hero-section/app.v1.7.13-7014.js",
                    cssOverrideAssetUrl: "https://cdn-widget-assets.yotpo.com/HeroSectionWidget/pc-_zsvJHOoRaZ3ebWa_rg/css-overrides/css-overrides.2025_03_12_02_23_04_459.css",
                    customizationCssUrl: "",
                    customizations: {
                      "background-image-url": "https://cdn-widget-assets.yotpo.com/static_assets/pc-_zsvJHOoRaZ3ebWa_rg/images/image_2025_03_10_00_00_52_800",
                      "description-color": "rgba(43,42,165,1)",
                      "description-font-size": 24,
                      "description-text-logged-in": "JEDER KAUF BRINGT SIE DEM BESTIES-STATUS NÄHER. VERDIENEN SIE SHELLS UND SCHALTEN SIE BELOHNUNGEN FREI!",
                      "description-text-logged-out": "SAMMLE MUSCHELN UND SCHALTE MIT JEDEM KAUF EXKLUSIVE VORTEILE FREI!",
                      "headline-color": "rgba(43,42,165,1)",
                      "headline-font-size": 120,
                      "headline-text-logged-in": "WILLKOMMEN IM CLUB",
                      "headline-text-logged-in-non-member": "You’re a step away from rewards!",
                      "headline-text-logged-in-subtitle-text-non-member": "Join our rewards program and earn points and exclusive rewards every time you shop.",
                      "headline-text-logged-out": "DEM CLUB BEITRETEN",
                      "login-button-color": "rgba(252,250,238,1)",
                      "login-button-text": "Einloggen",
                      "login-button-text-color": "rgba(0,0,0,1)",
                      "login-button-type": "filled_rectangle",
                      "member-optin-disclaimer": "To customize the disclaimer and button asking non-members to join your program, go to \u003cb\u003ePage Settings.\u003c/b\u003e",
                      "mobile-background-image-url": "https://cdn-widget-assets.yotpo.com/static_assets/pc-_zsvJHOoRaZ3ebWa_rg/images/image_2025_03_10_23_44_50_341",
                      "mode-is-page-settings": false,
                      "primary-font-name-and-url": "founders-grotesk-regular@400|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK/founders-grotesk-regular/founders-grotesk-regular-400.css",
                      "register-button-color": "rgba(252,250,238,1)",
                      "register-button-text": "Melden Sie sich jetzt an",
                      "register-button-text-color": "rgba(0,0,0,1)",
                      "register-button-type": "filled_rectangle",
                      "reward-opt-in-join-now-button-label": "Complete program signup",
                      "rewards-disclaimer-text": "I agree to the program’s [terms](http://example.net/terms) and [privacy policy](http://example.net/privacy-policy)",
                      "rewards-disclaimer-text-color": "#00000",
                      "rewards-disclaimer-text-size": "12px",
                      "rewards-disclaimer-type": "no-disclaimer",
                      "secondary-font-name-and-url": "founders-grotesk-regular@400|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK/founders-grotesk-regular/founders-grotesk-regular-400.css",
                      "text-background-color": "#D2E3E3",
                      "text-background-show-on-desktop": false,
                      "text-background-show-on-mobile": false,
                      "view-layout": "center-layout"
                    },
                    staticContent: {
                      "cssEditorEnabled": true,
                      "isHidden": false,
                      "isOptInFlowEnabled": false,
                      "isShopifyNewAccountsVersion": false,
                      "merchantId": "181985",
                      "platformName": "shopify",
                      "storeId": "yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK",
                      "storeLoginUrl": "//theodderside.com/account/login",
                      "storeRegistrationUrl": "//theodderside.com/account/register"
                    },
                    className: "HeroSectionWidget",
                    dependencyGroupId: 2
                },
            
                "1056897": {
                    instanceId: "1056897",
                    instanceVersionId: "328716456",
                    templateAssetUrl: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widget-loyalty-page/app.v0.6.3-7159.js",
                    cssOverrideAssetUrl: "",
                    customizationCssUrl: "",
                    customizations: {
                      "headline-color": "rgba(43,42,165,1)",
                      "headline-font-size": 40,
                      "page-background-color": "",
                      "primary-font-name-and-url": "founders-grotesk-regular@400|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK/founders-grotesk-regular/founders-grotesk-regular-400.css",
                      "reward-opt-in-join-now-button-label": "Complete program signup",
                      "rewards-disclaimer-text": "I agree to the program’s [terms](http://example.net/terms) and [privacy policy](http://example.net/privacy-policy)",
                      "rewards-disclaimer-text-color": "#00000",
                      "rewards-disclaimer-text-size": "12px",
                      "rewards-disclaimer-type": "no-disclaimer",
                      "secondary-font-name-and-url": "founders-grotesk-regular@400|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK/founders-grotesk-regular/founders-grotesk-regular-400.css",
                      "selected-widgets-ids": [
                        "1056898",
                        "1056899",
                        "1056900",
                        "1056901",
                        "1056902",
                        "1056903"
                      ],
                      "widget-1056898-type": "HeroSectionWidget",
                      "widget-1056899-type": "MyRewardsWidget",
                      "widget-1056900-type": "CampaignWidget",
                      "widget-1056901-type": null,
                      "widget-1056902-type": "VipTiersWidget",
                      "widget-1056903-type": "ReferralShareWidget",
                      "widget-1056904-type": "VisualRedemptionWidget"
                    },
                    staticContent: {
                      "isHidden": false,
                      "isOptInFlowEnabled": false,
                      "platformName": "shopify",
                      "storeId": "yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK"
                    },
                    className: "LoyaltyPageWidget",
                    dependencyGroupId: null
                },
            
                "1056884": {
                    instanceId: "1056884",
                    instanceVersionId: "327451052",
                    templateAssetUrl: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widget-visual-redemption/app.v1.1.3-6746.js",
                    cssOverrideAssetUrl: "https://cdn-widget-assets.yotpo.com/VisualRedemptionWidget/pc-_zsvJHOoRaZ3ebWa_rg/css-overrides/css-overrides.2025_03_11_03_14_08_617.css",
                    customizationCssUrl: "",
                    customizations: {
                      "description-color": "rgba(43,42,165,1)",
                      "description-font-size": 14,
                      "headline-color": "rgba(43,42,165,1)",
                      "headline-font-size": 40,
                      "layout-add-background": "true",
                      "layout-background-color": "rgba(254,253,249,1)",
                      "primary-font-name-and-url": "founders-grotesk-regular@400|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK/founders-grotesk-regular/founders-grotesk-regular-400.css",
                      "redemption-1-displayname": "Tile 1",
                      "redemption-1-settings-cost": "x 500",
                      "redemption-1-settings-cost-color": "rgba(43,42,165,1)",
                      "redemption-1-settings-cost-font-size": 20,
                      "redemption-1-settings-frame-color": "rgba(0,0,0,0)",
                      "redemption-1-settings-reward": "20 PLN OFF",
                      "redemption-1-settings-reward-color": "rgba(43,42,165,1)",
                      "redemption-1-settings-reward-font-size": 55,
                      "redemption-2-displayname": "Tile 2",
                      "redemption-2-settings-cost": "x 1000",
                      "redemption-2-settings-cost-color": "rgba(43,42,165,1)",
                      "redemption-2-settings-cost-font-size": 20,
                      "redemption-2-settings-frame-color": "rgba(0,0,0,0)",
                      "redemption-2-settings-reward": "40 PLN OFF",
                      "redemption-2-settings-reward-color": "rgba(43,42,165,1)",
                      "redemption-2-settings-reward-font-size": 55,
                      "redemption-3-displayname": "Tile 3",
                      "redemption-3-settings-cost": "x 2000",
                      "redemption-3-settings-cost-color": "rgba(43,42,165,1)",
                      "redemption-3-settings-cost-font-size": 20,
                      "redemption-3-settings-frame-color": "rgba(0,0,0,0)",
                      "redemption-3-settings-reward": "80 PLN OFF",
                      "redemption-3-settings-reward-color": "rgba(43,42,165,1)",
                      "redemption-3-settings-reward-font-size": 55,
                      "rule-color": "rgba(43,42,165,1)",
                      "rule-dots-color": "rgba(0,0,0,0)",
                      "rule-font-size": 20,
                      "secondary-font-name-and-url": "founders-grotesk-regular@400|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK/founders-grotesk-regular/founders-grotesk-regular-400.css",
                      "selected-extensions": [
                        "1",
                        "2",
                        "3"
                      ],
                      "view-layout": "full-layout",
                      "visual-redemption-description": "REDEEMING YOUR SHELLS IS EASY! \nJUST CLICK REDEEM MY SHELLS, AND SELECT AN ELIGIBLE REWARD.",
                      "visual-redemption-headline": "HOW TO USE YOUR SHELLS",
                      "visual-redemption-rule": "x 100 EQUALS 1 PLN"
                    },
                    staticContent: {
                      "cssEditorEnabled": true,
                      "currency": "PLN",
                      "isHidden": false,
                      "isMultiCurrencyEnabled": true,
                      "isShopifyNewAccountsVersion": false,
                      "platformName": "shopify",
                      "storeId": "yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK"
                    },
                    className: "VisualRedemptionWidget",
                    dependencyGroupId: 2
                },
            
                "1056883": {
                    instanceId: "1056883",
                    instanceVersionId: "347075647",
                    templateAssetUrl: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widget-referral-share/app.v0.4.24-7079.js",
                    cssOverrideAssetUrl: "https://cdn-widget-assets.yotpo.com/ReferralShareWidget/pc-_zsvJHOoRaZ3ebWa_rg/css-overrides/css-overrides.2025_03_18_23_13_31_330.css",
                    customizationCssUrl: "",
                    customizations: {
                      "background-color": "rgba(0,0,0,0)",
                      "customer-email-view-button-text": "Next",
                      "customer-email-view-description-discount-discount": "Give your friends {{friend_reward}} their first purchase of {{min_spent}}, and get {{customer_reward}} for each successful referral.",
                      "customer-email-view-description-discount-points": "Give your friends {{friend_reward}} their first purchase of {{min_spent}}, and get {{customer_reward}} points for each successful referral.",
                      "customer-email-view-description-nothing-discount": "Get {{customer_reward}} for each successful referral.",
                      "customer-email-view-description-nothing-points": "Get {{customer_reward}} points for each successful referral.",
                      "customer-email-view-description-points-discount": "Give your friends {{friend_reward}} points, and get {{customer_reward}} for each successful referral.",
                      "customer-email-view-description-points-points": "Give your friends {{friend_reward}} points, and get {{customer_reward}} points for each successful referral.",
                      "customer-email-view-header": "Refer a Friend",
                      "customer-email-view-input-placeholder": "Your email address",
                      "customer-email-view-title-discount-discount": "GIVE {{friend_reward}}, GET {{customer_reward}}",
                      "customer-email-view-title-discount-points": "GIVE {{friend_reward}}, GET {{customer_reward}} POINTS",
                      "customer-email-view-title-nothing-discount": "REFER A FRIEND, GET {{customer_reward}} FOR REFERRALS",
                      "customer-email-view-title-nothing-points": "REFER A FRIEND, GET {{customer_reward}} POINTS FOR REFERRALS",
                      "customer-email-view-title-points-discount": "GIVE {{friend_reward}} POINTS, GET {{customer_reward}}",
                      "customer-email-view-title-points-points": "GIVE {{friend_reward}} POINTS, GET {{customer_reward}} POINTS",
                      "customer-name-view-input-placeholder": "Your name",
                      "default-toggle": true,
                      "description-color": "rgba(252,250,238,1)",
                      "description-font-size": "24px",
                      "desktop-background-image-url": "https://cdn-widget-assets.yotpo.com/static_assets/pc-_zsvJHOoRaZ3ebWa_rg/images/image_2025_03_11_04_49_21_356",
                      "disabled-referral-code-error": "Il semble que votre lien de parrainage ait été désactivé",
                      "email-fill-color": "#F6F1EE",
                      "email-input-type": "rounded_rectangle",
                      "email-outline-color": "#000000",
                      "email-text-color": "#000000",
                      "final-view-button-text": "Parrainez plus d'amis",
                      "final-view-description": "Remind your friends to check their email",
                      "final-view-error-description": "Nous n'avons pas pu partager le lien de parrainage. Revenez à l'étape précédente pour réessayer.",
                      "final-view-error-text": "Dos",
                      "final-view-error-title": "Quelque chose s'est mal passé",
                      "final-view-title": "Merci de votre référencement !",
                      "fonts-primary-font-name-and-url": "founders-grotesk-regular@400|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK/founders-grotesk-regular/founders-grotesk-regular-400.css",
                      "fonts-secondary-font-name-and-url": "founders-grotesk-regular@400|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK/founders-grotesk-regular/founders-grotesk-regular-400.css",
                      "header-color": "rgba(252,250,238,1)",
                      "header-font-size": "14px",
                      "headline-color": "rgba(43,42,165,1)",
                      "headline-font-size": 40,
                      "login-view-description-discount-discount": "Give your friends {{friend_reward}} their first purchase of {{min_spent}}, and get {{customer_reward}} for each successful referral.",
                      "login-view-description-discount-points": "Give your friends {{friend_reward}} their first purchase of {{min_spent}}, and get {{customer_reward}} points for each successful referral.",
                      "login-view-description-nothing-discount": "Get {{customer_reward}} for each successful referral.",
                      "login-view-description-nothing-points": "PARCE QUE TOUTE AMITIÉ COMMENCE PAR UN PREMIER PAS !",
                      "login-view-description-points-discount": "Give your friends {{friend_reward}} points, and get {{customer_reward}} for each successful referral.",
                      "login-view-description-points-points": "Give your friends {{friend_reward}} points, and get {{customer_reward}} points for each successful referral.",
                      "login-view-header": "INVITEZ VOS AMIS ET GAGNEZ DES COQUILLAGES",
                      "login-view-log-in-button-text": "SE CONNECTER",
                      "login-view-sign-up-button-text": "REJOIGNEZ-NOUS MAINTENANT",
                      "login-view-title-discount-discount": "GIVE {{friend_reward}}, GET {{customer_reward}}",
                      "login-view-title-discount-points": "GIVE {{friend_reward}}, GET {{customer_reward}} POINTS",
                      "login-view-title-nothing-discount": "REFER A FRIEND, GET {{customer_reward}} FOR REFERRALS",
                      "login-view-title-nothing-points": "OBTENEZ 500 COQUILLAGES",
                      "login-view-title-points-discount": "GIVE {{friend_reward}} POINTS, GET {{customer_reward}}",
                      "login-view-title-points-points": "GIVE {{friend_reward}} POINTS, GET {{customer_reward}} POINTS",
                      "main-share-option-desktop": "main_share_copy_link",
                      "main-share-option-mobile": "main_share_sms",
                      "mobile-background-image-url": "https://cdn-widget-assets.yotpo.com/static_assets/pc-_zsvJHOoRaZ3ebWa_rg/images/image_2025_03_11_04_49_26_424",
                      "more-share-ways-text": "MORE WAYS TO SHARE",
                      "primary-button-background-color": "rgba(43,42,165,1)",
                      "primary-button-font-size": "16px",
                      "primary-button-size": "standard",
                      "primary-button-text-color": "rgba(252,250,238,1)",
                      "primary-button-type": "filled_rectangle",
                      "reduced-picture": true,
                      "referral-history-completed-points-text": "{{points}} POINTS",
                      "referral-history-completed-status-type": "text",
                      "referral-history-confirmed-status": "Completed",
                      "referral-history-pending-status": "Pending",
                      "referral-history-redeem-text": "You can redeem your points for a reward, or apply your reward code at checkout.",
                      "referral-history-sumup-line-points-text": "{{points}} POINTS",
                      "referral-history-sumup-line-text": "Your Rewards",
                      "referral-views-button-text": "Next",
                      "referral-views-copy-link-button-text": "Copy link",
                      "referral-views-description-discount-discount": "Give your friends {{friend_reward}} their first purchase of {{min_spent}}, and get {{customer_reward}} for each successful referral.",
                      "referral-views-description-discount-points": "Give your friends {{friend_reward}} their first purchase of {{min_spent}}, and get {{customer_reward}} points for each successful referral.",
                      "referral-views-description-nothing-discount": "Get {{customer_reward}} for each successful referral.",
                      "referral-views-description-nothing-points": "PARCE QUE TOUTE AMITIÉ COMMENCE PAR UN PREMIER PAS !",
                      "referral-views-description-points-discount": "Give your friends {{friend_reward}} points, and get {{customer_reward}} for each successful referral.",
                      "referral-views-description-points-points": "Give your friends {{friend_reward}} points, and get {{customer_reward}} points for each successful referral.",
                      "referral-views-email-share-body": "How does a discount off your first order at {{company_name}} sound? Use the link below and once you've shopped, I'll get a reward too.\n{{referral_link}}",
                      "referral-views-email-share-subject": "Discount to a Store You'll Love!",
                      "referral-views-email-share-type": "personal_email",
                      "referral-views-friends-input-placeholder": "Friend’s email address",
                      "referral-views-header": "INVITEZ VOS AMIS ET GAGNEZ DES COQUILLAGES",
                      "referral-views-personal-email-button-text": "Share via email",
                      "referral-views-sms-button-text": "Partager par SMS",
                      "referral-views-title-discount-discount": "GIVE {{friend_reward}}, GET {{customer_reward}}",
                      "referral-views-title-discount-points": "GIVE {{friend_reward}}, GET {{customer_reward}} POINTS",
                      "referral-views-title-nothing-discount": "REFER A FRIEND, GET {{customer_reward}} FOR REFERRALS",
                      "referral-views-title-nothing-points": "OBTENEZ 500 COQUILLAGES",
                      "referral-views-title-points-discount": "GIVE {{friend_reward}} POINTS, GET {{customer_reward}}",
                      "referral-views-title-points-points": "GIVE {{friend_reward}} POINTS, GET {{customer_reward}} POINTS",
                      "referral-views-whatsapp-button-text": "Share via WhatsApp",
                      "secondary-button-background-color": "rgba(43,42,165,1)",
                      "secondary-button-text-color": "rgba(252,250,238,1)",
                      "secondary-button-type": "filled_rectangle",
                      "share-allow-copy-link": true,
                      "share-allow-email": true,
                      "share-allow-sms": true,
                      "share-allow-whatsapp": true,
                      "share-headline-text-color": "rgba(252,250,238,1)",
                      "share-icons-color": "rgba(252,250,238,1)",
                      "share-settings-copyLink": true,
                      "share-settings-default-checkbox": true,
                      "share-settings-default-mobile-checkbox": true,
                      "share-settings-email": true,
                      "share-settings-mobile-copyLink": true,
                      "share-settings-mobile-email": true,
                      "share-settings-mobile-sms": true,
                      "share-settings-mobile-whatsapp": true,
                      "share-settings-whatsapp": true,
                      "share-sms-message": "I love {{company_name}}! Shop through my link to get a reward {{referral_link}}",
                      "share-whatsapp-message": "I love {{company_name}}! Shop through my link to get a reward {{referral_link}}",
                      "tab-size": "small",
                      "tab-type": "lower_line",
                      "tab-view-primary-tab-text": "Refer a Friend",
                      "tab-view-secondary-tab-text": "Your Referrals",
                      "tile-color": "rgba(0,0,0,0)",
                      "title-color": "rgba(252,250,238,1)",
                      "title-font-size": "40px",
                      "view-exit-intent-enabled": false,
                      "view-exit-intent-mobile-timeout-ms": 10000,
                      "view-is-popup": false,
                      "view-layout": "centered",
                      "view-popup-delay-ms": 0,
                      "view-show-customer-name": false,
                      "view-show-popup-on-exit": false,
                      "view-show-referral-history": false,
                      "view-table-rectangular-dark-pending-color": "rgba( 0, 0, 0, 0.6 )",
                      "view-table-rectangular-light-pending-color": "#FFFFFF",
                      "view-table-selected-color": "#0F8383",
                      "view-table-theme": "dark",
                      "view-table-type": "lines",
                      "wadmin-text-and-share-choose-sreen": "step_3"
                    },
                    staticContent: {
                      "advocateLoggedInRequirement": true,
                      "advocateRewardType": "POINTS",
                      "companyName": "The Odder Side",
                      "cssEditorEnabled": true,
                      "currency": "PLN",
                      "friendRewardType": "NOTHING",
                      "hasPrimaryFontsFeature": true,
                      "isFreeMerchant": false,
                      "isHidden": false,
                      "isMultiCurrencyEnabled": true,
                      "merchantId": "181985",
                      "migrateTabColorToBackground": true,
                      "platformName": "shopify",
                      "referralHistoryEnabled": true,
                      "referralHost": "http://rwrd.io",
                      "storeId": "yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK"
                    },
                    className: "ReferralShareWidget",
                    dependencyGroupId: null
                },
            
                "1056882": {
                    instanceId: "1056882",
                    instanceVersionId: "327451064",
                    templateAssetUrl: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widget-vip-tiers/app.v2.2.4-6882.js",
                    cssOverrideAssetUrl: "https://cdn-widget-assets.yotpo.com/VipTiersWidget/pc-_zsvJHOoRaZ3ebWa_rg/css-overrides/css-overrides.2025_03_12_13_18_03_502.css",
                    customizationCssUrl: "",
                    customizations: {
                      "background-color": "rgba(254,253,249,1)",
                      "background-enabled": "true",
                      "benefits-font-size": "14px",
                      "benefits-icon-color": "#89BABA",
                      "benefits-icon-type": "custom",
                      "benefits-icon-url": "https://cdn-widget-assets.yotpo.com/static_assets/pc-_zsvJHOoRaZ3ebWa_rg/images/image_2025_03_11_03_18_04_364",
                      "benefits-text-color": "rgba(43,42,165,1)",
                      "card-background-border-color": "rgba(0,0,0,0)",
                      "card-background-color": "rgba(252,250,238,1)",
                      "card-background-shadow": "false",
                      "card-separator-color": "#BCBCBC",
                      "card-separator-enabled": "false",
                      "current-status-bg-color": "rgba(252,250,238,1)",
                      "current-status-tag": "true",
                      "current-status-text": "VOTRE STATUT ACTUEL",
                      "current-status-text-color": "rgba(43,42,165,1)",
                      "current-tier-border-color": "rgba(0,0,0,0)",
                      "grid-lines-color": "#ACB5D4",
                      "headline-color": "rgba(43,42,165,1)",
                      "headline-font-size": 120,
                      "headline-text-color": "rgba(43,42,165,1)",
                      "layout": "card",
                      "primary-font-name-and-url": "founders-grotesk-regular@400|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK/founders-grotesk-regular/founders-grotesk-regular-400.css",
                      "progress-bar-current-status": "{{amount_spent}} Dépensé",
                      "progress-bar-enabled": "true",
                      "progress-bar-headline-font-size": "14px",
                      "progress-bar-primary-color": "rgba(43,42,165,1)",
                      "progress-bar-secondary-color": "rgba(43,42,165,1)",
                      "progress-bar-summary-current": "Vous avez {{current_vip_tier_name}} jusqu'à la prochaine période de gains.",
                      "progress-bar-summary-font-size": "14px",
                      "progress-bar-summary-maintain": "Dépensez {{spend_needed}} avant le {{tier_expiration_date}} pour conserver {{current_vip_tier_name}}",
                      "progress-bar-summary-next": "Dépensez {{spend_needed}} pour débloquer {{next_vip_tier_name}}.",
                      "progress-bar-tier-status": "Statut du niveau",
                      "progress-bar-you": "TOI",
                      "secondary-font-name-and-url": "founders-grotesk-regular@400|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK/founders-grotesk-regular/founders-grotesk-regular-400.css",
                      "selected-extensions": [
                        "30768",
                        "30769",
                        "30770",
                        "30846"
                      ],
                      "show-less-text": "- Voir moins",
                      "show-more-text": "+ Voir plus",
                      "tier-spacing": "small",
                      "tiers-30768-design-header-bg-color": "#FFFFFF",
                      "tiers-30768-design-icon-fill-color": "#0F8383",
                      "tiers-30768-design-icon-type": "custom",
                      "tiers-30768-design-icon-url": "https://cdn-widget-assets.yotpo.com/static_assets/pc-_zsvJHOoRaZ3ebWa_rg/images/image_2025_03_11_04_16_57_463",
                      "tiers-30768-design-include-header-bg": "false",
                      "tiers-30768-design-name-font-size": "24px",
                      "tiers-30768-design-name-text-color": "rgba(43,42,165,1)",
                      "tiers-30768-design-threshold-font-size": "14px",
                      "tiers-30768-design-threshold-text-color": "rgba(43,42,165,1)",
                      "tiers-30768-text-benefits": "CADEAU D'ANNIVERSAIRE||GAGNEZ DES COQUILLAGES À CHAQUE ACHAT",
                      "tiers-30768-text-name": "NOUVEL AMI",
                      "tiers-30768-text-rank": 1,
                      "tiers-30768-text-threshold": "REJOINDRE",
                      "tiers-30769-design-header-bg-color": "#FFFFFF",
                      "tiers-30769-design-icon-fill-color": "#0F8383",
                      "tiers-30769-design-icon-type": "custom",
                      "tiers-30769-design-icon-url": "https://cdn-widget-assets.yotpo.com/static_assets/pc-_zsvJHOoRaZ3ebWa_rg/images/image_2025_03_11_04_17_26_894",
                      "tiers-30769-design-include-header-bg": "false",
                      "tiers-30769-design-name-font-size": "24px",
                      "tiers-30769-design-name-text-color": "rgba(43,42,165,1)",
                      "tiers-30769-design-threshold-font-size": "14px",
                      "tiers-30769-design-threshold-text-color": "rgba(43,42,165,1)",
                      "tiers-30769-text-benefits": "CADEAU D'ANNIVERSAIRE SPÉCIAL CERCLE FERMÉ||GAGNEZ PLUS DE COQUILLAGES PAR DÉPENSE||CADEAU D'ENTRÉE DE NIVEAU : 500 COQUILLES",
                      "tiers-30769-text-name": "CERCLE FERMÉ",
                      "tiers-30769-text-rank": 2,
                      "tiers-30769-text-threshold": "DÉPENSER {{amount_spent}}",
                      "tiers-30770-design-header-bg-color": "#FFFFFF",
                      "tiers-30770-design-icon-fill-color": "#0F8383",
                      "tiers-30770-design-icon-type": "custom",
                      "tiers-30770-design-icon-url": "https://cdn-widget-assets.yotpo.com/static_assets/pc-_zsvJHOoRaZ3ebWa_rg/images/image_2025_03_11_04_18_12_525",
                      "tiers-30770-design-include-header-bg": "false",
                      "tiers-30770-design-name-font-size": "24px",
                      "tiers-30770-design-name-text-color": "rgba(43,42,165,1)",
                      "tiers-30770-design-threshold-font-size": "14px",
                      "tiers-30770-design-threshold-text-color": "rgba(43,42,165,1)",
                      "tiers-30770-text-benefits": "PARTENAIRE EXCLUSIF DANS LE CRIME||CADEAU D'ANNIVERSAIRE||ENCORE PLUS DE COQUILLAGES PAR DÉPENSE||CADEAU D'ENTRÉE DE NIVEAU : 1 000 COQUILLES||LIVRAISON STANDARD GRATUITE||ACCÈS ANTICIPÉ AUX NOUVELLES COLLECTIONS||MULTIPLICATEUR DE POINTS X1,25",
                      "tiers-30770-text-name": "PARTENAIRE DANS LE CRIME",
                      "tiers-30770-text-rank": 3,
                      "tiers-30770-text-threshold": "DÉPENSER {{amount_spent}}",
                      "tiers-30846-design-header-bg-color": "#FFFFFF",
                      "tiers-30846-design-icon-fill-color": "#0F8383",
                      "tiers-30846-design-icon-type": "custom",
                      "tiers-30846-design-icon-url": "https://cdn-widget-assets.yotpo.com/static_assets/pc-_zsvJHOoRaZ3ebWa_rg/images/image_2025_03_11_04_18_48_624",
                      "tiers-30846-design-include-header-bg": "false",
                      "tiers-30846-design-name-font-size": "24px",
                      "tiers-30846-design-name-text-color": "rgba(43,42,165,1)",
                      "tiers-30846-design-threshold-font-size": "14px",
                      "tiers-30846-design-threshold-text-color": "rgba(43,42,165,1)",
                      "tiers-30846-text-benefits": "LE CADEAU D'ANNIVERSAIRE ULTIME POUR LES MEILLEURS AMIES||MAX DE COQUILLAGES PAR DÉPENSE||CADEAU D'ENTRÉE DE NIVEAU : 3 000 COQUILLES||LIVRAISON EXPRESS GRATUITE||ACCÈS ANTICIPÉ AUX NOUVELLES COLLECTIONS||INVITATIONS À DES ÉVÉNEMENTS VIP||MULTIPLICATEUR DE POINTS X1,5",
                      "tiers-30846-text-name": "BESTIES",
                      "tiers-30846-text-rank": 4,
                      "tiers-30846-text-threshold": "DÉPENSER {{amount_spent}}",
                      "widget-headline": "LES MEILLEURS AMIS GAGNENT ENCORE PLUS"
                    },
                    staticContent: {
                      "cssEditorEnabled": true,
                      "currency": "PLN",
                      "isHidden": false,
                      "isMultiCurrencyEnabled": true,
                      "merchantId": "181985",
                      "platformName": "shopify",
                      "storeId": "yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK"
                    },
                    className: "VipTiersWidget",
                    dependencyGroupId: 2
                },
            
                "1056881": {
                    instanceId: "1056881",
                    instanceVersionId: "327451076",
                    templateAssetUrl: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widget-coupons-redemption/app.v1.1.13-7015.js",
                    cssOverrideAssetUrl: "https://cdn-widget-assets.yotpo.com/CouponsRedemptionWidget/pc-_zsvJHOoRaZ3ebWa_rg/css-overrides/css-overrides.2025_03_12_05_30_43_654.css",
                    customizationCssUrl: "",
                    customizations: {
                      "confirmation-step-cancel-option": "No",
                      "confirmation-step-confirm-option": "Yes",
                      "confirmation-step-title": "Are you sure?",
                      "coupon-background-type": "no-background",
                      "coupon-code-copied-message-body": "Thank you for redeeming your points. Please paste the code at checkout",
                      "coupon-code-copied-message-color": "#707997",
                      "coupon-code-copied-message-title": "",
                      "coupons-redemption-description": "ÉCHANGER VOS COQUILLES, C'EST FACILE !\nCLIQUEZ SIMPLEMENT SUR « ÉCHANGER MES COQUILLES » ET SÉLECTIONNEZ UNE RÉCOMPENSE ÉLIGIBLE.",
                      "coupons-redemption-headline": "COMMENT UTILISER VOS COQUILLAGES",
                      "coupons-redemption-rule": "x 100 ÉGAL À {{1_local_currency}}",
                      "description-color": "rgba(43,42,165,1)",
                      "description-font-size": 14,
                      "discount-bigger-than-subscription-cost-text": "Your next subscription is lower than the redemption amount",
                      "donate-button-text": "Donate",
                      "donation-success-message-body": "Thank you for donating ${{donation_amount}} to {{company_name}}",
                      "donation-success-message-color": "#707997",
                      "donation-success-message-title": "Success",
                      "error-message-color": "#f04860",
                      "error-message-title": "",
                      "headline-color": "rgba(43,42,165,1)",
                      "headline-font-size": 40,
                      "layout-add-background": "true",
                      "layout-background-color": "rgba(254,253,249,1)",
                      "local-enable-opt-in-flow": false,
                      "local-member-optin-disclaimer": "Add a disclaimer and button asking non-members to join your program.",
                      "local-member-optin-disclaimer-part2": "To customize them, go to \u003cb\u003ePage Settings.\u003c/b\u003e",
                      "login-button-color": "rgba(43,42,165,1)",
                      "login-button-text": "Échanger mes points",
                      "login-button-text-color": "white",
                      "login-button-type": "filled_rectangle",
                      "message-font-size": "14",
                      "missing-points-amount-text": "You don't have enough points to redeem",
                      "next-subscription-headline-text": "NEXT ORDER",
                      "next-subscription-subtitle-text": "{{product_name}} {{next_order_amount}}",
                      "no-subscription-subtitle-text": "No ongoing subscriptions",
                      "point-balance-text": "Vous avez {{current_point_balance}} coquillages",
                      "points-balance-color": "rgba(43,42,165,1)",
                      "points-balance-font-size": 20,
                      "points-balance-number-color": "rgba(43,42,165,1)",
                      "primary-font-name-and-url": "founders-grotesk-regular@400|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK/founders-grotesk-regular/founders-grotesk-regular-400.css",
                      "redeem-button-color": "#0F8383",
                      "redeem-button-text": "Redeem",
                      "redeem-button-text-color": "#FFFFFF",
                      "redeem-button-type": "rounded_filled_rectangle",
                      "redeem-frame-color": "#BCBCBC",
                      "redemption-942586-displayname": "20 zł off",
                      "redemption-942586-settings-button-color": "rgba(43,42,165,1)",
                      "redemption-942586-settings-button-text": "RACHETER MES COQUILLAGES",
                      "redemption-942586-settings-button-text-color": "#FFFFFF",
                      "redemption-942586-settings-button-type": "filled_rectangle",
                      "redemption-942586-settings-call-to-action-button-text": "Redeem",
                      "redemption-942586-settings-cost": 500,
                      "redemption-942586-settings-cost-color": "rgba(43,42,165,1)",
                      "redemption-942586-settings-cost-font-size": 20,
                      "redemption-942586-settings-cost-text": "x {{points}}",
                      "redemption-942586-settings-coupon-cost-font-size": "15",
                      "redemption-942586-settings-coupon-reward-font-size": "20",
                      "redemption-942586-settings-discount-amount-cents": 2000,
                      "redemption-942586-settings-discount-type": "fixed_amount",
                      "redemption-942586-settings-frame-color": "rgba(0,0,0,0)",
                      "redemption-942586-settings-reward": "{{20_local_currency}}",
                      "redemption-942586-settings-reward-color": "rgba(43,42,165,1)",
                      "redemption-942586-settings-reward-font-size": 55,
                      "redemption-942586-settings-success-message-text": "Reward Applied",
                      "redemption-942587-displayname": "40 zł off",
                      "redemption-942587-settings-button-color": "rgba(43,42,165,1)",
                      "redemption-942587-settings-button-text": "RACHETER MES COQUILLAGES",
                      "redemption-942587-settings-button-text-color": "#FFFFFF",
                      "redemption-942587-settings-button-type": "filled_rectangle",
                      "redemption-942587-settings-call-to-action-button-text": "Redeem",
                      "redemption-942587-settings-cost": 1000,
                      "redemption-942587-settings-cost-color": "rgba(43,42,165,1)",
                      "redemption-942587-settings-cost-font-size": 20,
                      "redemption-942587-settings-cost-text": "x {{points}}",
                      "redemption-942587-settings-coupon-cost-font-size": "15",
                      "redemption-942587-settings-coupon-reward-font-size": "20",
                      "redemption-942587-settings-discount-amount-cents": 4000,
                      "redemption-942587-settings-discount-type": "fixed_amount",
                      "redemption-942587-settings-frame-color": "rgba(0,0,0,0)",
                      "redemption-942587-settings-reward": "{{40_local_currency}}",
                      "redemption-942587-settings-reward-color": "rgba(43,42,165,1)",
                      "redemption-942587-settings-reward-font-size": 55,
                      "redemption-942587-settings-success-message-text": "Reward Applied",
                      "redemption-944048-displayname": "80 zł off",
                      "redemption-944048-settings-button-color": "rgba(43,42,165,1)",
                      "redemption-944048-settings-button-text": "RACHETER MES COQUILLAGES",
                      "redemption-944048-settings-button-text-color": "#FFFFFF",
                      "redemption-944048-settings-button-type": "filled_rectangle",
                      "redemption-944048-settings-call-to-action-button-text": "Redeem",
                      "redemption-944048-settings-cost": "2000",
                      "redemption-944048-settings-cost-color": "rgba(43,42,165,1)",
                      "redemption-944048-settings-cost-font-size": 20,
                      "redemption-944048-settings-cost-text": "x {{points}}",
                      "redemption-944048-settings-coupon-cost-font-size": "15",
                      "redemption-944048-settings-coupon-reward-font-size": "20",
                      "redemption-944048-settings-discount-amount-cents": "8000",
                      "redemption-944048-settings-discount-type": "fixed_amount",
                      "redemption-944048-settings-frame-color": "rgba(0,0,0,0)",
                      "redemption-944048-settings-reward": "{{80_local_currency}}",
                      "redemption-944048-settings-reward-color": "rgba(43,42,165,1)",
                      "redemption-944048-settings-reward-font-size": 55,
                      "redemption-944048-settings-success-message-text": "Reward Applied",
                      "reward-opt-in-join-now-button-label": "Complete program signup",
                      "rewards-disclaimer-text": "I agree to the program’s [terms](http://example.net/terms) and [privacy policy](http://example.net/privacy-policy)",
                      "rewards-disclaimer-text-color": "#00000",
                      "rewards-disclaimer-text-size": "12px",
                      "rewards-disclaimer-type": "no-disclaimer",
                      "rule-color": "rgba(43,42,165,1)",
                      "rule-dots-color": "rgba(0,0,0,0)",
                      "rule-font-size": 20,
                      "secondary-font-name-and-url": "founders-grotesk-regular@400|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK/founders-grotesk-regular/founders-grotesk-regular-400.css",
                      "selected-extensions": [
                        "942586",
                        "942587",
                        "944048"
                      ],
                      "selected-redemptions-modes": "regular",
                      "subscription-coupon-applied-message-body": "The discount was applied to your upcoming subscription order. You’ll be able to get another discount once the next order is processed.",
                      "subscription-coupon-applied-message-color": "#707997",
                      "subscription-coupon-applied-message-title": "",
                      "subscription-divider-color": "#c2cdf4",
                      "subscription-headline-color": "#666d8b",
                      "subscription-headline-font-size": "14",
                      "subscription-points-headline-text": "YOUR POINT BALANCE",
                      "subscription-points-subtitle-text": "{{current_point_balance}} Points",
                      "subscription-redemptions-description": "Choose a discount option that will automatically apply to your next subscription order.",
                      "subscription-redemptions-headline": "Redeem for Subscription Discount",
                      "subscription-subtitle-color": "#768cdc",
                      "subscription-subtitle-font-size": "20",
                      "undefined": "Only for brands using Shopify’s new customer accounts and have program eligibility set to “only members who signed up.”",
                      "view-layout": "full-layout"
                    },
                    staticContent: {
                      "cssEditorEnabled": true,
                      "currency": "PLN",
                      "isHidden": false,
                      "isMultiCurrencyEnabled": true,
                      "isOptInFlowEnabled": false,
                      "isShopifyNewAccountsVersion": false,
                      "merchantId": "181985",
                      "platformName": "shopify",
                      "storeId": "yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK",
                      "storeLoginUrl": "/account/login",
                      "subunitsPerUnit": 100
                    },
                    className: "CouponsRedemptionWidget",
                    dependencyGroupId: 2
                },
            
                "1056880": {
                    instanceId: "1056880",
                    instanceVersionId: "347075645",
                    templateAssetUrl: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widget-loyalty-campaigns/app.v1.2.5-6990.js",
                    cssOverrideAssetUrl: "https://cdn-widget-assets.yotpo.com/CampaignWidget/pc-_zsvJHOoRaZ3ebWa_rg/css-overrides/css-overrides.2025_03_12_02_37_48_399.css",
                    customizationCssUrl: "",
                    customizations: {
                      "campaign-description-font-color": "#6C6C6C",
                      "campaign-description-size": "16px",
                      "campaign-item-1436740-background-color": "rgba(252,250,238,1)",
                      "campaign-item-1436740-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-1436740-background-type": "color",
                      "campaign-item-1436740-border-color": "rgba(0,0,0,0)",
                      "campaign-item-1436740-description-font-color": "rgba(43,42,165,1)",
                      "campaign-item-1436740-description-font-size": 14,
                      "campaign-item-1436740-exclude_audience_names": [],
                      "campaign-item-1436740-hover-view-tile-message": "Gagnez 1 point pour chaque {{1_local_currency}} dépensé",
                      "campaign-item-1436740-icon-color": "#60a3a3",
                      "campaign-item-1436740-icon-type": "customIcon",
                      "campaign-item-1436740-icon-url": "https://cdn-widget-assets.yotpo.com/static_assets/pc-_zsvJHOoRaZ3ebWa_rg/images/image_2025_03_11_02_49_37_052",
                      "campaign-item-1436740-include_audience_ids": "1",
                      "campaign-item-1436740-include_audience_names": [
                        "All customers"
                      ],
                      "campaign-item-1436740-special-reward-enabled": "false",
                      "campaign-item-1436740-special-reward-headline-background-color": "#D2E3E3",
                      "campaign-item-1436740-special-reward-headline-text": "Just for you!",
                      "campaign-item-1436740-special-reward-headline-title-font-color": "#000000",
                      "campaign-item-1436740-special-reward-headline-title-font-size": "12",
                      "campaign-item-1436740-special-reward-tile-border-color": "#000000",
                      "campaign-item-1436740-tile-description": "POUR CHAQUE {{1_local_currency}} DÉPENSÉ",
                      "campaign-item-1436740-tile-reward": "1 COQUILLE",
                      "campaign-item-1436740-title-font-color": "rgba(43,42,165,1)",
                      "campaign-item-1436740-title-font-size": 26,
                      "campaign-item-1436740-type": "PointsForPurchasesCampaign",
                      "campaign-item-1462605-action-tile-ask-year": "true",
                      "campaign-item-1462605-action-tile-birthday-required-field-message": "This field is required",
                      "campaign-item-1462605-action-tile-birthday-thank-you-message": "Thanks! We're looking forward to helping you celebrate :)",
                      "campaign-item-1462605-action-tile-european-date-format": "true",
                      "campaign-item-1462605-action-tile-message-text": "If your birthday is within the next 30 days, your reward will be granted in delay, up to 30 days.",
                      "campaign-item-1462605-action-tile-month-names": "January,February,March,April,May,June,July,August,September,October,November,December",
                      "campaign-item-1462605-action-tile-title": "Gagnez 500 points le jour de votre anniversaire",
                      "campaign-item-1462605-background-color": "rgba(252,250,238,1)",
                      "campaign-item-1462605-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-1462605-background-type": "color",
                      "campaign-item-1462605-border-color": "rgba(0,0,0,0)",
                      "campaign-item-1462605-description-font-color": "rgba(43,42,165,1)",
                      "campaign-item-1462605-description-font-size": 14,
                      "campaign-item-1462605-exclude_audience_names": [],
                      "campaign-item-1462605-icon-color": "#60a3a3",
                      "campaign-item-1462605-icon-type": "customIcon",
                      "campaign-item-1462605-icon-url": "https://cdn-widget-assets.yotpo.com/static_assets/pc-_zsvJHOoRaZ3ebWa_rg/images/image_2025_03_11_02_52_50_057",
                      "campaign-item-1462605-include_audience_ids": "1",
                      "campaign-item-1462605-include_audience_names": [
                        "All customers"
                      ],
                      "campaign-item-1462605-special-reward-enabled": "false",
                      "campaign-item-1462605-special-reward-headline-background-color": "#D2E3E3",
                      "campaign-item-1462605-special-reward-headline-text": "Just for you!",
                      "campaign-item-1462605-special-reward-headline-title-font-color": "#000000",
                      "campaign-item-1462605-special-reward-headline-title-font-size": "12",
                      "campaign-item-1462605-special-reward-tile-border-color": "#000000",
                      "campaign-item-1462605-tile-description": "RÉCOMPENSE D'ANNIVERSAIRE",
                      "campaign-item-1462605-tile-reward": "200 COQUILLES",
                      "campaign-item-1462605-title-font-color": "rgba(43,42,165,1)",
                      "campaign-item-1462605-title-font-size": 26,
                      "campaign-item-1462605-type": "BirthdayCampaign",
                      "campaign-item-1466325-action-tile-action-text": "@the_odderside",
                      "campaign-item-1466325-action-tile-title": "Gagnez 20 points lorsque vous nous suivez sur Instagram",
                      "campaign-item-1466325-background-color": "rgba(252,250,238,1)",
                      "campaign-item-1466325-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-1466325-background-type": "color",
                      "campaign-item-1466325-border-color": "rgba(0,0,0,0)",
                      "campaign-item-1466325-description-font-color": "rgba(43,42,165,1)",
                      "campaign-item-1466325-description-font-size": 14,
                      "campaign-item-1466325-exclude_audience_names": [],
                      "campaign-item-1466325-icon-color": "#60a3a3",
                      "campaign-item-1466325-icon-type": "customIcon",
                      "campaign-item-1466325-icon-url": "https://cdn-widget-assets.yotpo.com/static_assets/pc-_zsvJHOoRaZ3ebWa_rg/images/image_2025_03_11_02_53_55_706",
                      "campaign-item-1466325-include_audience_ids": "1",
                      "campaign-item-1466325-include_audience_names": [
                        "All customers"
                      ],
                      "campaign-item-1466325-special-reward-enabled": "false",
                      "campaign-item-1466325-special-reward-headline-background-color": "#D2E3E3",
                      "campaign-item-1466325-special-reward-headline-text": "Just for you!",
                      "campaign-item-1466325-special-reward-headline-title-font-color": "#000000",
                      "campaign-item-1466325-special-reward-headline-title-font-size": "12",
                      "campaign-item-1466325-special-reward-tile-border-color": "#000000",
                      "campaign-item-1466325-tile-description": "SUIVEZ-NOUS SUR INSTAGRAM",
                      "campaign-item-1466325-tile-reward": "20 COQUILLES",
                      "campaign-item-1466325-title-font-color": "rgba(43,42,165,1)",
                      "campaign-item-1466325-title-font-size": 26,
                      "campaign-item-1466325-type": "InstagramFollowCampaign",
                      "campaign-item-1466686-action-tile-action-text": "Visiter la page",
                      "campaign-item-1466686-action-tile-title": "Gagnez 20 points lorsque vous visitez notre page",
                      "campaign-item-1466686-background-color": "rgba(252,250,238,1)",
                      "campaign-item-1466686-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-1466686-background-type": "color",
                      "campaign-item-1466686-border-color": "rgba(0,0,0,0)",
                      "campaign-item-1466686-description-font-color": "rgba(43,42,165,1)",
                      "campaign-item-1466686-description-font-size": 14,
                      "campaign-item-1466686-exclude_audience_names": [],
                      "campaign-item-1466686-icon-color": "#60a3a3",
                      "campaign-item-1466686-icon-type": "customIcon",
                      "campaign-item-1466686-icon-url": "https://cdn-widget-assets.yotpo.com/static_assets/pc-_zsvJHOoRaZ3ebWa_rg/images/image_2025_03_11_02_53_30_141",
                      "campaign-item-1466686-include_audience_ids": "1",
                      "campaign-item-1466686-include_audience_names": [
                        "All customers"
                      ],
                      "campaign-item-1466686-special-reward-enabled": "false",
                      "campaign-item-1466686-special-reward-headline-background-color": "#D2E3E3",
                      "campaign-item-1466686-special-reward-headline-text": "Just for you!",
                      "campaign-item-1466686-special-reward-headline-title-font-color": "#000000",
                      "campaign-item-1466686-special-reward-headline-title-font-size": "12",
                      "campaign-item-1466686-special-reward-tile-border-color": "#000000",
                      "campaign-item-1466686-tile-description": "SUIVRE TIKTOK",
                      "campaign-item-1466686-tile-reward": "600 COQUILLES",
                      "campaign-item-1466686-title-font-color": "rgba(43,42,165,1)",
                      "campaign-item-1466686-title-font-size": 26,
                      "campaign-item-1466686-type": "FacebookPageVisitCampaign",
                      "campaign-item-1569314-action-tile-action-text": "Visiter la page",
                      "campaign-item-1569314-action-tile-title": "Gagnez 20 points lorsque vous visitez notre page",
                      "campaign-item-1569314-background-color": "rgba(252,250,238,1)",
                      "campaign-item-1569314-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-1569314-background-type": "color",
                      "campaign-item-1569314-border-color": "rgba(0,0,0,0)",
                      "campaign-item-1569314-description-font-color": "rgba(43,42,165,1)",
                      "campaign-item-1569314-description-font-size": 14,
                      "campaign-item-1569314-exclude_audience_names": [],
                      "campaign-item-1569314-icon-color": "#60a3a3",
                      "campaign-item-1569314-icon-type": "customIcon",
                      "campaign-item-1569314-icon-url": "https://cdn-widget-assets.yotpo.com/static_assets/pc-_zsvJHOoRaZ3ebWa_rg/images/image_2025_03_11_02_54_25_355",
                      "campaign-item-1569314-include_audience_ids": "1",
                      "campaign-item-1569314-include_audience_names": [
                        "All customers"
                      ],
                      "campaign-item-1569314-special-reward-enabled": "false",
                      "campaign-item-1569314-special-reward-headline-background-color": "#D2E3E3",
                      "campaign-item-1569314-special-reward-headline-text": "Just for you!",
                      "campaign-item-1569314-special-reward-headline-title-font-color": "#000000",
                      "campaign-item-1569314-special-reward-headline-title-font-size": "12",
                      "campaign-item-1569314-special-reward-tile-border-color": "#000000",
                      "campaign-item-1569314-tile-description": "SUIVRE SUR FACEBOOK",
                      "campaign-item-1569314-tile-reward": "20 COQUILLES",
                      "campaign-item-1569314-title-font-color": "rgba(43,42,165,1)",
                      "campaign-item-1569314-title-font-size": 26,
                      "campaign-item-1569314-type": "FacebookPageVisitCampaign",
                      "campaign-item-1569340-action-tile-action-text": "S'abonner",
                      "campaign-item-1569340-action-tile-title": "Gagnez 40 points lorsque vous terminez cette action",
                      "campaign-item-1569340-background-color": "rgba(252,250,238,1)",
                      "campaign-item-1569340-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-1569340-background-type": "color",
                      "campaign-item-1569340-border-color": "rgba(0,0,0,0)",
                      "campaign-item-1569340-custom-action-tile-action-url": "https://theodderside.com/#:~:text=BEZ%20U%C5%BBYCIA%20PLASTIKU.-,JOIN%20THE%20CLUB,-Zapisz%20si%C4%99%20do",
                      "campaign-item-1569340-description-font-color": "rgba(43,42,165,1)",
                      "campaign-item-1569340-description-font-size": 14,
                      "campaign-item-1569340-exclude_audience_names": [],
                      "campaign-item-1569340-icon-color": "#60a3a3",
                      "campaign-item-1569340-icon-type": "customIcon",
                      "campaign-item-1569340-icon-url": "https://cdn-widget-assets.yotpo.com/static_assets/pc-_zsvJHOoRaZ3ebWa_rg/images/image_2025_03_11_02_54_45_089",
                      "campaign-item-1569340-include_audience_ids": "1",
                      "campaign-item-1569340-include_audience_names": [
                        "All customers"
                      ],
                      "campaign-item-1569340-special-reward-enabled": "false",
                      "campaign-item-1569340-special-reward-headline-background-color": "#D2E3E3",
                      "campaign-item-1569340-special-reward-headline-text": "Just for you!",
                      "campaign-item-1569340-special-reward-headline-title-font-color": "#000000",
                      "campaign-item-1569340-special-reward-headline-title-font-size": "12",
                      "campaign-item-1569340-special-reward-tile-border-color": "#000000",
                      "campaign-item-1569340-tile-description": "ABONNEZ-VOUS À NOTRE NEWSLETTER",
                      "campaign-item-1569340-tile-reward": "40 COQUILLES",
                      "campaign-item-1569340-title-font-color": "rgba(43,42,165,1)",
                      "campaign-item-1569340-title-font-size": 26,
                      "campaign-item-1569340-type": "CustomActionCampaign",
                      "campaign-item-1569340-view-show-custom-action-button": "true",
                      "campaign-item-1589237-background-color": "rgba(252,250,238,1)",
                      "campaign-item-1589237-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-1589237-background-type": "color",
                      "campaign-item-1589237-border-color": "rgba(0,0,0,0)",
                      "campaign-item-1589237-description-font-color": "rgba(43,42,165,1)",
                      "campaign-item-1589237-description-font-size": 14,
                      "campaign-item-1589237-exclude_audience_names": "",
                      "campaign-item-1589237-hover-view-tile-message": "Earn 250 points when you make 1 purchase",
                      "campaign-item-1589237-icon-color": "#60a3a3",
                      "campaign-item-1589237-icon-type": "customIcon",
                      "campaign-item-1589237-icon-url": "https://cdn-widget-assets.yotpo.com/static_assets/pc-_zsvJHOoRaZ3ebWa_rg/images/image_2025_03_26_10_16_29_612",
                      "campaign-item-1589237-include_audience_ids": "1",
                      "campaign-item-1589237-include_audience_names": "All customers",
                      "campaign-item-1589237-special-reward-enabled": "false",
                      "campaign-item-1589237-special-reward-headline-background-color": "#D2E3E3",
                      "campaign-item-1589237-special-reward-headline-text": "Just for you!",
                      "campaign-item-1589237-special-reward-headline-title-font-color": "#000000",
                      "campaign-item-1589237-special-reward-headline-title-font-size": "12",
                      "campaign-item-1589237-special-reward-tile-border-color": "#000000",
                      "campaign-item-1589237-tile-description": "Make your first purchase  | Pierwsze zamówienie w klubie",
                      "campaign-item-1589237-tile-reward": "500 points",
                      "campaign-item-1589237-title-font-color": "rgba(43,42,165,1)",
                      "campaign-item-1589237-title-font-size": 26,
                      "campaign-item-1589237-type": "TransactionBasedCampaign",
                      "campaign-title-font-color": "#000000",
                      "campaign-title-size": "20px",
                      "completed-tile-headline": "Complété",
                      "completed-tile-message": "Vous avez déjà utilisé cette option",
                      "container-headline": "FAÇONS DE GAGNER",
                      "general-hover-tile-button-color": "rgba(43,42,165,1)",
                      "general-hover-tile-button-text-color": "#FFFFFF",
                      "general-hover-tile-button-type": "filled_rectangle",
                      "general-hover-tile-color-overlay": "rgba(220,218,225,1)",
                      "general-hover-tile-text-color": "rgba(43,42,165,1)",
                      "headline-color": "rgba(43,42,165,1)",
                      "headline-font-color": "rgba(43,42,165,1)",
                      "headline-font-size": 40,
                      "layout-background-color": "rgba(254,253,249,1)",
                      "layout-background-enabled": "true",
                      "logged-in-non-member-button-text": "Join now",
                      "logged-in-non-member-link-destination": "banner_section",
                      "logged-out-is-redirect-after-login-to-current-page": "true",
                      "logged-out-message": "Déjà membre ? Connectez-vous",
                      "logged-out-sign-in-text": "SE CONNECTER",
                      "logged-out-sign-up-text": "REJOIGNEZ LE CLUB",
                      "main-text-font-name-and-url": "founders-grotesk-regular@400|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK/founders-grotesk-regular/founders-grotesk-regular-400.css",
                      "secondary-text-font-name-and-url": "founders-grotesk-regular@400|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK/founders-grotesk-regular/founders-grotesk-regular-400.css",
                      "selected-audiences": "1",
                      "selected-extensions": [
                        "1436740",
                        "1589237",
                        "1462605",
                        "1466686",
                        "1569314",
                        "1466325",
                        "1569340"
                      ],
                      "special-reward-enabled": "false",
                      "special-reward-headline-background-color": "#D2E3E3",
                      "special-reward-headline-text": "Special for you",
                      "special-reward-headline-title-font-color": "#000000",
                      "special-reward-headline-title-font-size": "12",
                      "special-reward-tile-border-color": "#000000",
                      "tile-border-color": "#BCBCBC",
                      "tile-spacing-type": "small",
                      "tiles-background-color": "#FFFFFF",
                      "time-between-rewards-days": "Vous serez à nouveau éligible dans *|jours|* jours",
                      "time-between-rewards-hours": "Vous serez à nouveau éligible dans *|heures|* heures"
                    },
                    staticContent: {
                      "companyName": "The Odder Side",
                      "cssEditorEnabled": true,
                      "currency": "PLN",
                      "facebookAppId": "1647129615540489",
                      "isHidden": false,
                      "isMultiCurrencyEnabled": true,
                      "isOptInFlowEnabled": false,
                      "isSegmentationsPickerEnabled": true,
                      "isShopifyNewAccountsVersion": false,
                      "merchantId": "181985",
                      "platformName": "shopify",
                      "storeAccountLoginUrl": "//theodderside.com/account/login",
                      "storeAccountRegistrationUrl": "//theodderside.com/account/register",
                      "storeId": "yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK"
                    },
                    className: "CampaignWidget",
                    dependencyGroupId: 2
                },
            
                "1056879": {
                    instanceId: "1056879",
                    instanceVersionId: "347175231",
                    templateAssetUrl: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widget-my-rewards/app.v1.4.7-7088.js",
                    cssOverrideAssetUrl: "https://cdn-widget-assets.yotpo.com/MyRewardsWidget/pc-_zsvJHOoRaZ3ebWa_rg/css-overrides/css-overrides.2025_03_12_02_48_50_268.css",
                    customizationCssUrl: "",
                    customizations: {
                      "headline-color": "rgba(43,42,165,1)",
                      "headline-font-size": 40,
                      "layout-add-background": "true",
                      "layout-background-color": "rgba(254,253,249,1)",
                      "logged-in-description-color": "rgba(43,42,165,1)",
                      "logged-in-description-font-size": 40,
                      "logged-in-description-text": "{{current_point_balance}}",
                      "logged-in-description-tier-status-text": "{{current_vip_tier_name}} tier",
                      "logged-in-headline-color": "rgba(43,42,165,1)",
                      "logged-in-headline-font-size": 40,
                      "logged-in-headline-text": "Salut {{first_name}}!",
                      "logged-in-primary-button-cta-type": "redemptionWidget",
                      "logged-in-primary-button-text": "RACHETER MES COQUILLAGES",
                      "logged-in-secondary-button-text": "HISTORIQUE DES RÉCOMPENSES",
                      "logged-out-headline-color": "rgba(43,42,165,1)",
                      "logged-out-headline-font-size": 40,
                      "logged-out-headline-text": "COMMENT ÇA MARCHE",
                      "logged-out-selected-step-name": "step_3",
                      "primary-button-background-color": "rgba(43,42,165,1)",
                      "primary-button-text-color": "#FFFFFF",
                      "primary-button-type": "filled_rectangle",
                      "primary-font-name-and-url": "founders-grotesk-regular@400|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK/founders-grotesk-regular/founders-grotesk-regular-400.css",
                      "reward-step-1-displayname": "Step 1",
                      "reward-step-1-settings-description": "CRÉEZ UN COMPTE ET COMMENCEZ AVEC 100 COQUILLAGES - PARCE QUE TOUTE AMITIÉ COMMENCE PAR UN PREMIER PAS !",
                      "reward-step-1-settings-description-color": "rgba(43,42,165,1)",
                      "reward-step-1-settings-description-font-size": 14,
                      "reward-step-1-settings-icon": "custom",
                      "reward-step-1-settings-icon-color": "#000000",
                      "reward-step-1-settings-icon-url": "https://cdn-widget-assets.yotpo.com/static_assets/pc-_zsvJHOoRaZ3ebWa_rg/images/image_2025_03_11_02_24_37_427",
                      "reward-step-1-settings-title": "REJOIGNEZ LE CLUB",
                      "reward-step-1-settings-title-color": "rgba(43,42,165,1)",
                      "reward-step-1-settings-title-font-size": 30,
                      "reward-step-2-displayname": "Step 2",
                      "reward-step-2-settings-description": "COLLECTEZ DES COQUILLAGES À CHAQUE FOIS QUE VOUS FAITES DES ACHATS ET RAPPROCHEZ-VOUS DU STATUT DE MEILLEURS AMIS !",
                      "reward-step-2-settings-description-color": "rgba(43,42,165,1)",
                      "reward-step-2-settings-description-font-size": 14,
                      "reward-step-2-settings-icon": "custom",
                      "reward-step-2-settings-icon-color": "#000000",
                      "reward-step-2-settings-icon-url": "https://cdn-widget-assets.yotpo.com/static_assets/pc-_zsvJHOoRaZ3ebWa_rg/images/image_2025_03_11_02_25_42_389",
                      "reward-step-2-settings-title": "GAGNEZ DES COQUILLAGES",
                      "reward-step-2-settings-title-color": "rgba(43,42,165,1)",
                      "reward-step-2-settings-title-font-size": 30,
                      "reward-step-3-displayname": "Step 3",
                      "reward-step-3-settings-description": "UTILISEZ VOS COQUILLES POUR OBTENIR DES AVANTAGES EXCLUSIFS - PARCE QUE LES VRAIS AMIS MÉRITENT UN TRAITEMENT SPÉCIAL !",
                      "reward-step-3-settings-description-color": "rgba(43,42,165,1)",
                      "reward-step-3-settings-description-font-size": 14,
                      "reward-step-3-settings-icon": "custom",
                      "reward-step-3-settings-icon-color": "#000000",
                      "reward-step-3-settings-icon-url": "https://cdn-widget-assets.yotpo.com/static_assets/pc-_zsvJHOoRaZ3ebWa_rg/images/image_2025_03_11_02_26_00_729",
                      "reward-step-3-settings-title": "DÉBLOQUEZ DES RÉCOMPENSES",
                      "reward-step-3-settings-title-color": "rgba(43,42,165,1)",
                      "reward-step-3-settings-title-font-size": 30,
                      "rewards-history-approved-text": "Approuvée",
                      "rewards-history-background-color": "rgba(255,255,255,0.83)",
                      "rewards-history-headline-color": "rgba(43,42,165,1)",
                      "rewards-history-headline-font-size": "26",
                      "rewards-history-headline-text": "HISTORIQUE DES RÉCOMPENSES",
                      "rewards-history-pending-text": "En attente",
                      "rewards-history-refunded-text": "Remboursé",
                      "rewards-history-reversed-text": "Renversée",
                      "rewards-history-table-action-col-text": "Action",
                      "rewards-history-table-date-col-text": "Date",
                      "rewards-history-table-expiration-col-text": "Les points expirent le",
                      "rewards-history-table-points-col-text": "Points",
                      "rewards-history-table-status-col-text": "Statut",
                      "rewards-history-table-store-col-text": "Store",
                      "secondary-button-background-color": "rgba(43,42,165,1)",
                      "secondary-button-text-color": "rgba(254,253,249,1)",
                      "secondary-button-type": "filled_rectangle",
                      "secondary-font-name-and-url": "founders-grotesk-regular@400|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK/founders-grotesk-regular/founders-grotesk-regular-400.css",
                      "show-logged-in-description-points-balance": true,
                      "show-logged-in-description-tier-status": false,
                      "view-grid-points-column-color": "rgba(43,42,165,1)",
                      "view-grid-rectangular-background-color": "#F6F1EE",
                      "view-grid-type": "border"
                    },
                    staticContent: {
                      "cssEditorEnabled": true,
                      "currency": "PLN",
                      "isHidden": false,
                      "isMultiCurrencyEnabled": true,
                      "isMultiStoreMerchant": false,
                      "isOptInFlowEnabled": false,
                      "isShopifyNewAccountsVersion": false,
                      "isVipTiersEnabled": true,
                      "merchantId": "181985",
                      "platformName": "shopify",
                      "storeId": "yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK"
                    },
                    className: "MyRewardsWidget",
                    dependencyGroupId: 2
                },
            
                "1056878": {
                    instanceId: "1056878",
                    instanceVersionId: "327451083",
                    templateAssetUrl: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widget-hero-section/app.v1.7.13-7014.js",
                    cssOverrideAssetUrl: "https://cdn-widget-assets.yotpo.com/HeroSectionWidget/pc-_zsvJHOoRaZ3ebWa_rg/css-overrides/css-overrides.2025_03_12_02_23_04_459.css",
                    customizationCssUrl: "",
                    customizations: {
                      "background-image-url": "https://cdn-widget-assets.yotpo.com/static_assets/pc-_zsvJHOoRaZ3ebWa_rg/images/image_2025_03_10_00_00_52_800",
                      "description-color": "rgba(43,42,165,1)",
                      "description-font-size": 24,
                      "description-text-logged-in": "CHAQUE ACHAT VOUS RAPPROCHE DU STATUT DE MEILLEURS AMIES. GAGNEZ DES COQUILLAGES ET DÉBLOQUEZ DES RÉCOMPENSES !",
                      "description-text-logged-out": "COLLECTIONNEZ DES COQUILLAGES ET DÉBLOQUEZ DES AVANTAGES EXCLUSIFS À CHAQUE ACHAT !",
                      "headline-color": "rgba(43,42,165,1)",
                      "headline-font-size": 120,
                      "headline-text-logged-in": "BIENVENUE AU CLUB",
                      "headline-text-logged-in-non-member": "You’re a step away from rewards!",
                      "headline-text-logged-in-subtitle-text-non-member": "Join our rewards program and earn points and exclusive rewards every time you shop.",
                      "headline-text-logged-out": "REJOIGNEZ LE CLUB",
                      "login-button-color": "rgba(252,250,238,1)",
                      "login-button-text": "Se connecter",
                      "login-button-text-color": "rgba(0,0,0,1)",
                      "login-button-type": "filled_rectangle",
                      "member-optin-disclaimer": "To customize the disclaimer and button asking non-members to join your program, go to \u003cb\u003ePage Settings.\u003c/b\u003e",
                      "mobile-background-image-url": "https://cdn-widget-assets.yotpo.com/static_assets/pc-_zsvJHOoRaZ3ebWa_rg/images/image_2025_03_10_23_44_50_341",
                      "mode-is-page-settings": false,
                      "primary-font-name-and-url": "founders-grotesk-regular@400|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK/founders-grotesk-regular/founders-grotesk-regular-400.css",
                      "register-button-color": "rgba(252,250,238,1)",
                      "register-button-text": "Inscrivez-vous maintenant",
                      "register-button-text-color": "rgba(0,0,0,1)",
                      "register-button-type": "filled_rectangle",
                      "reward-opt-in-join-now-button-label": "Complete program signup",
                      "rewards-disclaimer-text": "I agree to the program’s [terms](http://example.net/terms) and [privacy policy](http://example.net/privacy-policy)",
                      "rewards-disclaimer-text-color": "#00000",
                      "rewards-disclaimer-text-size": "12px",
                      "rewards-disclaimer-type": "no-disclaimer",
                      "secondary-font-name-and-url": "founders-grotesk-regular@400|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK/founders-grotesk-regular/founders-grotesk-regular-400.css",
                      "text-background-color": "#D2E3E3",
                      "text-background-show-on-desktop": false,
                      "text-background-show-on-mobile": false,
                      "view-layout": "center-layout"
                    },
                    staticContent: {
                      "cssEditorEnabled": true,
                      "isHidden": false,
                      "isOptInFlowEnabled": false,
                      "isShopifyNewAccountsVersion": false,
                      "merchantId": "181985",
                      "platformName": "shopify",
                      "storeId": "yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK",
                      "storeLoginUrl": "//theodderside.com/account/login",
                      "storeRegistrationUrl": "//theodderside.com/account/register"
                    },
                    className: "HeroSectionWidget",
                    dependencyGroupId: 2
                },
            
                "1056877": {
                    instanceId: "1056877",
                    instanceVersionId: "328716218",
                    templateAssetUrl: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widget-loyalty-page/app.v0.6.3-7159.js",
                    cssOverrideAssetUrl: "",
                    customizationCssUrl: "",
                    customizations: {
                      "headline-color": "rgba(43,42,165,1)",
                      "headline-font-size": 40,
                      "page-background-color": "",
                      "primary-font-name-and-url": "founders-grotesk-regular@400|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK/founders-grotesk-regular/founders-grotesk-regular-400.css",
                      "reward-opt-in-join-now-button-label": "Complete program signup",
                      "rewards-disclaimer-text": "I agree to the program’s [terms](http://example.net/terms) and [privacy policy](http://example.net/privacy-policy)",
                      "rewards-disclaimer-text-color": "#00000",
                      "rewards-disclaimer-text-size": "12px",
                      "rewards-disclaimer-type": "no-disclaimer",
                      "secondary-font-name-and-url": "founders-grotesk-regular@400|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK/founders-grotesk-regular/founders-grotesk-regular-400.css",
                      "selected-widgets-ids": [
                        "1056878",
                        "1056879",
                        "1056880",
                        "1056881",
                        "1056882",
                        "1056883"
                      ],
                      "widget-1056878-type": "HeroSectionWidget",
                      "widget-1056879-type": "MyRewardsWidget",
                      "widget-1056880-type": "CampaignWidget",
                      "widget-1056881-type": null,
                      "widget-1056882-type": "VipTiersWidget",
                      "widget-1056883-type": "ReferralShareWidget",
                      "widget-1056884-type": "VisualRedemptionWidget"
                    },
                    staticContent: {
                      "isHidden": false,
                      "isOptInFlowEnabled": false,
                      "platformName": "shopify",
                      "storeId": "yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK"
                    },
                    className: "LoyaltyPageWidget",
                    dependencyGroupId: null
                },
            
                "1056232": {
                    instanceId: "1056232",
                    instanceVersionId: "327451097",
                    templateAssetUrl: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widget-visual-redemption/app.v1.1.3-6746.js",
                    cssOverrideAssetUrl: "https://cdn-widget-assets.yotpo.com/VisualRedemptionWidget/pc-_zsvJHOoRaZ3ebWa_rg/css-overrides/css-overrides.2025_03_11_03_14_08_617.css",
                    customizationCssUrl: "",
                    customizations: {
                      "description-color": "rgba(43,42,165,1)",
                      "description-font-size": 14,
                      "headline-color": "rgba(43,42,165,1)",
                      "headline-font-size": 40,
                      "layout-add-background": "true",
                      "layout-background-color": "rgba(254,253,249,1)",
                      "primary-font-name-and-url": "founders-grotesk-regular@400|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK/founders-grotesk-regular/founders-grotesk-regular-400.css",
                      "redemption-1-displayname": "Tile 1",
                      "redemption-1-settings-cost": "x 500",
                      "redemption-1-settings-cost-color": "rgba(43,42,165,1)",
                      "redemption-1-settings-cost-font-size": 20,
                      "redemption-1-settings-frame-color": "rgba(0,0,0,0)",
                      "redemption-1-settings-reward": "20 PLN OFF",
                      "redemption-1-settings-reward-color": "rgba(43,42,165,1)",
                      "redemption-1-settings-reward-font-size": 55,
                      "redemption-2-displayname": "Tile 2",
                      "redemption-2-settings-cost": "x 1000",
                      "redemption-2-settings-cost-color": "rgba(43,42,165,1)",
                      "redemption-2-settings-cost-font-size": 20,
                      "redemption-2-settings-frame-color": "rgba(0,0,0,0)",
                      "redemption-2-settings-reward": "40 PLN OFF",
                      "redemption-2-settings-reward-color": "rgba(43,42,165,1)",
                      "redemption-2-settings-reward-font-size": 55,
                      "redemption-3-displayname": "Tile 3",
                      "redemption-3-settings-cost": "x 2000",
                      "redemption-3-settings-cost-color": "rgba(43,42,165,1)",
                      "redemption-3-settings-cost-font-size": 20,
                      "redemption-3-settings-frame-color": "rgba(0,0,0,0)",
                      "redemption-3-settings-reward": "80 PLN OFF",
                      "redemption-3-settings-reward-color": "rgba(43,42,165,1)",
                      "redemption-3-settings-reward-font-size": 55,
                      "rule-color": "rgba(43,42,165,1)",
                      "rule-dots-color": "rgba(0,0,0,0)",
                      "rule-font-size": 20,
                      "secondary-font-name-and-url": "founders-grotesk-regular@400|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK/founders-grotesk-regular/founders-grotesk-regular-400.css",
                      "selected-extensions": [
                        "1",
                        "2",
                        "3"
                      ],
                      "view-layout": "full-layout",
                      "visual-redemption-description": "REDEEMING YOUR SHELLS IS EASY! \nJUST CLICK REDEEM MY SHELLS, AND SELECT AN ELIGIBLE REWARD.",
                      "visual-redemption-headline": "HOW TO USE YOUR SHELLS",
                      "visual-redemption-rule": "x 100 EQUALS 1 PLN"
                    },
                    staticContent: {
                      "cssEditorEnabled": true,
                      "currency": "PLN",
                      "isHidden": false,
                      "isMultiCurrencyEnabled": true,
                      "isShopifyNewAccountsVersion": false,
                      "platformName": "shopify",
                      "storeId": "yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK"
                    },
                    className: "VisualRedemptionWidget",
                    dependencyGroupId: 2
                },
            
                "1056231": {
                    instanceId: "1056231",
                    instanceVersionId: "347075654",
                    templateAssetUrl: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widget-referral-share/app.v0.4.24-7079.js",
                    cssOverrideAssetUrl: "https://cdn-widget-assets.yotpo.com/ReferralShareWidget/pc-_zsvJHOoRaZ3ebWa_rg/css-overrides/css-overrides.2025_03_12_00_32_47_060.css",
                    customizationCssUrl: "",
                    customizations: {
                      "background-color": "rgba(0,0,0,0)",
                      "customer-email-view-button-text": "Next",
                      "customer-email-view-description-discount-discount": "Give your friends {{friend_reward}} their first purchase of {{min_spent}}, and get {{customer_reward}} for each successful referral.",
                      "customer-email-view-description-discount-points": "Give your friends {{friend_reward}} their first purchase of {{min_spent}}, and get {{customer_reward}} points for each successful referral.",
                      "customer-email-view-description-nothing-discount": "Get {{customer_reward}} for each successful referral.",
                      "customer-email-view-description-nothing-points": "Get {{customer_reward}} points for each successful referral.",
                      "customer-email-view-description-points-discount": "Give your friends {{friend_reward}} points, and get {{customer_reward}} for each successful referral.",
                      "customer-email-view-description-points-points": "Give your friends {{friend_reward}} points, and get {{customer_reward}} points for each successful referral.",
                      "customer-email-view-header": "Refer a Friend",
                      "customer-email-view-input-placeholder": "Your email address",
                      "customer-email-view-title-discount-discount": "GIVE {{friend_reward}}, GET {{customer_reward}}",
                      "customer-email-view-title-discount-points": "GIVE {{friend_reward}}, GET {{customer_reward}} POINTS",
                      "customer-email-view-title-nothing-discount": "REFER A FRIEND, GET {{customer_reward}} FOR REFERRALS",
                      "customer-email-view-title-nothing-points": "REFER A FRIEND, GET {{customer_reward}} POINTS FOR REFERRALS",
                      "customer-email-view-title-points-discount": "GIVE {{friend_reward}} POINTS, GET {{customer_reward}}",
                      "customer-email-view-title-points-points": "GIVE {{friend_reward}} POINTS, GET {{customer_reward}} POINTS",
                      "customer-name-view-input-placeholder": "Your name",
                      "default-toggle": true,
                      "description-color": "rgba(252,250,238,1)",
                      "description-font-size": "24px",
                      "desktop-background-image-url": "https://cdn-widget-assets.yotpo.com/static_assets/pc-_zsvJHOoRaZ3ebWa_rg/images/image_2025_03_11_04_49_21_356",
                      "disabled-referral-code-error": "Wygląda na to, że Twój link polecający został dezaktywowany",
                      "email-fill-color": "#F6F1EE",
                      "email-input-type": "rounded_rectangle",
                      "email-outline-color": "#000000",
                      "email-text-color": "#000000",
                      "final-view-button-text": "POLEĆ WIĘCEJ ZNAJOMYCH",
                      "final-view-description": "Remind your friends to check their email",
                      "final-view-error-description": "Udostępnienie linku polecającego nie powiodło się.Wróć do poprzedniego kroku i spróbuj ponownie.",
                      "final-view-error-text": "WRÓĆ",
                      "final-view-error-title": "Coś poszło nie tak.",
                      "final-view-title": "DZIĘKUJEMY ZA POLECENIE!",
                      "fonts-primary-font-name-and-url": "founders-grotesk-regular@400|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK/founders-grotesk-regular/founders-grotesk-regular-400.css",
                      "fonts-secondary-font-name-and-url": "founders-grotesk-regular@400|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK/founders-grotesk-regular/founders-grotesk-regular-400.css",
                      "header-color": "rgba(252,250,238,1)",
                      "header-font-size": "14px",
                      "headline-color": "rgba(43,42,165,1)",
                      "headline-font-size": 40,
                      "login-view-description-discount-discount": "Give your friends {{friend_reward}} their first purchase of {{min_spent}}, and get {{customer_reward}} for each successful referral.",
                      "login-view-description-discount-points": "Give your friends {{friend_reward}} their first purchase of {{min_spent}}, and get {{customer_reward}} points for each successful referral.",
                      "login-view-description-nothing-discount": "Get {{customer_reward}} for each successful referral.",
                      "login-view-description-nothing-points": "ZA PIERWSZE ZAMÓWIENIE TWOJEJ BESTIE ZA 400ZŁ +",
                      "login-view-description-points-discount": "Give your friends {{friend_reward}} points, and get {{customer_reward}} for each successful referral.",
                      "login-view-description-points-points": "Give your friends {{friend_reward}} points, and get {{customer_reward}} points for each successful referral.",
                      "login-view-header": "ZAPROŚ BESTIES I ZBIERAJ SHELLS",
                      "login-view-log-in-button-text": "ZALOGUJ SIĘ",
                      "login-view-sign-up-button-text": "DOŁĄCZ TERAZ",
                      "login-view-title-discount-discount": "GIVE {{friend_reward}}, GET {{customer_reward}}",
                      "login-view-title-discount-points": "GIVE {{friend_reward}}, GET {{customer_reward}} POINTS",
                      "login-view-title-nothing-discount": "REFER A FRIEND, GET {{customer_reward}} FOR REFERRALS",
                      "login-view-title-nothing-points": "ZDOBĄDŹ 500 SHELLS",
                      "login-view-title-points-discount": "GIVE {{friend_reward}} POINTS, GET {{customer_reward}}",
                      "login-view-title-points-points": "GIVE {{friend_reward}} POINTS, GET {{customer_reward}} POINTS",
                      "main-share-option-desktop": "main_share_copy_link",
                      "main-share-option-mobile": "main_share_sms",
                      "mobile-background-image-url": "https://cdn-widget-assets.yotpo.com/static_assets/pc-_zsvJHOoRaZ3ebWa_rg/images/image_2025_03_11_04_49_26_424",
                      "more-share-ways-text": "MORE WAYS TO SHARE",
                      "primary-button-background-color": "rgba(43,42,165,1)",
                      "primary-button-font-size": "16px",
                      "primary-button-size": "standard",
                      "primary-button-text-color": "rgba(252,250,238,1)",
                      "primary-button-type": "filled_rectangle",
                      "reduced-picture": true,
                      "referral-history-completed-points-text": "{{points}} POINTS",
                      "referral-history-completed-status-type": "text",
                      "referral-history-confirmed-status": "Completed",
                      "referral-history-pending-status": "Pending",
                      "referral-history-redeem-text": "You can redeem your points for a reward, or apply your reward code at checkout.",
                      "referral-history-sumup-line-points-text": "{{points}} POINTS",
                      "referral-history-sumup-line-text": "Your Rewards",
                      "referral-views-button-text": "Next",
                      "referral-views-copy-link-button-text": "Copy link",
                      "referral-views-description-discount-discount": "Give your friends {{friend_reward}} their first purchase of {{min_spent}}, and get {{customer_reward}} for each successful referral.",
                      "referral-views-description-discount-points": "Give your friends {{friend_reward}} their first purchase of {{min_spent}}, and get {{customer_reward}} points for each successful referral.",
                      "referral-views-description-nothing-discount": "Get {{customer_reward}} for each successful referral.",
                      "referral-views-description-nothing-points": "ZA PIERWSZE ZAMÓWIENIE TWOJEJ BESTIE ZA 400ZŁ +\nBO KAŻDA PRZYJAŹŃ ZACZYNA SIĘ OD PIERWSZEGO KROKU!",
                      "referral-views-description-points-discount": "Give your friends {{friend_reward}} points, and get {{customer_reward}} for each successful referral.",
                      "referral-views-description-points-points": "Give your friends {{friend_reward}} points, and get {{customer_reward}} points for each successful referral.",
                      "referral-views-email-share-body": "How does a discount off your first order at {{company_name}} sound? Use the link below and once you've shopped, I'll get a reward too.\n{{referral_link}}",
                      "referral-views-email-share-subject": "Discount to a Store You'll Love!",
                      "referral-views-email-share-type": "personal_email",
                      "referral-views-friends-input-placeholder": "Friend’s email address",
                      "referral-views-header": "POLEĆ NAS SWOIM BESTIES",
                      "referral-views-personal-email-button-text": "Share via email",
                      "referral-views-sms-button-text": "Wyślij przez SMS",
                      "referral-views-title-discount-discount": "GIVE {{friend_reward}}, GET {{customer_reward}}",
                      "referral-views-title-discount-points": "GIVE {{friend_reward}}, GET {{customer_reward}} POINTS",
                      "referral-views-title-nothing-discount": "REFER A FRIEND, GET {{customer_reward}} FOR REFERRALS",
                      "referral-views-title-nothing-points": "ZDOBĄDŹ 500 SHELLS",
                      "referral-views-title-points-discount": "GIVE {{friend_reward}} POINTS, GET {{customer_reward}}",
                      "referral-views-title-points-points": "GIVE {{friend_reward}} POINTS, GET {{customer_reward}} POINTS",
                      "referral-views-whatsapp-button-text": "Share via WhatsApp",
                      "secondary-button-background-color": "rgba(43,42,165,1)",
                      "secondary-button-text-color": "rgba(252,250,238,1)",
                      "secondary-button-type": "filled_rectangle",
                      "share-allow-copy-link": true,
                      "share-allow-email": true,
                      "share-allow-sms": true,
                      "share-allow-whatsapp": true,
                      "share-headline-text-color": "rgba(252,250,238,1)",
                      "share-icons-color": "rgba(252,250,238,1)",
                      "share-settings-copyLink": true,
                      "share-settings-default-checkbox": true,
                      "share-settings-default-mobile-checkbox": true,
                      "share-settings-email": true,
                      "share-settings-mobile-copyLink": true,
                      "share-settings-mobile-email": true,
                      "share-settings-mobile-sms": true,
                      "share-settings-mobile-whatsapp": true,
                      "share-settings-whatsapp": true,
                      "share-sms-message": "I love {{company_name}}! Shop through my link to get a reward {{referral_link}}",
                      "share-whatsapp-message": "I love {{company_name}}! Shop through my link to get a reward {{referral_link}}",
                      "tab-size": "small",
                      "tab-type": "lower_line",
                      "tab-view-primary-tab-text": "Refer a Friend",
                      "tab-view-secondary-tab-text": "Your Referrals",
                      "tile-color": "rgba(0,0,0,0)",
                      "title-color": "rgba(252,250,238,1)",
                      "title-font-size": "40px",
                      "view-exit-intent-enabled": false,
                      "view-exit-intent-mobile-timeout-ms": 10000,
                      "view-is-popup": false,
                      "view-layout": "centered",
                      "view-popup-delay-ms": 0,
                      "view-show-customer-name": false,
                      "view-show-popup-on-exit": false,
                      "view-show-referral-history": false,
                      "view-table-rectangular-dark-pending-color": "rgba( 0, 0, 0, 0.6 )",
                      "view-table-rectangular-light-pending-color": "#FFFFFF",
                      "view-table-selected-color": "#0F8383",
                      "view-table-theme": "dark",
                      "view-table-type": "lines",
                      "wadmin-text-and-share-choose-sreen": "step_2"
                    },
                    staticContent: {
                      "advocateLoggedInRequirement": true,
                      "advocateRewardType": "POINTS",
                      "companyName": "The Odder Side",
                      "cssEditorEnabled": true,
                      "currency": "PLN",
                      "friendRewardType": "NOTHING",
                      "hasPrimaryFontsFeature": true,
                      "isFreeMerchant": false,
                      "isHidden": false,
                      "isMultiCurrencyEnabled": true,
                      "merchantId": "181985",
                      "migrateTabColorToBackground": true,
                      "platformName": "shopify",
                      "referralHistoryEnabled": true,
                      "referralHost": "http://rwrd.io",
                      "storeId": "yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK"
                    },
                    className: "ReferralShareWidget",
                    dependencyGroupId: null
                },
            
                "1056230": {
                    instanceId: "1056230",
                    instanceVersionId: "327451071",
                    templateAssetUrl: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widget-vip-tiers/app.v2.2.4-6882.js",
                    cssOverrideAssetUrl: "https://cdn-widget-assets.yotpo.com/VipTiersWidget/pc-_zsvJHOoRaZ3ebWa_rg/css-overrides/css-overrides.2025_03_12_13_17_15_322.css",
                    customizationCssUrl: "",
                    customizations: {
                      "background-color": "rgba(254,253,249,1)",
                      "background-enabled": "true",
                      "benefits-font-size": "14px",
                      "benefits-icon-color": "#89BABA",
                      "benefits-icon-type": "custom",
                      "benefits-icon-url": "https://cdn-widget-assets.yotpo.com/static_assets/pc-_zsvJHOoRaZ3ebWa_rg/images/image_2025_03_11_03_18_04_364",
                      "benefits-text-color": "rgba(43,42,165,1)",
                      "card-background-border-color": "rgba(0,0,0,0)",
                      "card-background-color": "rgba(252,250,238,1)",
                      "card-background-shadow": "false",
                      "card-separator-color": "#BCBCBC",
                      "card-separator-enabled": "false",
                      "current-status-bg-color": "rgba(252,250,238,1)",
                      "current-status-tag": "true",
                      "current-status-text": "AKTUALNY STATUS ",
                      "current-status-text-color": "rgba(43,42,165,1)",
                      "current-tier-border-color": "rgba(0,0,0,0)",
                      "grid-lines-color": "#ACB5D4",
                      "headline-color": "rgba(43,42,165,1)",
                      "headline-font-size": 120,
                      "headline-text-color": "rgba(43,42,165,1)",
                      "layout": "card",
                      "primary-font-name-and-url": "founders-grotesk-regular@400|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK/founders-grotesk-regular/founders-grotesk-regular-400.css",
                      "progress-bar-current-status": "{{amount_spent}} WYDANE",
                      "progress-bar-enabled": "true",
                      "progress-bar-headline-font-size": "14px",
                      "progress-bar-primary-color": "rgba(43,42,165,1)",
                      "progress-bar-secondary-color": "rgba(43,42,165,1)",
                      "progress-bar-summary-current": "Aktualny status {{current_vip_tier_name}} ",
                      "progress-bar-summary-font-size": "14px",
                      "progress-bar-summary-maintain": "Wydaj {{spend_needed}} do {{tier_expiration_date}},aby zachować status  {{current_vip_tier_name}}",
                      "progress-bar-summary-next": "Wydaj {{spend_needed}} aby odblokować status {{next_vip_tier_name}}.",
                      "progress-bar-tier-status": "TWÓJ STATUS W KLUBIE",
                      "progress-bar-you": "AKTUALNIE",
                      "secondary-font-name-and-url": "founders-grotesk-regular@400|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK/founders-grotesk-regular/founders-grotesk-regular-400.css",
                      "selected-extensions": [
                        "30768",
                        "30769",
                        "30770",
                        "30846"
                      ],
                      "show-less-text": "- Pokaż mniej",
                      "show-more-text": "+ Pokaż więcej",
                      "tier-spacing": "small",
                      "tiers-30768-design-header-bg-color": "#FFFFFF",
                      "tiers-30768-design-icon-fill-color": "#0F8383",
                      "tiers-30768-design-icon-type": "custom",
                      "tiers-30768-design-icon-url": "https://cdn-widget-assets.yotpo.com/static_assets/pc-_zsvJHOoRaZ3ebWa_rg/images/image_2025_03_11_04_16_57_463",
                      "tiers-30768-design-include-header-bg": "false",
                      "tiers-30768-design-name-font-size": "24px",
                      "tiers-30768-design-name-text-color": "rgba(43,42,165,1)",
                      "tiers-30768-design-threshold-font-size": "14px",
                      "tiers-30768-design-threshold-text-color": "rgba(43,42,165,1)",
                      "tiers-30768-text-benefits": "PREZENT URODZINOWY||ZBIERAJ SHELLS PRZY KAŻDYM ZAKUPIE",
                      "tiers-30768-text-name": "NEW FRIEND",
                      "tiers-30768-text-rank": 1,
                      "tiers-30768-text-threshold": "DOŁĄCZ DO KLUBU",
                      "tiers-30769-design-header-bg-color": "#FFFFFF",
                      "tiers-30769-design-icon-fill-color": "#0F8383",
                      "tiers-30769-design-icon-type": "custom",
                      "tiers-30769-design-icon-url": "https://cdn-widget-assets.yotpo.com/static_assets/pc-_zsvJHOoRaZ3ebWa_rg/images/image_2025_03_11_04_17_26_894",
                      "tiers-30769-design-include-header-bg": "false",
                      "tiers-30769-design-name-font-size": "24px",
                      "tiers-30769-design-name-text-color": "rgba(43,42,165,1)",
                      "tiers-30769-design-threshold-font-size": "14px",
                      "tiers-30769-design-threshold-text-color": "rgba(43,42,165,1)",
                      "tiers-30769-text-benefits": "SPECJALNY PREZENT URODZINOWY DLA CLOSE CIRCLE||ZBIERAJ SHELLS PRZY KAŻDYM ZAKUPIE||BONUS POWITALNY : 500 SHELLS",
                      "tiers-30769-text-name": "CLOSE CIRCLE",
                      "tiers-30769-text-rank": 2,
                      "tiers-30769-text-threshold": "WYDAJ {{amount_spent}}",
                      "tiers-30770-design-header-bg-color": "#FFFFFF",
                      "tiers-30770-design-icon-fill-color": "#0F8383",
                      "tiers-30770-design-icon-type": "custom",
                      "tiers-30770-design-icon-url": "https://cdn-widget-assets.yotpo.com/static_assets/pc-_zsvJHOoRaZ3ebWa_rg/images/image_2025_03_11_04_18_12_525",
                      "tiers-30770-design-include-header-bg": "false",
                      "tiers-30770-design-name-font-size": "24px",
                      "tiers-30770-design-name-text-color": "rgba(43,42,165,1)",
                      "tiers-30770-design-threshold-font-size": "14px",
                      "tiers-30770-design-threshold-text-color": "rgba(43,42,165,1)",
                      "tiers-30770-text-benefits": "SPECJALNY PREZENT URODZINOWY DLA PARTNER IN CRIME||ZBIERAJ SHELLS PRZY KAŻDYM ZAKUPIE||BONUS POWITALNY : 1000 SHELLS||DARMOWA STANDARDOWA WYSYŁKA||WCZEŚNIEJSZY DOSTĘP DO NOWYCH KOLEKCJI ||SHELLS X1.25",
                      "tiers-30770-text-name": "PARTNER IN CRIME",
                      "tiers-30770-text-rank": 3,
                      "tiers-30770-text-threshold": "WYDAJ {{amount_spent}}",
                      "tiers-30846-design-header-bg-color": "#FFFFFF",
                      "tiers-30846-design-icon-fill-color": "#0F8383",
                      "tiers-30846-design-icon-type": "custom",
                      "tiers-30846-design-icon-url": "https://cdn-widget-assets.yotpo.com/static_assets/pc-_zsvJHOoRaZ3ebWa_rg/images/image_2025_03_11_04_18_48_624",
                      "tiers-30846-design-include-header-bg": "false",
                      "tiers-30846-design-name-font-size": "24px",
                      "tiers-30846-design-name-text-color": "rgba(43,42,165,1)",
                      "tiers-30846-design-threshold-font-size": "14px",
                      "tiers-30846-design-threshold-text-color": "rgba(43,42,165,1)",
                      "tiers-30846-text-benefits": "SPECJALNY PREZENT URODZINOWY DLA BESTIES||ZBIERAJ SHELLS PRZY KAŻDYM ZAKUPIE||BONUS POWITALNY : 3000 SHELLS ||DARMOWA EKSPRESOWA WYSYŁKA||WCZEŚNIEJSZY DOSTĘP DO NOWYCH KOLEKCJI ||ZAPROSZENIA NA EVENTY THE ODDER SIDE||SHELLS X1.5",
                      "tiers-30846-text-name": "BESTIES",
                      "tiers-30846-text-rank": 4,
                      "tiers-30846-text-threshold": "WYDAJ {{amount_spent}}",
                      "widget-headline": "BESTIES ZYSKUJĄ WIĘCEJ"
                    },
                    staticContent: {
                      "cssEditorEnabled": true,
                      "currency": "PLN",
                      "isHidden": false,
                      "isMultiCurrencyEnabled": true,
                      "merchantId": "181985",
                      "platformName": "shopify",
                      "storeId": "yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK"
                    },
                    className: "VipTiersWidget",
                    dependencyGroupId: 2
                },
            
                "1056229": {
                    instanceId: "1056229",
                    instanceVersionId: "327451087",
                    templateAssetUrl: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widget-coupons-redemption/app.v1.1.13-7015.js",
                    cssOverrideAssetUrl: "https://cdn-widget-assets.yotpo.com/CouponsRedemptionWidget/pc-_zsvJHOoRaZ3ebWa_rg/css-overrides/css-overrides.2025_03_13_03_22_30_255.css",
                    customizationCssUrl: "",
                    customizations: {
                      "confirmation-step-cancel-option": "No",
                      "confirmation-step-confirm-option": "Yes",
                      "confirmation-step-title": "Are you sure?",
                      "coupon-background-type": "no-background",
                      "coupon-code-copied-message-body": "Thank you for redeeming your points. Please paste the code at checkout",
                      "coupon-code-copied-message-color": "#707997",
                      "coupon-code-copied-message-title": "",
                      "coupons-redemption-description": "WYKORZYSTANIE SHELLS JEST PROSTE!\nKLIKNIJ \"WYMIEŃ SHELLS\" I WYBIERZ SWOJĄ NAGRODĘ\n",
                      "coupons-redemption-headline": "JAK WYKORZYSTAĆ SHELLS?",
                      "coupons-redemption-rule": "x 25 TO {{1_local_currency}}",
                      "description-color": "rgba(43,42,165,1)",
                      "description-font-size": 14,
                      "discount-bigger-than-subscription-cost-text": "Your next subscription is lower than the redemption amount",
                      "donate-button-text": "Donate",
                      "donation-success-message-body": "Thank you for donating ${{donation_amount}} to {{company_name}}",
                      "donation-success-message-color": "#707997",
                      "donation-success-message-title": "Success",
                      "error-message-color": "#f04860",
                      "error-message-title": "",
                      "headline-color": "rgba(43,42,165,1)",
                      "headline-font-size": 40,
                      "layout-add-background": "true",
                      "layout-background-color": "rgba(254,253,249,1)",
                      "local-enable-opt-in-flow": false,
                      "local-member-optin-disclaimer": "Add a disclaimer and button asking non-members to join your program.",
                      "local-member-optin-disclaimer-part2": "To customize them, go to \u003cb\u003ePage Settings.\u003c/b\u003e",
                      "login-button-color": "rgba(43,42,165,1)",
                      "login-button-text": "WYMIEŃ SHELLS",
                      "login-button-text-color": "white",
                      "login-button-type": "filled_rectangle",
                      "message-font-size": "14",
                      "missing-points-amount-text": "You don't have enough points to redeem",
                      "next-subscription-headline-text": "NEXT ORDER",
                      "next-subscription-subtitle-text": "{{product_name}} {{next_order_amount}}",
                      "no-subscription-subtitle-text": "No ongoing subscriptions",
                      "point-balance-text": "POSIADASZ {{current_point_balance}} Shells",
                      "points-balance-color": "rgba(43,42,165,1)",
                      "points-balance-font-size": 20,
                      "points-balance-number-color": "rgba(43,42,165,1)",
                      "primary-font-name-and-url": "founders-grotesk-regular@400|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK/founders-grotesk-regular/founders-grotesk-regular-400.css",
                      "redeem-button-color": "#0F8383",
                      "redeem-button-text": "Redeem",
                      "redeem-button-text-color": "#FFFFFF",
                      "redeem-button-type": "rounded_filled_rectangle",
                      "redeem-frame-color": "#BCBCBC",
                      "redemption-942586-displayname": "20 zł off",
                      "redemption-942586-settings-button-color": "rgba(43,42,165,1)",
                      "redemption-942586-settings-button-text": "WYMIEŃ SHELLS",
                      "redemption-942586-settings-button-text-color": "#FFFFFF",
                      "redemption-942586-settings-button-type": "filled_rectangle",
                      "redemption-942586-settings-call-to-action-button-text": "Redeem",
                      "redemption-942586-settings-cost": 500,
                      "redemption-942586-settings-cost-color": "rgba(43,42,165,1)",
                      "redemption-942586-settings-cost-font-size": 20,
                      "redemption-942586-settings-cost-text": "x {{points}}",
                      "redemption-942586-settings-coupon-cost-font-size": "15",
                      "redemption-942586-settings-coupon-reward-font-size": "20",
                      "redemption-942586-settings-discount-amount-cents": 2000,
                      "redemption-942586-settings-discount-type": "fixed_amount",
                      "redemption-942586-settings-frame-color": "rgba(0,0,0,0)",
                      "redemption-942586-settings-reward": "{{20_local_currency}}",
                      "redemption-942586-settings-reward-color": "rgba(43,42,165,1)",
                      "redemption-942586-settings-reward-font-size": 55,
                      "redemption-942586-settings-success-message-text": "Reward Applied",
                      "redemption-942587-displayname": "40 zł off",
                      "redemption-942587-settings-button-color": "rgba(43,42,165,1)",
                      "redemption-942587-settings-button-text": "WYMIEŃ SHELLS",
                      "redemption-942587-settings-button-text-color": "#FFFFFF",
                      "redemption-942587-settings-button-type": "filled_rectangle",
                      "redemption-942587-settings-call-to-action-button-text": "Redeem",
                      "redemption-942587-settings-cost": 1000,
                      "redemption-942587-settings-cost-color": "rgba(43,42,165,1)",
                      "redemption-942587-settings-cost-font-size": 20,
                      "redemption-942587-settings-cost-text": "x {{points}}",
                      "redemption-942587-settings-coupon-cost-font-size": "15",
                      "redemption-942587-settings-coupon-reward-font-size": "20",
                      "redemption-942587-settings-discount-amount-cents": 4000,
                      "redemption-942587-settings-discount-type": "fixed_amount",
                      "redemption-942587-settings-frame-color": "rgba(0,0,0,0)",
                      "redemption-942587-settings-reward": "{{40_local_currency}}",
                      "redemption-942587-settings-reward-color": "rgba(43,42,165,1)",
                      "redemption-942587-settings-reward-font-size": 55,
                      "redemption-942587-settings-success-message-text": "Reward Applied",
                      "redemption-944048-displayname": "80 zł off",
                      "redemption-944048-settings-button-color": "rgba(43,42,165,1)",
                      "redemption-944048-settings-button-text": "WYMIEŃ SHELLS",
                      "redemption-944048-settings-button-text-color": "#FFFFFF",
                      "redemption-944048-settings-button-type": "filled_rectangle",
                      "redemption-944048-settings-call-to-action-button-text": "Redeem",
                      "redemption-944048-settings-cost": "2000",
                      "redemption-944048-settings-cost-color": "rgba(43,42,165,1)",
                      "redemption-944048-settings-cost-font-size": 20,
                      "redemption-944048-settings-cost-text": "x {{points}}",
                      "redemption-944048-settings-coupon-cost-font-size": "15",
                      "redemption-944048-settings-coupon-reward-font-size": "20",
                      "redemption-944048-settings-discount-amount-cents": "8000",
                      "redemption-944048-settings-discount-type": "fixed_amount",
                      "redemption-944048-settings-frame-color": "rgba(0,0,0,0)",
                      "redemption-944048-settings-reward": "{{80_local_currency}}",
                      "redemption-944048-settings-reward-color": "rgba(43,42,165,1)",
                      "redemption-944048-settings-reward-font-size": 55,
                      "redemption-944048-settings-success-message-text": "Reward Applied",
                      "reward-opt-in-join-now-button-label": "Complete program signup",
                      "rewards-disclaimer-text": "I agree to the program’s [terms](http://example.net/terms) and [privacy policy](http://example.net/privacy-policy)",
                      "rewards-disclaimer-text-color": "#00000",
                      "rewards-disclaimer-text-size": "12px",
                      "rewards-disclaimer-type": "no-disclaimer",
                      "rule-color": "rgba(43,42,165,1)",
                      "rule-dots-color": "rgba(0,0,0,0)",
                      "rule-font-size": 20,
                      "secondary-font-name-and-url": "founders-grotesk-regular@400|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK/founders-grotesk-regular/founders-grotesk-regular-400.css",
                      "selected-extensions": [
                        "942586",
                        "942587",
                        "944048"
                      ],
                      "selected-redemptions-modes": "regular",
                      "subscription-coupon-applied-message-body": "The discount was applied to your upcoming subscription order. You’ll be able to get another discount once the next order is processed.",
                      "subscription-coupon-applied-message-color": "#707997",
                      "subscription-coupon-applied-message-title": "",
                      "subscription-divider-color": "#c2cdf4",
                      "subscription-headline-color": "#666d8b",
                      "subscription-headline-font-size": "14",
                      "subscription-points-headline-text": "YOUR POINT BALANCE",
                      "subscription-points-subtitle-text": "{{current_point_balance}} Points",
                      "subscription-redemptions-description": "Choose a discount option that will automatically apply to your next subscription order.",
                      "subscription-redemptions-headline": "Redeem for Subscription Discount",
                      "subscription-subtitle-color": "#768cdc",
                      "subscription-subtitle-font-size": "20",
                      "undefined": "Only for brands using Shopify’s new customer accounts and have program eligibility set to “only members who signed up.”",
                      "view-layout": "full-layout"
                    },
                    staticContent: {
                      "cssEditorEnabled": true,
                      "currency": "PLN",
                      "isHidden": false,
                      "isMultiCurrencyEnabled": true,
                      "isOptInFlowEnabled": false,
                      "isShopifyNewAccountsVersion": false,
                      "merchantId": "181985",
                      "platformName": "shopify",
                      "storeId": "yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK",
                      "storeLoginUrl": "/account/login",
                      "subunitsPerUnit": 100
                    },
                    className: "CouponsRedemptionWidget",
                    dependencyGroupId: 2
                },
            
                "1056228": {
                    instanceId: "1056228",
                    instanceVersionId: "347075644",
                    templateAssetUrl: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widget-loyalty-campaigns/app.v1.2.5-6990.js",
                    cssOverrideAssetUrl: "https://cdn-widget-assets.yotpo.com/CampaignWidget/pc-_zsvJHOoRaZ3ebWa_rg/css-overrides/css-overrides.2025_03_12_02_37_48_399.css",
                    customizationCssUrl: "",
                    customizations: {
                      "campaign-description-font-color": "#6C6C6C",
                      "campaign-description-size": "16px",
                      "campaign-item-1436740-background-color": "rgba(252,250,238,1)",
                      "campaign-item-1436740-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-1436740-background-type": "color",
                      "campaign-item-1436740-border-color": "rgba(0,0,0,0)",
                      "campaign-item-1436740-description-font-color": "rgba(43,42,165,1)",
                      "campaign-item-1436740-description-font-size": 14,
                      "campaign-item-1436740-exclude_audience_names": [],
                      "campaign-item-1436740-hover-view-tile-message": "KAŻDY KROK PRZYBLIŻA CIĘ DO STATUSU BESTIES!",
                      "campaign-item-1436740-icon-color": "#60a3a3",
                      "campaign-item-1436740-icon-type": "customIcon",
                      "campaign-item-1436740-icon-url": "https://cdn-widget-assets.yotpo.com/static_assets/pc-_zsvJHOoRaZ3ebWa_rg/images/image_2025_03_11_02_49_37_052",
                      "campaign-item-1436740-include_audience_ids": "1",
                      "campaign-item-1436740-include_audience_names": [
                        "All customers"
                      ],
                      "campaign-item-1436740-special-reward-enabled": "false",
                      "campaign-item-1436740-special-reward-headline-background-color": "#D2E3E3",
                      "campaign-item-1436740-special-reward-headline-text": "Just for you!",
                      "campaign-item-1436740-special-reward-headline-title-font-color": "#000000",
                      "campaign-item-1436740-special-reward-headline-title-font-size": "12",
                      "campaign-item-1436740-special-reward-tile-border-color": "#000000",
                      "campaign-item-1436740-tile-description": "ZA KAŻDĄ WYDANĄ {{1_local_currency}} ",
                      "campaign-item-1436740-tile-reward": "1 SHELL",
                      "campaign-item-1436740-title-font-color": "rgba(43,42,165,1)",
                      "campaign-item-1436740-title-font-size": 26,
                      "campaign-item-1436740-type": "PointsForPurchasesCampaign",
                      "campaign-item-1462605-action-tile-ask-year": "true",
                      "campaign-item-1462605-action-tile-birthday-required-field-message": "To pole jest wymagane.",
                      "campaign-item-1462605-action-tile-birthday-thank-you-message": "DZIĘKI! JUŻ NIE MOŻEMY SIĘ DOCZEKAĆ ŚWIĘTOWANIA Z TOBĄ!",
                      "campaign-item-1462605-action-tile-european-date-format": "true",
                      "campaign-item-1462605-action-tile-message-text": "JEŚLI TWOJE URODZINY SĄ W CIĄGU NAJBLIŻSZYCH 30 DNI, OTRZYMANIE NAGRODY MOŻE SIĘ NIECO OPÓŹNIĆ –DOTRZE W CIĄGU MIESIĄCA.",
                      "campaign-item-1462605-action-tile-month-names": "January,February,March,April,May,June,July,August,September,October,November,December",
                      "campaign-item-1462605-action-tile-title": "BO BESTIES ZAWSZE ŚWIĘTUJĄ RAZEM!",
                      "campaign-item-1462605-background-color": "rgba(252,250,238,1)",
                      "campaign-item-1462605-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-1462605-background-type": "color",
                      "campaign-item-1462605-border-color": "rgba(0,0,0,0)",
                      "campaign-item-1462605-description-font-color": "rgba(43,42,165,1)",
                      "campaign-item-1462605-description-font-size": 14,
                      "campaign-item-1462605-exclude_audience_names": [],
                      "campaign-item-1462605-icon-color": "#60a3a3",
                      "campaign-item-1462605-icon-type": "customIcon",
                      "campaign-item-1462605-icon-url": "https://cdn-widget-assets.yotpo.com/static_assets/pc-_zsvJHOoRaZ3ebWa_rg/images/image_2025_03_11_02_52_50_057",
                      "campaign-item-1462605-include_audience_ids": "1",
                      "campaign-item-1462605-include_audience_names": [
                        "All customers"
                      ],
                      "campaign-item-1462605-special-reward-enabled": "false",
                      "campaign-item-1462605-special-reward-headline-background-color": "#D2E3E3",
                      "campaign-item-1462605-special-reward-headline-text": "Just for you!",
                      "campaign-item-1462605-special-reward-headline-title-font-color": "#000000",
                      "campaign-item-1462605-special-reward-headline-title-font-size": "12",
                      "campaign-item-1462605-special-reward-tile-border-color": "#000000",
                      "campaign-item-1462605-tile-description": "PREZENT URODZINOWY",
                      "campaign-item-1462605-tile-reward": "600 SHELLS",
                      "campaign-item-1462605-title-font-color": "rgba(43,42,165,1)",
                      "campaign-item-1462605-title-font-size": 26,
                      "campaign-item-1462605-type": "BirthdayCampaign",
                      "campaign-item-1466325-action-tile-action-text": "@the_odderside",
                      "campaign-item-1466325-action-tile-title": "BĄDŹ NA BIEŻĄCO I ZGARNIAJ NAGRODY!",
                      "campaign-item-1466325-background-color": "rgba(252,250,238,1)",
                      "campaign-item-1466325-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-1466325-background-type": "color",
                      "campaign-item-1466325-border-color": "rgba(0,0,0,0)",
                      "campaign-item-1466325-description-font-color": "rgba(43,42,165,1)",
                      "campaign-item-1466325-description-font-size": 14,
                      "campaign-item-1466325-exclude_audience_names": [],
                      "campaign-item-1466325-icon-color": "#60a3a3",
                      "campaign-item-1466325-icon-type": "customIcon",
                      "campaign-item-1466325-icon-url": "https://cdn-widget-assets.yotpo.com/static_assets/pc-_zsvJHOoRaZ3ebWa_rg/images/image_2025_03_11_02_53_55_706",
                      "campaign-item-1466325-include_audience_ids": "1",
                      "campaign-item-1466325-include_audience_names": [
                        "All customers"
                      ],
                      "campaign-item-1466325-special-reward-enabled": "false",
                      "campaign-item-1466325-special-reward-headline-background-color": "#D2E3E3",
                      "campaign-item-1466325-special-reward-headline-text": "Just for you!",
                      "campaign-item-1466325-special-reward-headline-title-font-color": "#000000",
                      "campaign-item-1466325-special-reward-headline-title-font-size": "12",
                      "campaign-item-1466325-special-reward-tile-border-color": "#000000",
                      "campaign-item-1466325-tile-description": "INSTAGRAM FOLLOW",
                      "campaign-item-1466325-tile-reward": "20 SHELLS",
                      "campaign-item-1466325-title-font-color": "rgba(43,42,165,1)",
                      "campaign-item-1466325-title-font-size": 26,
                      "campaign-item-1466325-type": "InstagramFollowCampaign",
                      "campaign-item-1466686-action-tile-action-text": "@the_odderside",
                      "campaign-item-1466686-action-tile-title": "BĄDŹ NA BIEŻĄCO I ZGARNIAJ NAGRODY!",
                      "campaign-item-1466686-background-color": "rgba(252,250,238,1)",
                      "campaign-item-1466686-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-1466686-background-type": "color",
                      "campaign-item-1466686-border-color": "rgba(0,0,0,0)",
                      "campaign-item-1466686-description-font-color": "rgba(43,42,165,1)",
                      "campaign-item-1466686-description-font-size": 14,
                      "campaign-item-1466686-exclude_audience_names": [],
                      "campaign-item-1466686-icon-color": "#60a3a3",
                      "campaign-item-1466686-icon-type": "customIcon",
                      "campaign-item-1466686-icon-url": "https://cdn-widget-assets.yotpo.com/static_assets/pc-_zsvJHOoRaZ3ebWa_rg/images/image_2025_03_11_02_53_30_141",
                      "campaign-item-1466686-include_audience_ids": "1",
                      "campaign-item-1466686-include_audience_names": [
                        "All customers"
                      ],
                      "campaign-item-1466686-special-reward-enabled": "false",
                      "campaign-item-1466686-special-reward-headline-background-color": "#D2E3E3",
                      "campaign-item-1466686-special-reward-headline-text": "Just for you!",
                      "campaign-item-1466686-special-reward-headline-title-font-color": "#000000",
                      "campaign-item-1466686-special-reward-headline-title-font-size": "12",
                      "campaign-item-1466686-special-reward-tile-border-color": "#000000",
                      "campaign-item-1466686-tile-description": "TIKTOK FOLLOW",
                      "campaign-item-1466686-tile-reward": "20 SHELLS",
                      "campaign-item-1466686-title-font-color": "rgba(43,42,165,1)",
                      "campaign-item-1466686-title-font-size": 26,
                      "campaign-item-1466686-type": "FacebookPageVisitCampaign",
                      "campaign-item-1569314-action-tile-action-text": "ODWIEDŹ NAS",
                      "campaign-item-1569314-action-tile-title": "BĄDŹ NA BIEŻĄCO I ZGARNIAJ NAGRODY!",
                      "campaign-item-1569314-background-color": "rgba(252,250,238,1)",
                      "campaign-item-1569314-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-1569314-background-type": "color",
                      "campaign-item-1569314-border-color": "rgba(0,0,0,0)",
                      "campaign-item-1569314-description-font-color": "rgba(43,42,165,1)",
                      "campaign-item-1569314-description-font-size": 14,
                      "campaign-item-1569314-exclude_audience_names": [],
                      "campaign-item-1569314-icon-color": "#60a3a3",
                      "campaign-item-1569314-icon-type": "customIcon",
                      "campaign-item-1569314-icon-url": "https://cdn-widget-assets.yotpo.com/static_assets/pc-_zsvJHOoRaZ3ebWa_rg/images/image_2025_03_11_02_54_25_355",
                      "campaign-item-1569314-include_audience_ids": "1",
                      "campaign-item-1569314-include_audience_names": [
                        "All customers"
                      ],
                      "campaign-item-1569314-special-reward-enabled": "false",
                      "campaign-item-1569314-special-reward-headline-background-color": "#D2E3E3",
                      "campaign-item-1569314-special-reward-headline-text": "Just for you!",
                      "campaign-item-1569314-special-reward-headline-title-font-color": "#000000",
                      "campaign-item-1569314-special-reward-headline-title-font-size": "12",
                      "campaign-item-1569314-special-reward-tile-border-color": "#000000",
                      "campaign-item-1569314-tile-description": "FACEBOOK FOLLOW",
                      "campaign-item-1569314-tile-reward": "20 SHELLS",
                      "campaign-item-1569314-title-font-color": "rgba(43,42,165,1)",
                      "campaign-item-1569314-title-font-size": 26,
                      "campaign-item-1569314-type": "FacebookPageVisitCampaign",
                      "campaign-item-1569340-action-tile-action-text": "DOŁĄCZ",
                      "campaign-item-1569340-action-tile-title": "ZYSKAJ DOSTĘP DO NOWOŚCI, DROPÓW I EKSKLUZYWNYCH KORZYŚCI!",
                      "campaign-item-1569340-background-color": "rgba(252,250,238,1)",
                      "campaign-item-1569340-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-1569340-background-type": "color",
                      "campaign-item-1569340-border-color": "rgba(0,0,0,0)",
                      "campaign-item-1569340-custom-action-tile-action-url": "https://theodderside.com/#:~:text=BEZ%20U%C5%BBYCIA%20PLASTIKU.-,JOIN%20THE%20CLUB,-Zapisz%20si%C4%99%20do",
                      "campaign-item-1569340-description-font-color": "rgba(43,42,165,1)",
                      "campaign-item-1569340-description-font-size": 14,
                      "campaign-item-1569340-exclude_audience_names": [],
                      "campaign-item-1569340-icon-color": "#60a3a3",
                      "campaign-item-1569340-icon-type": "customIcon",
                      "campaign-item-1569340-icon-url": "https://cdn-widget-assets.yotpo.com/static_assets/pc-_zsvJHOoRaZ3ebWa_rg/images/image_2025_03_11_02_54_45_089",
                      "campaign-item-1569340-include_audience_ids": "1",
                      "campaign-item-1569340-include_audience_names": [
                        "All customers"
                      ],
                      "campaign-item-1569340-special-reward-enabled": "false",
                      "campaign-item-1569340-special-reward-headline-background-color": "#D2E3E3",
                      "campaign-item-1569340-special-reward-headline-text": "Just for you!",
                      "campaign-item-1569340-special-reward-headline-title-font-color": "#000000",
                      "campaign-item-1569340-special-reward-headline-title-font-size": "12",
                      "campaign-item-1569340-special-reward-tile-border-color": "#000000",
                      "campaign-item-1569340-tile-description": "ZAPISZ SIĘ DO NEWSLETTERA",
                      "campaign-item-1569340-tile-reward": "40 SHELLS",
                      "campaign-item-1569340-title-font-color": "rgba(43,42,165,1)",
                      "campaign-item-1569340-title-font-size": 26,
                      "campaign-item-1569340-type": "CustomActionCampaign",
                      "campaign-item-1569340-view-show-custom-action-button": "true",
                      "campaign-item-1589237-background-color": "rgba(252,250,238,1)",
                      "campaign-item-1589237-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-1589237-background-type": "color",
                      "campaign-item-1589237-border-color": "rgba(0,0,0,0)",
                      "campaign-item-1589237-description-font-color": "rgba(43,42,165,1)",
                      "campaign-item-1589237-description-font-size": 14,
                      "campaign-item-1589237-exclude_audience_names": "",
                      "campaign-item-1589237-hover-view-tile-message": "KAŻDY KROK PRZYBLIŻA CIĘ DO STATUSU BESTIES!",
                      "campaign-item-1589237-icon-color": "#60a3a3",
                      "campaign-item-1589237-icon-type": "customIcon",
                      "campaign-item-1589237-icon-url": "https://cdn-widget-assets.yotpo.com/static_assets/pc-_zsvJHOoRaZ3ebWa_rg/images/image_2025_03_26_10_15_11_668",
                      "campaign-item-1589237-include_audience_ids": "1",
                      "campaign-item-1589237-include_audience_names": "All customers",
                      "campaign-item-1589237-special-reward-enabled": "false",
                      "campaign-item-1589237-special-reward-headline-background-color": "#D2E3E3",
                      "campaign-item-1589237-special-reward-headline-text": "Just for you!",
                      "campaign-item-1589237-special-reward-headline-title-font-color": "#000000",
                      "campaign-item-1589237-special-reward-headline-title-font-size": "12",
                      "campaign-item-1589237-special-reward-tile-border-color": "#000000",
                      "campaign-item-1589237-tile-description": "PIERWSZE ZAMÓWIENIE JAKO CZŁONEK KLUBU",
                      "campaign-item-1589237-tile-reward": "500 SHELLS",
                      "campaign-item-1589237-title-font-color": "rgba(43,42,165,1)",
                      "campaign-item-1589237-title-font-size": 26,
                      "campaign-item-1589237-type": "TransactionBasedCampaign",
                      "campaign-title-font-color": "#000000",
                      "campaign-title-size": "20px",
                      "completed-tile-headline": "Gotowe ",
                      "completed-tile-message": "Ta opcja została już użyta.",
                      "container-headline": "JAK ZDOBYĆ SHELLS",
                      "general-hover-tile-button-color": "rgba(43,42,165,1)",
                      "general-hover-tile-button-text-color": "#FFFFFF",
                      "general-hover-tile-button-type": "filled_rectangle",
                      "general-hover-tile-color-overlay": "rgba(220,218,225,1)",
                      "general-hover-tile-text-color": "rgba(43,42,165,1)",
                      "headline-color": "rgba(43,42,165,1)",
                      "headline-font-color": "rgba(43,42,165,1)",
                      "headline-font-size": 40,
                      "layout-background-color": "rgba(254,253,249,1)",
                      "layout-background-enabled": "true",
                      "logged-in-non-member-button-text": "Join now",
                      "logged-in-non-member-link-destination": "banner_section",
                      "logged-out-is-redirect-after-login-to-current-page": "true",
                      "logged-out-message": "Masz już konto? ",
                      "logged-out-sign-in-text": "ZALOGUJ SIĘ",
                      "logged-out-sign-up-text": "JOIN THE CLUB",
                      "main-text-font-name-and-url": "founders-grotesk-regular@400|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK/founders-grotesk-regular/founders-grotesk-regular-400.css",
                      "secondary-text-font-name-and-url": "founders-grotesk-regular@400|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK/founders-grotesk-regular/founders-grotesk-regular-400.css",
                      "selected-audiences": "1",
                      "selected-extensions": [
                        "1436740",
                        "1589237",
                        "1462605",
                        "1466686",
                        "1466325",
                        "1569314",
                        "1569340"
                      ],
                      "special-reward-enabled": "false",
                      "special-reward-headline-background-color": "#D2E3E3",
                      "special-reward-headline-text": "Special for you",
                      "special-reward-headline-title-font-color": "#000000",
                      "special-reward-headline-title-font-size": "12",
                      "special-reward-tile-border-color": "#000000",
                      "tile-border-color": "#BCBCBC",
                      "tile-spacing-type": "small",
                      "tiles-background-color": "#FFFFFF",
                      "time-between-rewards-days": "Znów będziesz mógł/mogła skorzystać za *|days|* days",
                      "time-between-rewards-hours": "Znów będziesz mógł/mogła skorzystać za *|hours|* hours"
                    },
                    staticContent: {
                      "companyName": "The Odder Side",
                      "cssEditorEnabled": true,
                      "currency": "PLN",
                      "facebookAppId": "1647129615540489",
                      "isHidden": false,
                      "isMultiCurrencyEnabled": true,
                      "isOptInFlowEnabled": false,
                      "isSegmentationsPickerEnabled": true,
                      "isShopifyNewAccountsVersion": false,
                      "merchantId": "181985",
                      "platformName": "shopify",
                      "storeAccountLoginUrl": "//theodderside.com/account/login",
                      "storeAccountRegistrationUrl": "//theodderside.com/account/register",
                      "storeId": "yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK"
                    },
                    className: "CampaignWidget",
                    dependencyGroupId: 2
                },
            
                "1056227": {
                    instanceId: "1056227",
                    instanceVersionId: "347175228",
                    templateAssetUrl: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widget-my-rewards/app.v1.4.7-7088.js",
                    cssOverrideAssetUrl: "https://cdn-widget-assets.yotpo.com/MyRewardsWidget/pc-_zsvJHOoRaZ3ebWa_rg/css-overrides/css-overrides.2025_03_12_02_48_50_268.css",
                    customizationCssUrl: "",
                    customizations: {
                      "headline-color": "rgba(43,42,165,1)",
                      "headline-font-size": 40,
                      "layout-add-background": "true",
                      "layout-background-color": "rgba(254,253,249,1)",
                      "logged-in-description-color": "rgba(43,42,165,1)",
                      "logged-in-description-font-size": 40,
                      "logged-in-description-text": "{{current_point_balance}}",
                      "logged-in-description-tier-status-text": "{{current_vip_tier_name}} ",
                      "logged-in-headline-color": "rgba(43,42,165,1)",
                      "logged-in-headline-font-size": 40,
                      "logged-in-headline-text": "CZEŚĆ  {{first_name}}!",
                      "logged-in-primary-button-cta-type": "redemptionWidget",
                      "logged-in-primary-button-text": "WYMIEŃ SHELLS",
                      "logged-in-secondary-button-text": "HISTORIA NAGRÓD",
                      "logged-out-headline-color": "rgba(43,42,165,1)",
                      "logged-out-headline-font-size": 40,
                      "logged-out-headline-text": "JAK TO DZIAŁA",
                      "logged-out-selected-step-name": "step_3",
                      "primary-button-background-color": "rgba(43,42,165,1)",
                      "primary-button-text-color": "#FFFFFF",
                      "primary-button-type": "filled_rectangle",
                      "primary-font-name-and-url": "founders-grotesk-regular@400|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK/founders-grotesk-regular/founders-grotesk-regular-400.css",
                      "reward-step-1-displayname": "Step 1",
                      "reward-step-1-settings-description": "ZAŁÓŻ KONTO I OTRZYMAJ 100 SHELLS- BO KAŻDA PRZYJAŹŃ ZACZYNA SIĘ OD PIERWSZEGO KROKU!",
                      "reward-step-1-settings-description-color": "rgba(43,42,165,1)",
                      "reward-step-1-settings-description-font-size": 14,
                      "reward-step-1-settings-icon": "custom",
                      "reward-step-1-settings-icon-color": "#000000",
                      "reward-step-1-settings-icon-url": "https://cdn-widget-assets.yotpo.com/static_assets/pc-_zsvJHOoRaZ3ebWa_rg/images/image_2025_03_11_02_24_37_427",
                      "reward-step-1-settings-title": "DOŁĄCZ DO KLUBU",
                      "reward-step-1-settings-title-color": "rgba(43,42,165,1)",
                      "reward-step-1-settings-title-font-size": 30,
                      "reward-step-2-displayname": "Step 2",
                      "reward-step-2-settings-description": "ZBIERAJ SHELLS PRZY KAŻDYM ZAKUPIE I ZBLIŻAJ SIĘ DO STATUSU BESTIES!",
                      "reward-step-2-settings-description-color": "rgba(43,42,165,1)",
                      "reward-step-2-settings-description-font-size": 14,
                      "reward-step-2-settings-icon": "custom",
                      "reward-step-2-settings-icon-color": "#000000",
                      "reward-step-2-settings-icon-url": "https://cdn-widget-assets.yotpo.com/static_assets/pc-_zsvJHOoRaZ3ebWa_rg/images/image_2025_03_11_02_25_42_389",
                      "reward-step-2-settings-title": "ZBIERAJ SHELLS",
                      "reward-step-2-settings-title-color": "rgba(43,42,165,1)",
                      "reward-step-2-settings-title-font-size": 30,
                      "reward-step-3-displayname": "Step 3",
                      "reward-step-3-settings-description": "WYKORZYSTAJ SWOJE SHELLS, ABY ZGARNĄĆ EKSKLUZYWNE KORZYŚCI- BO PRAWDZIWI PRZYJACIELE ZASŁUGUJĄ NA COŚ WYJĄTKOWEGO!",
                      "reward-step-3-settings-description-color": "rgba(43,42,165,1)",
                      "reward-step-3-settings-description-font-size": 14,
                      "reward-step-3-settings-icon": "custom",
                      "reward-step-3-settings-icon-color": "#000000",
                      "reward-step-3-settings-icon-url": "https://cdn-widget-assets.yotpo.com/static_assets/pc-_zsvJHOoRaZ3ebWa_rg/images/image_2025_03_11_02_26_00_729",
                      "reward-step-3-settings-title": "ODBLOKUJ NAGRODY",
                      "reward-step-3-settings-title-color": "rgba(43,42,165,1)",
                      "reward-step-3-settings-title-font-size": 30,
                      "rewards-history-approved-text": "Zatwierdzony",
                      "rewards-history-background-color": "rgba(255,255,255,0.83)",
                      "rewards-history-headline-color": "rgba(43,42,165,1)",
                      "rewards-history-headline-font-size": "26",
                      "rewards-history-headline-text": "HISTORIA NAGRÓD",
                      "rewards-history-pending-text": "oczekujący",
                      "rewards-history-refunded-text": "Zwrócono pieniądze",
                      "rewards-history-reversed-text": "anulowany",
                      "rewards-history-table-action-col-text": "Działanie",
                      "rewards-history-table-date-col-text": "Data",
                      "rewards-history-table-expiration-col-text": "Punkty wygasają dnia",
                      "rewards-history-table-points-col-text": "Punkty",
                      "rewards-history-table-status-col-text": "Status",
                      "rewards-history-table-store-col-text": "Store",
                      "secondary-button-background-color": "rgba(43,42,165,1)",
                      "secondary-button-text-color": "rgba(254,253,249,1)",
                      "secondary-button-type": "filled_rectangle",
                      "secondary-font-name-and-url": "founders-grotesk-regular@400|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK/founders-grotesk-regular/founders-grotesk-regular-400.css",
                      "show-logged-in-description-points-balance": true,
                      "show-logged-in-description-tier-status": true,
                      "view-grid-points-column-color": "rgba(43,42,165,1)",
                      "view-grid-rectangular-background-color": "#F6F1EE",
                      "view-grid-type": "border"
                    },
                    staticContent: {
                      "cssEditorEnabled": true,
                      "currency": "PLN",
                      "isHidden": false,
                      "isMultiCurrencyEnabled": true,
                      "isMultiStoreMerchant": false,
                      "isOptInFlowEnabled": false,
                      "isShopifyNewAccountsVersion": false,
                      "isVipTiersEnabled": true,
                      "merchantId": "181985",
                      "platformName": "shopify",
                      "storeId": "yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK"
                    },
                    className: "MyRewardsWidget",
                    dependencyGroupId: 2
                },
            
                "1056226": {
                    instanceId: "1056226",
                    instanceVersionId: "327451067",
                    templateAssetUrl: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widget-hero-section/app.v1.7.13-7014.js",
                    cssOverrideAssetUrl: "https://cdn-widget-assets.yotpo.com/HeroSectionWidget/pc-_zsvJHOoRaZ3ebWa_rg/css-overrides/css-overrides.2025_03_12_02_23_04_459.css",
                    customizationCssUrl: "",
                    customizations: {
                      "background-image-url": "https://cdn-widget-assets.yotpo.com/static_assets/pc-_zsvJHOoRaZ3ebWa_rg/images/image_2025_03_10_00_00_52_800",
                      "description-color": "rgba(43,42,165,1)",
                      "description-font-size": 24,
                      "description-text-logged-in": "KAŻDY ZAKUP PRZYBLIŻA CIĘ DO ZOSTANIA BESTIE! \nZBIERAJ SHELLS I ODBLOKUJ NAGRODY!",
                      "description-text-logged-out": "ZGARNIAJ SHELLS I WYMIENIAJ JE NA EKSKLUZYWNE KORZYŚCI PRZY KAŻDYM ZAKUPIE!",
                      "headline-color": "rgba(43,42,165,1)",
                      "headline-font-size": 120,
                      "headline-text-logged-in": "WELCOME TO THE CLUB",
                      "headline-text-logged-in-non-member": "You’re a step away from rewards!",
                      "headline-text-logged-in-subtitle-text-non-member": "Join our rewards program and earn points and exclusive rewards every time you shop.",
                      "headline-text-logged-out": "JOIN THE CLUB",
                      "login-button-color": "rgba(252,250,238,1)",
                      "login-button-text": "ZALOGUJ SIĘ ",
                      "login-button-text-color": "rgba(0,0,0,1)",
                      "login-button-type": "filled_rectangle",
                      "member-optin-disclaimer": "To customize the disclaimer and button asking non-members to join your program, go to \u003cb\u003ePage Settings.\u003c/b\u003e",
                      "mobile-background-image-url": "https://cdn-widget-assets.yotpo.com/static_assets/pc-_zsvJHOoRaZ3ebWa_rg/images/image_2025_03_10_23_44_50_341",
                      "mode-is-page-settings": false,
                      "primary-font-name-and-url": "founders-grotesk-regular@400|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK/founders-grotesk-regular/founders-grotesk-regular-400.css",
                      "register-button-color": "rgba(252,250,238,1)",
                      "register-button-text": "DOŁĄCZ TERAZ",
                      "register-button-text-color": "rgba(0,0,0,1)",
                      "register-button-type": "filled_rectangle",
                      "reward-opt-in-join-now-button-label": "Complete program signup",
                      "rewards-disclaimer-text": "I agree to the program’s [terms](http://example.net/terms) and [privacy policy](http://example.net/privacy-policy)",
                      "rewards-disclaimer-text-color": "#00000",
                      "rewards-disclaimer-text-size": "12px",
                      "rewards-disclaimer-type": "no-disclaimer",
                      "secondary-font-name-and-url": "founders-grotesk-regular@400|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK/founders-grotesk-regular/founders-grotesk-regular-400.css",
                      "text-background-color": "#D2E3E3",
                      "text-background-show-on-desktop": false,
                      "text-background-show-on-mobile": false,
                      "view-layout": "center-layout"
                    },
                    staticContent: {
                      "cssEditorEnabled": true,
                      "isHidden": false,
                      "isOptInFlowEnabled": false,
                      "isShopifyNewAccountsVersion": false,
                      "merchantId": "181985",
                      "platformName": "shopify",
                      "storeId": "yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK",
                      "storeLoginUrl": "//theodderside.com/account/login",
                      "storeRegistrationUrl": "//theodderside.com/account/register"
                    },
                    className: "HeroSectionWidget",
                    dependencyGroupId: 2
                },
            
                "1056225": {
                    instanceId: "1056225",
                    instanceVersionId: "344813080",
                    templateAssetUrl: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widget-loyalty-page/app.v0.6.3-7159.js",
                    cssOverrideAssetUrl: "",
                    customizationCssUrl: "",
                    customizations: {
                      "headline-color": "rgba(43,42,165,1)",
                      "headline-font-size": 40,
                      "page-background-color": "",
                      "primary-font-name-and-url": "founders-grotesk-regular@400|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK/founders-grotesk-regular/founders-grotesk-regular-400.css",
                      "reward-opt-in-join-now-button-label": "Complete program signup",
                      "rewards-disclaimer-text": "I agree to the program’s [terms](http://example.net/terms) and [privacy policy](http://example.net/privacy-policy)",
                      "rewards-disclaimer-text-color": "#00000",
                      "rewards-disclaimer-text-size": "12px",
                      "rewards-disclaimer-type": "no-disclaimer",
                      "secondary-font-name-and-url": "founders-grotesk-regular@400|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK/founders-grotesk-regular/founders-grotesk-regular-400.css",
                      "selected-widgets-ids": [
                        "1056226",
                        "1056227",
                        "1056228",
                        "1056229",
                        "1056230",
                        "1056231"
                      ],
                      "widget-1056226-type": "HeroSectionWidget",
                      "widget-1056227-type": "MyRewardsWidget",
                      "widget-1056228-type": "CampaignWidget",
                      "widget-1056229-type": null,
                      "widget-1056230-type": "VipTiersWidget",
                      "widget-1056231-type": "ReferralShareWidget",
                      "widget-1056232-type": "VisualRedemptionWidget"
                    },
                    staticContent: {
                      "isHidden": false,
                      "isOptInFlowEnabled": false,
                      "platformName": "shopify",
                      "storeId": "yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK"
                    },
                    className: "LoyaltyPageWidget",
                    dependencyGroupId: null
                },
            
                "1054000": {
                    instanceId: "1054000",
                    instanceVersionId: "347175229",
                    templateAssetUrl: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widget-my-rewards/app.v1.4.7-7088.js",
                    cssOverrideAssetUrl: "https://cdn-widget-assets.yotpo.com/MyRewardsWidget/pc-_zsvJHOoRaZ3ebWa_rg/css-overrides/css-overrides.2025_03_12_02_48_50_268.css",
                    customizationCssUrl: "",
                    customizations: {
                      "headline-color": "rgba(43,42,165,1)",
                      "headline-font-size": 40,
                      "layout-add-background": "true",
                      "layout-background-color": "rgba(254,253,249,1)",
                      "logged-in-description-color": "rgba(43,42,165,1)",
                      "logged-in-description-font-size": 40,
                      "logged-in-description-text": "{{current_point_balance}}",
                      "logged-in-description-tier-status-text": "{{current_vip_tier_name}} tier",
                      "logged-in-headline-color": "rgba(43,42,165,1)",
                      "logged-in-headline-font-size": 40,
                      "logged-in-headline-text": "Hi {{first_name}}!",
                      "logged-in-primary-button-cta-type": "redemptionWidget",
                      "logged-in-primary-button-text": "REDEEM MY SHELLS",
                      "logged-in-secondary-button-text": "REWARDS HISTORY",
                      "logged-out-headline-color": "rgba(43,42,165,1)",
                      "logged-out-headline-font-size": 40,
                      "logged-out-headline-text": "HOW IT WORKS",
                      "logged-out-selected-step-name": "step_3",
                      "primary-button-background-color": "rgba(43,42,165,1)",
                      "primary-button-text-color": "#FFFFFF",
                      "primary-button-type": "filled_rectangle",
                      "primary-font-name-and-url": "founders-grotesk-regular@400|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK/founders-grotesk-regular/founders-grotesk-regular-400.css",
                      "reward-step-1-displayname": "Step 1",
                      "reward-step-1-settings-description": "CREATE AN ACCOUNT AND START WITH 100 SHELLS - BECAUSE EVERY FRIENDSHIP STARTS WITH A FIRST STEP!",
                      "reward-step-1-settings-description-color": "rgba(43,42,165,1)",
                      "reward-step-1-settings-description-font-size": 14,
                      "reward-step-1-settings-icon": "custom",
                      "reward-step-1-settings-icon-color": "#000000",
                      "reward-step-1-settings-icon-url": "https://cdn-widget-assets.yotpo.com/static_assets/pc-_zsvJHOoRaZ3ebWa_rg/images/image_2025_03_11_02_24_37_427",
                      "reward-step-1-settings-title": "JOIN THE CLUB",
                      "reward-step-1-settings-title-color": "rgba(43,42,165,1)",
                      "reward-step-1-settings-title-font-size": 30,
                      "reward-step-2-displayname": "Step 2",
                      "reward-step-2-settings-description": "COLLECT SHELLS EVERY TIME YOU SHOP \u0026 MOVE CLOSER TO BESTIES STATUS!",
                      "reward-step-2-settings-description-color": "rgba(43,42,165,1)",
                      "reward-step-2-settings-description-font-size": 14,
                      "reward-step-2-settings-icon": "custom",
                      "reward-step-2-settings-icon-color": "#000000",
                      "reward-step-2-settings-icon-url": "https://cdn-widget-assets.yotpo.com/static_assets/pc-_zsvJHOoRaZ3ebWa_rg/images/image_2025_03_11_02_25_42_389",
                      "reward-step-2-settings-title": "EARN SHELLS",
                      "reward-step-2-settings-title-color": "rgba(43,42,165,1)",
                      "reward-step-2-settings-title-font-size": 30,
                      "reward-step-3-displayname": "Step 3",
                      "reward-step-3-settings-description": "USE YOUR SHELLS TO GET EXCLUSIVE PERKS - BECAUSE REAL FRIENDS DESERVE SPECIAL TREATMENT!",
                      "reward-step-3-settings-description-color": "rgba(43,42,165,1)",
                      "reward-step-3-settings-description-font-size": 14,
                      "reward-step-3-settings-icon": "custom",
                      "reward-step-3-settings-icon-color": "#000000",
                      "reward-step-3-settings-icon-url": "https://cdn-widget-assets.yotpo.com/static_assets/pc-_zsvJHOoRaZ3ebWa_rg/images/image_2025_03_11_02_26_00_729",
                      "reward-step-3-settings-title": "UNLOCK REWARDS",
                      "reward-step-3-settings-title-color": "rgba(43,42,165,1)",
                      "reward-step-3-settings-title-font-size": 30,
                      "rewards-history-approved-text": "Approved",
                      "rewards-history-background-color": "rgba(255,255,255,0.83)",
                      "rewards-history-headline-color": "rgba(43,42,165,1)",
                      "rewards-history-headline-font-size": "26",
                      "rewards-history-headline-text": "REWARDS HISTORY",
                      "rewards-history-pending-text": "Pending",
                      "rewards-history-refunded-text": "Refunded",
                      "rewards-history-reversed-text": "Reversed",
                      "rewards-history-table-action-col-text": "Action",
                      "rewards-history-table-date-col-text": "Date",
                      "rewards-history-table-expiration-col-text": "Points expire on",
                      "rewards-history-table-points-col-text": "Points",
                      "rewards-history-table-status-col-text": "Status",
                      "rewards-history-table-store-col-text": "Store",
                      "secondary-button-background-color": "rgba(43,42,165,1)",
                      "secondary-button-text-color": "rgba(254,253,249,1)",
                      "secondary-button-type": "filled_rectangle",
                      "secondary-font-name-and-url": "founders-grotesk-regular@400|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK/founders-grotesk-regular/founders-grotesk-regular-400.css",
                      "show-logged-in-description-points-balance": true,
                      "show-logged-in-description-tier-status": false,
                      "view-grid-points-column-color": "rgba(43,42,165,1)",
                      "view-grid-rectangular-background-color": "#F6F1EE",
                      "view-grid-type": "border"
                    },
                    staticContent: {
                      "cssEditorEnabled": true,
                      "currency": "PLN",
                      "isHidden": false,
                      "isMultiCurrencyEnabled": true,
                      "isMultiStoreMerchant": false,
                      "isOptInFlowEnabled": false,
                      "isShopifyNewAccountsVersion": false,
                      "isVipTiersEnabled": true,
                      "merchantId": "181985",
                      "platformName": "shopify",
                      "storeId": "yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK"
                    },
                    className: "MyRewardsWidget",
                    dependencyGroupId: 2
                },
            
                "1053999": {
                    instanceId: "1053999",
                    instanceVersionId: "347075655",
                    templateAssetUrl: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widget-referral-share/app.v0.4.24-7079.js",
                    cssOverrideAssetUrl: "https://cdn-widget-assets.yotpo.com/ReferralShareWidget/pc-_zsvJHOoRaZ3ebWa_rg/css-overrides/css-overrides.2025_03_12_00_32_47_060.css",
                    customizationCssUrl: "",
                    customizations: {
                      "background-color": "rgba(0,0,0,0)",
                      "customer-email-view-button-text": "Next",
                      "customer-email-view-description-discount-discount": "Give your friends {{friend_reward}} their first purchase of {{min_spent}}, and get {{customer_reward}} for each successful referral.",
                      "customer-email-view-description-discount-points": "Give your friends {{friend_reward}} their first purchase of {{min_spent}}, and get {{customer_reward}} points for each successful referral.",
                      "customer-email-view-description-nothing-discount": "Get {{customer_reward}} for each successful referral.",
                      "customer-email-view-description-nothing-points": "Get {{customer_reward}} points for each successful referral.",
                      "customer-email-view-description-points-discount": "Give your friends {{friend_reward}} points, and get {{customer_reward}} for each successful referral.",
                      "customer-email-view-description-points-points": "Give your friends {{friend_reward}} points, and get {{customer_reward}} points for each successful referral.",
                      "customer-email-view-header": "Refer a Friend",
                      "customer-email-view-input-placeholder": "Your email address",
                      "customer-email-view-title-discount-discount": "GIVE {{friend_reward}}, GET {{customer_reward}}",
                      "customer-email-view-title-discount-points": "GIVE {{friend_reward}}, GET {{customer_reward}} POINTS",
                      "customer-email-view-title-nothing-discount": "REFER A FRIEND, GET {{customer_reward}} FOR REFERRALS",
                      "customer-email-view-title-nothing-points": "REFER A FRIEND, GET {{customer_reward}} POINTS FOR REFERRALS",
                      "customer-email-view-title-points-discount": "GIVE {{friend_reward}} POINTS, GET {{customer_reward}}",
                      "customer-email-view-title-points-points": "GIVE {{friend_reward}} POINTS, GET {{customer_reward}} POINTS",
                      "customer-name-view-input-placeholder": "Your name",
                      "default-toggle": true,
                      "description-color": "rgba(252,250,238,1)",
                      "description-font-size": "24px",
                      "desktop-background-image-url": "https://cdn-widget-assets.yotpo.com/static_assets/pc-_zsvJHOoRaZ3ebWa_rg/images/image_2025_03_11_04_49_21_356",
                      "disabled-referral-code-error": "Looks like your referral link was deactivated",
                      "email-fill-color": "#F6F1EE",
                      "email-input-type": "rounded_rectangle",
                      "email-outline-color": "#000000",
                      "email-text-color": "#000000",
                      "final-view-button-text": "Refer more friends",
                      "final-view-description": "Remind your friends to check their email",
                      "final-view-error-description": "We were unable to share the referral link. Go back to the previous step to try again.",
                      "final-view-error-text": "Back",
                      "final-view-error-title": "Something went wrong",
                      "final-view-title": "Thank you for referring!",
                      "fonts-primary-font-name-and-url": "founders-grotesk-regular@400|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK/founders-grotesk-regular/founders-grotesk-regular-400.css",
                      "fonts-secondary-font-name-and-url": "founders-grotesk-regular@400|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK/founders-grotesk-regular/founders-grotesk-regular-400.css",
                      "header-color": "rgba(252,250,238,1)",
                      "header-font-size": "14px",
                      "headline-color": "rgba(43,42,165,1)",
                      "headline-font-size": 40,
                      "login-view-description-discount-discount": "Give your friends {{friend_reward}} their first purchase of {{min_spent}}, and get {{customer_reward}} for each successful referral.",
                      "login-view-description-discount-points": "Give your friends {{friend_reward}} their first purchase of {{min_spent}}, and get {{customer_reward}} points for each successful referral.",
                      "login-view-description-nothing-discount": "Get {{customer_reward}} for each successful referral.",
                      "login-view-description-nothing-points": "BECAUSE EVERY FRIENDSHIP STARTS WITH A FIRST STEP!",
                      "login-view-description-points-discount": "Give your friends {{friend_reward}} points, and get {{customer_reward}} for each successful referral.",
                      "login-view-description-points-points": "Give your friends {{friend_reward}} points, and get {{customer_reward}} points for each successful referral.",
                      "login-view-header": "INVITE YOUR FRIENDS \u0026 EARN SHELLS",
                      "login-view-log-in-button-text": "LOG IN",
                      "login-view-sign-up-button-text": "JOIN NOW",
                      "login-view-title-discount-discount": "GIVE {{friend_reward}}, GET {{customer_reward}}",
                      "login-view-title-discount-points": "GIVE {{friend_reward}}, GET {{customer_reward}} POINTS",
                      "login-view-title-nothing-discount": "REFER A FRIEND, GET {{customer_reward}} FOR REFERRALS",
                      "login-view-title-nothing-points": "GET 500 SHELLS",
                      "login-view-title-points-discount": "GIVE {{friend_reward}} POINTS, GET {{customer_reward}}",
                      "login-view-title-points-points": "GIVE {{friend_reward}} POINTS, GET {{customer_reward}} POINTS",
                      "main-share-option-desktop": "main_share_copy_link",
                      "main-share-option-mobile": "main_share_sms",
                      "mobile-background-image-url": "https://cdn-widget-assets.yotpo.com/static_assets/pc-_zsvJHOoRaZ3ebWa_rg/images/image_2025_03_11_04_49_26_424",
                      "more-share-ways-text": "MORE WAYS TO SHARE",
                      "primary-button-background-color": "rgba(43,42,165,1)",
                      "primary-button-font-size": "16px",
                      "primary-button-size": "standard",
                      "primary-button-text-color": "rgba(252,250,238,1)",
                      "primary-button-type": "filled_rectangle",
                      "reduced-picture": true,
                      "referral-history-completed-points-text": "{{points}} POINTS",
                      "referral-history-completed-status-type": "text",
                      "referral-history-confirmed-status": "Completed",
                      "referral-history-pending-status": "Pending",
                      "referral-history-redeem-text": "You can redeem your points for a reward, or apply your reward code at checkout.",
                      "referral-history-sumup-line-points-text": "{{points}} POINTS",
                      "referral-history-sumup-line-text": "Your Rewards",
                      "referral-views-button-text": "Next",
                      "referral-views-copy-link-button-text": "Copy link",
                      "referral-views-description-discount-discount": "Give your friends {{friend_reward}} their first purchase of {{min_spent}}, and get {{customer_reward}} for each successful referral.",
                      "referral-views-description-discount-points": "Give your friends {{friend_reward}} their first purchase of {{min_spent}}, and get {{customer_reward}} points for each successful referral.",
                      "referral-views-description-nothing-discount": "Get {{customer_reward}} for each successful referral.",
                      "referral-views-description-nothing-points": "BECAUSE EVERY FRIENDSHIP STARTS WITH A FIRST STEP!",
                      "referral-views-description-points-discount": "Give your friends {{friend_reward}} points, and get {{customer_reward}} for each successful referral.",
                      "referral-views-description-points-points": "Give your friends {{friend_reward}} points, and get {{customer_reward}} points for each successful referral.",
                      "referral-views-email-share-body": "How does a discount off your first order at {{company_name}} sound? Use the link below and once you've shopped, I'll get a reward too.\n{{referral_link}}",
                      "referral-views-email-share-subject": "Discount to a Store You'll Love!",
                      "referral-views-email-share-type": "personal_email",
                      "referral-views-friends-input-placeholder": "Friend’s email address",
                      "referral-views-header": "INVITE YOUR FRIENDS \u0026 EARN SHELLS",
                      "referral-views-personal-email-button-text": "Share via email",
                      "referral-views-sms-button-text": "Share via SMS",
                      "referral-views-title-discount-discount": "GIVE {{friend_reward}}, GET {{customer_reward}}",
                      "referral-views-title-discount-points": "GIVE {{friend_reward}}, GET {{customer_reward}} POINTS",
                      "referral-views-title-nothing-discount": "REFER A FRIEND, GET {{customer_reward}} FOR REFERRALS",
                      "referral-views-title-nothing-points": "GET 500 SHELLS",
                      "referral-views-title-points-discount": "GIVE {{friend_reward}} POINTS, GET {{customer_reward}}",
                      "referral-views-title-points-points": "GIVE {{friend_reward}} POINTS, GET {{customer_reward}} POINTS",
                      "referral-views-whatsapp-button-text": "Share via WhatsApp",
                      "secondary-button-background-color": "rgba(43,42,165,1)",
                      "secondary-button-text-color": "rgba(252,250,238,1)",
                      "secondary-button-type": "filled_rectangle",
                      "share-allow-copy-link": true,
                      "share-allow-email": true,
                      "share-allow-sms": true,
                      "share-allow-whatsapp": true,
                      "share-headline-text-color": "rgba(252,250,238,1)",
                      "share-icons-color": "rgba(252,250,238,1)",
                      "share-settings-copyLink": true,
                      "share-settings-default-checkbox": true,
                      "share-settings-default-mobile-checkbox": true,
                      "share-settings-email": true,
                      "share-settings-mobile-copyLink": true,
                      "share-settings-mobile-email": true,
                      "share-settings-mobile-sms": true,
                      "share-settings-mobile-whatsapp": true,
                      "share-settings-whatsapp": true,
                      "share-sms-message": "I love {{company_name}}! Shop through my link to get a reward {{referral_link}}",
                      "share-whatsapp-message": "I love {{company_name}}! Shop through my link to get a reward {{referral_link}}",
                      "tab-size": "small",
                      "tab-type": "lower_line",
                      "tab-view-primary-tab-text": "Refer a Friend",
                      "tab-view-secondary-tab-text": "Your Referrals",
                      "tile-color": "rgba(0,0,0,0)",
                      "title-color": "rgba(252,250,238,1)",
                      "title-font-size": "40px",
                      "view-exit-intent-enabled": false,
                      "view-exit-intent-mobile-timeout-ms": 10000,
                      "view-is-popup": false,
                      "view-layout": "centered",
                      "view-popup-delay-ms": 0,
                      "view-show-customer-name": false,
                      "view-show-popup-on-exit": false,
                      "view-show-referral-history": false,
                      "view-table-rectangular-dark-pending-color": "rgba( 0, 0, 0, 0.6 )",
                      "view-table-rectangular-light-pending-color": "#FFFFFF",
                      "view-table-selected-color": "#0F8383",
                      "view-table-theme": "dark",
                      "view-table-type": "lines",
                      "wadmin-text-and-share-choose-sreen": "step_2"
                    },
                    staticContent: {
                      "advocateLoggedInRequirement": true,
                      "advocateRewardType": "POINTS",
                      "companyName": "The Odder Side",
                      "cssEditorEnabled": true,
                      "currency": "PLN",
                      "friendRewardType": "NOTHING",
                      "hasPrimaryFontsFeature": true,
                      "isFreeMerchant": false,
                      "isHidden": false,
                      "isMultiCurrencyEnabled": true,
                      "merchantId": "181985",
                      "migrateTabColorToBackground": true,
                      "platformName": "shopify",
                      "referralHistoryEnabled": true,
                      "referralHost": "http://rwrd.io",
                      "storeId": "yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK"
                    },
                    className: "ReferralShareWidget",
                    dependencyGroupId: null
                },
            
                "1053998": {
                    instanceId: "1053998",
                    instanceVersionId: "347075648",
                    templateAssetUrl: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widget-loyalty-campaigns/app.v1.2.5-6990.js",
                    cssOverrideAssetUrl: "https://cdn-widget-assets.yotpo.com/CampaignWidget/pc-_zsvJHOoRaZ3ebWa_rg/css-overrides/css-overrides.2025_03_12_02_37_48_399.css",
                    customizationCssUrl: "",
                    customizations: {
                      "campaign-description-font-color": "#6C6C6C",
                      "campaign-description-size": "16px",
                      "campaign-item-1436740-background-color": "rgba(252,250,238,1)",
                      "campaign-item-1436740-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-1436740-background-type": "color",
                      "campaign-item-1436740-border-color": "rgba(0,0,0,0)",
                      "campaign-item-1436740-description-font-color": "rgba(43,42,165,1)",
                      "campaign-item-1436740-description-font-size": 14,
                      "campaign-item-1436740-exclude_audience_names": [],
                      "campaign-item-1436740-hover-view-tile-message": "Every step brings you closer to Besties status.",
                      "campaign-item-1436740-icon-color": "#60a3a3",
                      "campaign-item-1436740-icon-type": "customIcon",
                      "campaign-item-1436740-icon-url": "https://cdn-widget-assets.yotpo.com/static_assets/pc-_zsvJHOoRaZ3ebWa_rg/images/image_2025_03_11_02_49_37_052",
                      "campaign-item-1436740-include_audience_ids": "1",
                      "campaign-item-1436740-include_audience_names": [
                        "All customers"
                      ],
                      "campaign-item-1436740-special-reward-enabled": "false",
                      "campaign-item-1436740-special-reward-headline-background-color": "#D2E3E3",
                      "campaign-item-1436740-special-reward-headline-text": "Just for you!",
                      "campaign-item-1436740-special-reward-headline-title-font-color": "#000000",
                      "campaign-item-1436740-special-reward-headline-title-font-size": "12",
                      "campaign-item-1436740-special-reward-tile-border-color": "#000000",
                      "campaign-item-1436740-tile-description": "FOR EVERY {{1_local_currency}} SPENT",
                      "campaign-item-1436740-tile-reward": "1 SHELL",
                      "campaign-item-1436740-title-font-color": "rgba(43,42,165,1)",
                      "campaign-item-1436740-title-font-size": 26,
                      "campaign-item-1436740-type": "PointsForPurchasesCampaign",
                      "campaign-item-1462605-action-tile-ask-year": "true",
                      "campaign-item-1462605-action-tile-birthday-required-field-message": "This field is required",
                      "campaign-item-1462605-action-tile-birthday-thank-you-message": "Thanks! We're looking forward to helping you celebrate :)",
                      "campaign-item-1462605-action-tile-european-date-format": "true",
                      "campaign-item-1462605-action-tile-message-text": "If your birthday is within the next 30 days, your reward will be granted in delay, up to 30 days.",
                      "campaign-item-1462605-action-tile-month-names": "January,February,March,April,May,June,July,August,September,October,November,December",
                      "campaign-item-1462605-action-tile-title": "Because besties always celebrate together.",
                      "campaign-item-1462605-background-color": "rgba(252,250,238,1)",
                      "campaign-item-1462605-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-1462605-background-type": "color",
                      "campaign-item-1462605-border-color": "rgba(0,0,0,0)",
                      "campaign-item-1462605-description-font-color": "rgba(43,42,165,1)",
                      "campaign-item-1462605-description-font-size": 14,
                      "campaign-item-1462605-exclude_audience_names": [],
                      "campaign-item-1462605-icon-color": "#60a3a3",
                      "campaign-item-1462605-icon-type": "customIcon",
                      "campaign-item-1462605-icon-url": "https://cdn-widget-assets.yotpo.com/static_assets/pc-_zsvJHOoRaZ3ebWa_rg/images/image_2025_03_11_02_52_50_057",
                      "campaign-item-1462605-include_audience_ids": "1",
                      "campaign-item-1462605-include_audience_names": [
                        "All customers"
                      ],
                      "campaign-item-1462605-special-reward-enabled": "false",
                      "campaign-item-1462605-special-reward-headline-background-color": "#D2E3E3",
                      "campaign-item-1462605-special-reward-headline-text": "Just for you!",
                      "campaign-item-1462605-special-reward-headline-title-font-color": "#000000",
                      "campaign-item-1462605-special-reward-headline-title-font-size": "12",
                      "campaign-item-1462605-special-reward-tile-border-color": "#000000",
                      "campaign-item-1462605-tile-description": "BIRTHDAY REWARD",
                      "campaign-item-1462605-tile-reward": "600 SHELLS",
                      "campaign-item-1462605-title-font-color": "rgba(43,42,165,1)",
                      "campaign-item-1462605-title-font-size": 26,
                      "campaign-item-1462605-type": "BirthdayCampaign",
                      "campaign-item-1466325-action-tile-action-text": "@the_odderside",
                      "campaign-item-1466325-action-tile-title": "Every visit counts, just like every moment of friendship.",
                      "campaign-item-1466325-background-color": "rgba(252,250,238,1)",
                      "campaign-item-1466325-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-1466325-background-type": "color",
                      "campaign-item-1466325-border-color": "rgba(0,0,0,0)",
                      "campaign-item-1466325-description-font-color": "rgba(43,42,165,1)",
                      "campaign-item-1466325-description-font-size": 14,
                      "campaign-item-1466325-exclude_audience_names": [],
                      "campaign-item-1466325-icon-color": "#60a3a3",
                      "campaign-item-1466325-icon-type": "customIcon",
                      "campaign-item-1466325-icon-url": "https://cdn-widget-assets.yotpo.com/static_assets/pc-_zsvJHOoRaZ3ebWa_rg/images/image_2025_03_11_02_53_55_706",
                      "campaign-item-1466325-include_audience_ids": "1",
                      "campaign-item-1466325-include_audience_names": [
                        "All customers"
                      ],
                      "campaign-item-1466325-special-reward-enabled": "false",
                      "campaign-item-1466325-special-reward-headline-background-color": "#D2E3E3",
                      "campaign-item-1466325-special-reward-headline-text": "Just for you!",
                      "campaign-item-1466325-special-reward-headline-title-font-color": "#000000",
                      "campaign-item-1466325-special-reward-headline-title-font-size": "12",
                      "campaign-item-1466325-special-reward-tile-border-color": "#000000",
                      "campaign-item-1466325-tile-description": "INSTAGRAM FOLLOW",
                      "campaign-item-1466325-tile-reward": "20 SHELLS",
                      "campaign-item-1466325-title-font-color": "rgba(43,42,165,1)",
                      "campaign-item-1466325-title-font-size": 26,
                      "campaign-item-1466325-type": "InstagramFollowCampaign",
                      "campaign-item-1466686-action-tile-action-text": "Visit Page",
                      "campaign-item-1466686-action-tile-title": "Every visit counts, just like every moment of friendship.",
                      "campaign-item-1466686-background-color": "rgba(252,250,238,1)",
                      "campaign-item-1466686-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-1466686-background-type": "color",
                      "campaign-item-1466686-border-color": "rgba(0,0,0,0)",
                      "campaign-item-1466686-description-font-color": "rgba(43,42,165,1)",
                      "campaign-item-1466686-description-font-size": 14,
                      "campaign-item-1466686-exclude_audience_names": [],
                      "campaign-item-1466686-icon-color": "#60a3a3",
                      "campaign-item-1466686-icon-type": "customIcon",
                      "campaign-item-1466686-icon-url": "https://cdn-widget-assets.yotpo.com/static_assets/pc-_zsvJHOoRaZ3ebWa_rg/images/image_2025_03_11_02_53_30_141",
                      "campaign-item-1466686-include_audience_ids": "1",
                      "campaign-item-1466686-include_audience_names": [
                        "All customers"
                      ],
                      "campaign-item-1466686-special-reward-enabled": "false",
                      "campaign-item-1466686-special-reward-headline-background-color": "#D2E3E3",
                      "campaign-item-1466686-special-reward-headline-text": "Just for you!",
                      "campaign-item-1466686-special-reward-headline-title-font-color": "#000000",
                      "campaign-item-1466686-special-reward-headline-title-font-size": "12",
                      "campaign-item-1466686-special-reward-tile-border-color": "#000000",
                      "campaign-item-1466686-tile-description": "TIKTOK FOLLOW",
                      "campaign-item-1466686-tile-reward": "20 SHELLS",
                      "campaign-item-1466686-title-font-color": "rgba(43,42,165,1)",
                      "campaign-item-1466686-title-font-size": 26,
                      "campaign-item-1466686-type": "FacebookPageVisitCampaign",
                      "campaign-item-1569314-action-tile-action-text": "Visit Page",
                      "campaign-item-1569314-action-tile-title": "Every visit counts, just like every moment of friendship.",
                      "campaign-item-1569314-background-color": "rgba(252,250,238,1)",
                      "campaign-item-1569314-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-1569314-background-type": "color",
                      "campaign-item-1569314-border-color": "rgba(0,0,0,0)",
                      "campaign-item-1569314-description-font-color": "rgba(43,42,165,1)",
                      "campaign-item-1569314-description-font-size": 14,
                      "campaign-item-1569314-exclude_audience_names": [],
                      "campaign-item-1569314-icon-color": "#60a3a3",
                      "campaign-item-1569314-icon-type": "customIcon",
                      "campaign-item-1569314-icon-url": "https://cdn-widget-assets.yotpo.com/static_assets/pc-_zsvJHOoRaZ3ebWa_rg/images/image_2025_03_11_02_54_25_355",
                      "campaign-item-1569314-include_audience_ids": "1",
                      "campaign-item-1569314-include_audience_names": [
                        "All customers"
                      ],
                      "campaign-item-1569314-special-reward-enabled": "false",
                      "campaign-item-1569314-special-reward-headline-background-color": "#D2E3E3",
                      "campaign-item-1569314-special-reward-headline-text": "Just for you!",
                      "campaign-item-1569314-special-reward-headline-title-font-color": "#000000",
                      "campaign-item-1569314-special-reward-headline-title-font-size": "12",
                      "campaign-item-1569314-special-reward-tile-border-color": "#000000",
                      "campaign-item-1569314-tile-description": "FACEBOOK FOLLOW",
                      "campaign-item-1569314-tile-reward": "20 SHELLS",
                      "campaign-item-1569314-title-font-color": "rgba(43,42,165,1)",
                      "campaign-item-1569314-title-font-size": 26,
                      "campaign-item-1569314-type": "FacebookPageVisitCampaign",
                      "campaign-item-1569340-action-tile-action-text": "Subscribe",
                      "campaign-item-1569340-action-tile-title": "Get access to news, drops, and exclusive benefits.",
                      "campaign-item-1569340-background-color": "rgba(252,250,238,1)",
                      "campaign-item-1569340-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-1569340-background-type": "color",
                      "campaign-item-1569340-border-color": "rgba(0,0,0,0)",
                      "campaign-item-1569340-custom-action-tile-action-url": "https://theodderside.com/#:~:text=BEZ%20U%C5%BBYCIA%20PLASTIKU.-,JOIN%20THE%20CLUB,-Zapisz%20si%C4%99%20do",
                      "campaign-item-1569340-description-font-color": "rgba(43,42,165,1)",
                      "campaign-item-1569340-description-font-size": 14,
                      "campaign-item-1569340-exclude_audience_names": [],
                      "campaign-item-1569340-icon-color": "#60a3a3",
                      "campaign-item-1569340-icon-type": "customIcon",
                      "campaign-item-1569340-icon-url": "https://cdn-widget-assets.yotpo.com/static_assets/pc-_zsvJHOoRaZ3ebWa_rg/images/image_2025_03_11_02_54_45_089",
                      "campaign-item-1569340-include_audience_ids": "1",
                      "campaign-item-1569340-include_audience_names": [
                        "All customers"
                      ],
                      "campaign-item-1569340-special-reward-enabled": "false",
                      "campaign-item-1569340-special-reward-headline-background-color": "#D2E3E3",
                      "campaign-item-1569340-special-reward-headline-text": "Just for you!",
                      "campaign-item-1569340-special-reward-headline-title-font-color": "#000000",
                      "campaign-item-1569340-special-reward-headline-title-font-size": "12",
                      "campaign-item-1569340-special-reward-tile-border-color": "#000000",
                      "campaign-item-1569340-tile-description": "SIGN UP TO OUR NEWSLETTER",
                      "campaign-item-1569340-tile-reward": "40 SHELLS",
                      "campaign-item-1569340-title-font-color": "rgba(43,42,165,1)",
                      "campaign-item-1569340-title-font-size": 26,
                      "campaign-item-1569340-type": "CustomActionCampaign",
                      "campaign-item-1569340-view-show-custom-action-button": "true",
                      "campaign-item-1589237-background-color": "rgba(252,250,238,1)",
                      "campaign-item-1589237-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-1589237-background-type": "color",
                      "campaign-item-1589237-border-color": "rgba(0,0,0,0)",
                      "campaign-item-1589237-description-font-color": "rgba(43,42,165,1)",
                      "campaign-item-1589237-description-font-size": 14,
                      "campaign-item-1589237-exclude_audience_names": "",
                      "campaign-item-1589237-hover-view-tile-message": "Every step brings you closer to Besties status.",
                      "campaign-item-1589237-icon-color": "#60a3a3",
                      "campaign-item-1589237-icon-type": "customIcon",
                      "campaign-item-1589237-icon-url": "https://cdn-widget-assets.yotpo.com/static_assets/pc-_zsvJHOoRaZ3ebWa_rg/images/image_2025_03_26_10_12_03_355",
                      "campaign-item-1589237-include_audience_ids": "1",
                      "campaign-item-1589237-include_audience_names": "All customers",
                      "campaign-item-1589237-special-reward-enabled": "false",
                      "campaign-item-1589237-special-reward-headline-background-color": "#D2E3E3",
                      "campaign-item-1589237-special-reward-headline-text": "Just for you!",
                      "campaign-item-1589237-special-reward-headline-title-font-color": "#000000",
                      "campaign-item-1589237-special-reward-headline-title-font-size": "12",
                      "campaign-item-1589237-special-reward-tile-border-color": "#000000",
                      "campaign-item-1589237-tile-description": "MAKE YOUR FIRST PURCHASE AS A LOYALTY MEMBER",
                      "campaign-item-1589237-tile-reward": "500 SHELLS",
                      "campaign-item-1589237-title-font-color": "rgba(43,42,165,1)",
                      "campaign-item-1589237-title-font-size": 26,
                      "campaign-item-1589237-type": "TransactionBasedCampaign",
                      "campaign-title-font-color": "#000000",
                      "campaign-title-size": "20px",
                      "completed-tile-headline": "Completed",
                      "completed-tile-message": "You've already used this option",
                      "container-headline": "WAYS TO EARN",
                      "general-hover-tile-button-color": "rgba(43,42,165,1)",
                      "general-hover-tile-button-text-color": "#FFFFFF",
                      "general-hover-tile-button-type": "filled_rectangle",
                      "general-hover-tile-color-overlay": "rgba(220,218,225,1)",
                      "general-hover-tile-text-color": "rgba(43,42,165,1)",
                      "headline-color": "rgba(43,42,165,1)",
                      "headline-font-color": "rgba(43,42,165,1)",
                      "headline-font-size": 40,
                      "layout-background-color": "rgba(254,253,249,1)",
                      "layout-background-enabled": "true",
                      "logged-in-non-member-button-text": "Join now",
                      "logged-in-non-member-link-destination": "banner_section",
                      "logged-out-is-redirect-after-login-to-current-page": "true",
                      "logged-out-message": "ALREADY A MEMBER? LOG IN",
                      "logged-out-sign-in-text": "LOG IN",
                      "logged-out-sign-up-text": "JOIN THE CLUB",
                      "main-text-font-name-and-url": "founders-grotesk-regular@400|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK/founders-grotesk-regular/founders-grotesk-regular-400.css",
                      "secondary-text-font-name-and-url": "founders-grotesk-regular@400|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK/founders-grotesk-regular/founders-grotesk-regular-400.css",
                      "selected-audiences": "1",
                      "selected-extensions": [
                        "1436740",
                        "1589237",
                        "1462605",
                        "1466686",
                        "1466325",
                        "1569314",
                        "1569340"
                      ],
                      "special-reward-enabled": "false",
                      "special-reward-headline-background-color": "#D2E3E3",
                      "special-reward-headline-text": "Special for you",
                      "special-reward-headline-title-font-color": "#000000",
                      "special-reward-headline-title-font-size": "12",
                      "special-reward-tile-border-color": "#000000",
                      "tile-border-color": "#BCBCBC",
                      "tile-spacing-type": "small",
                      "tiles-background-color": "#FFFFFF",
                      "time-between-rewards-days": "You'll be eligible again in *|days|* days",
                      "time-between-rewards-hours": "You'll be eligible again in *|hours|* hours"
                    },
                    staticContent: {
                      "companyName": "The Odder Side",
                      "cssEditorEnabled": true,
                      "currency": "PLN",
                      "facebookAppId": "1647129615540489",
                      "isHidden": false,
                      "isMultiCurrencyEnabled": true,
                      "isOptInFlowEnabled": false,
                      "isSegmentationsPickerEnabled": true,
                      "isShopifyNewAccountsVersion": false,
                      "merchantId": "181985",
                      "platformName": "shopify",
                      "storeAccountLoginUrl": "//theodderside.com/account/login",
                      "storeAccountRegistrationUrl": "//theodderside.com/account/register",
                      "storeId": "yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK"
                    },
                    className: "CampaignWidget",
                    dependencyGroupId: 2
                },
            
                "1053997": {
                    instanceId: "1053997",
                    instanceVersionId: "327451073",
                    templateAssetUrl: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widget-visual-redemption/app.v1.1.3-6746.js",
                    cssOverrideAssetUrl: "https://cdn-widget-assets.yotpo.com/VisualRedemptionWidget/pc-_zsvJHOoRaZ3ebWa_rg/css-overrides/css-overrides.2025_03_11_03_14_08_617.css",
                    customizationCssUrl: "",
                    customizations: {
                      "description-color": "rgba(43,42,165,1)",
                      "description-font-size": 14,
                      "headline-color": "rgba(43,42,165,1)",
                      "headline-font-size": 40,
                      "layout-add-background": "true",
                      "layout-background-color": "rgba(254,253,249,1)",
                      "primary-font-name-and-url": "founders-grotesk-regular@400|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK/founders-grotesk-regular/founders-grotesk-regular-400.css",
                      "redemption-1-displayname": "Tile 1",
                      "redemption-1-settings-cost": "x 500",
                      "redemption-1-settings-cost-color": "rgba(43,42,165,1)",
                      "redemption-1-settings-cost-font-size": 20,
                      "redemption-1-settings-frame-color": "rgba(0,0,0,0)",
                      "redemption-1-settings-reward": "20 PLN OFF",
                      "redemption-1-settings-reward-color": "rgba(43,42,165,1)",
                      "redemption-1-settings-reward-font-size": 55,
                      "redemption-2-displayname": "Tile 2",
                      "redemption-2-settings-cost": "x 1000",
                      "redemption-2-settings-cost-color": "rgba(43,42,165,1)",
                      "redemption-2-settings-cost-font-size": 20,
                      "redemption-2-settings-frame-color": "rgba(0,0,0,0)",
                      "redemption-2-settings-reward": "40 PLN OFF",
                      "redemption-2-settings-reward-color": "rgba(43,42,165,1)",
                      "redemption-2-settings-reward-font-size": 55,
                      "redemption-3-displayname": "Tile 3",
                      "redemption-3-settings-cost": "x 2000",
                      "redemption-3-settings-cost-color": "rgba(43,42,165,1)",
                      "redemption-3-settings-cost-font-size": 20,
                      "redemption-3-settings-frame-color": "rgba(0,0,0,0)",
                      "redemption-3-settings-reward": "80 PLN OFF",
                      "redemption-3-settings-reward-color": "rgba(43,42,165,1)",
                      "redemption-3-settings-reward-font-size": 55,
                      "rule-color": "rgba(43,42,165,1)",
                      "rule-dots-color": "rgba(0,0,0,0)",
                      "rule-font-size": 20,
                      "secondary-font-name-and-url": "founders-grotesk-regular@400|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK/founders-grotesk-regular/founders-grotesk-regular-400.css",
                      "selected-extensions": [
                        "1",
                        "2",
                        "3"
                      ],
                      "view-layout": "full-layout",
                      "visual-redemption-description": "REDEEMING YOUR SHELLS IS EASY! \nJUST CLICK REDEEM MY SHELLS, AND SELECT AN ELIGIBLE REWARD.",
                      "visual-redemption-headline": "HOW TO USE YOUR SHELLS",
                      "visual-redemption-rule": "x 100 EQUALS 1 PLN"
                    },
                    staticContent: {
                      "cssEditorEnabled": true,
                      "currency": "PLN",
                      "isHidden": false,
                      "isMultiCurrencyEnabled": true,
                      "isShopifyNewAccountsVersion": false,
                      "platformName": "shopify",
                      "storeId": "yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK"
                    },
                    className: "VisualRedemptionWidget",
                    dependencyGroupId: 2
                },
            
                "1053996": {
                    instanceId: "1053996",
                    instanceVersionId: "327451086",
                    templateAssetUrl: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widget-coupons-redemption/app.v1.1.13-7015.js",
                    cssOverrideAssetUrl: "https://cdn-widget-assets.yotpo.com/CouponsRedemptionWidget/pc-_zsvJHOoRaZ3ebWa_rg/css-overrides/css-overrides.2025_03_12_05_30_43_654.css",
                    customizationCssUrl: "",
                    customizations: {
                      "confirmation-step-cancel-option": "No",
                      "confirmation-step-confirm-option": "Yes",
                      "confirmation-step-title": "Are you sure?",
                      "coupon-background-type": "no-background",
                      "coupon-code-copied-message-body": "Thank you for redeeming your points. Please paste the code at checkout",
                      "coupon-code-copied-message-color": "#707997",
                      "coupon-code-copied-message-title": "",
                      "coupons-redemption-description": "REDEEMING YOUR SHELLS IS EASY!\nJUST CLICK REDEEM MY SHELLS, AND SELECT AN ELIGIBLE REWARD.\n",
                      "coupons-redemption-headline": "HOW TO USE YOUR SHELLS",
                      "coupons-redemption-rule": "x 25 EQUALS {{1_local_currency}}",
                      "description-color": "rgba(43,42,165,1)",
                      "description-font-size": 14,
                      "discount-bigger-than-subscription-cost-text": "Your next subscription is lower than the redemption amount",
                      "donate-button-text": "Donate",
                      "donation-success-message-body": "Thank you for donating ${{donation_amount}} to {{company_name}}",
                      "donation-success-message-color": "#707997",
                      "donation-success-message-title": "Success",
                      "error-message-color": "#f04860",
                      "error-message-title": "",
                      "headline-color": "rgba(43,42,165,1)",
                      "headline-font-size": 40,
                      "layout-add-background": "true",
                      "layout-background-color": "rgba(254,253,249,1)",
                      "local-enable-opt-in-flow": false,
                      "local-member-optin-disclaimer": "Add a disclaimer and button asking non-members to join your program.",
                      "local-member-optin-disclaimer-part2": "To customize them, go to \u003cb\u003ePage Settings.\u003c/b\u003e",
                      "login-button-color": "rgba(43,42,165,1)",
                      "login-button-text": "Redeem my points",
                      "login-button-text-color": "white",
                      "login-button-type": "filled_rectangle",
                      "message-font-size": "14",
                      "missing-points-amount-text": "You don't have enough points to redeem",
                      "next-subscription-headline-text": "NEXT ORDER",
                      "next-subscription-subtitle-text": "{{product_name}} {{next_order_amount}}",
                      "no-subscription-subtitle-text": "No ongoing subscriptions",
                      "point-balance-text": "You have {{current_point_balance}} Shells",
                      "points-balance-color": "rgba(43,42,165,1)",
                      "points-balance-font-size": 20,
                      "points-balance-number-color": "rgba(43,42,165,1)",
                      "primary-font-name-and-url": "founders-grotesk-regular@400|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK/founders-grotesk-regular/founders-grotesk-regular-400.css",
                      "redeem-button-color": "#0F8383",
                      "redeem-button-text": "Redeem",
                      "redeem-button-text-color": "#FFFFFF",
                      "redeem-button-type": "rounded_filled_rectangle",
                      "redeem-frame-color": "#BCBCBC",
                      "redemption-942586-displayname": "20 zł off",
                      "redemption-942586-settings-button-color": "rgba(43,42,165,1)",
                      "redemption-942586-settings-button-text": "REDEEM MY SHELLS",
                      "redemption-942586-settings-button-text-color": "#FFFFFF",
                      "redemption-942586-settings-button-type": "filled_rectangle",
                      "redemption-942586-settings-call-to-action-button-text": "Redeem",
                      "redemption-942586-settings-cost": 500,
                      "redemption-942586-settings-cost-color": "rgba(43,42,165,1)",
                      "redemption-942586-settings-cost-font-size": 20,
                      "redemption-942586-settings-cost-text": "x {{points}}",
                      "redemption-942586-settings-coupon-cost-font-size": "15",
                      "redemption-942586-settings-coupon-reward-font-size": "20",
                      "redemption-942586-settings-discount-amount-cents": 2000,
                      "redemption-942586-settings-discount-type": "fixed_amount",
                      "redemption-942586-settings-frame-color": "rgba(0,0,0,0)",
                      "redemption-942586-settings-reward": "{{20_local_currency}}",
                      "redemption-942586-settings-reward-color": "rgba(43,42,165,1)",
                      "redemption-942586-settings-reward-font-size": 55,
                      "redemption-942586-settings-success-message-text": "Reward Applied",
                      "redemption-942587-displayname": "40 zł off",
                      "redemption-942587-settings-button-color": "rgba(43,42,165,1)",
                      "redemption-942587-settings-button-text": "REDEEM MY SHELLS",
                      "redemption-942587-settings-button-text-color": "#FFFFFF",
                      "redemption-942587-settings-button-type": "filled_rectangle",
                      "redemption-942587-settings-call-to-action-button-text": "Redeem",
                      "redemption-942587-settings-cost": 1000,
                      "redemption-942587-settings-cost-color": "rgba(43,42,165,1)",
                      "redemption-942587-settings-cost-font-size": 20,
                      "redemption-942587-settings-cost-text": "x {{points}}",
                      "redemption-942587-settings-coupon-cost-font-size": "15",
                      "redemption-942587-settings-coupon-reward-font-size": "20",
                      "redemption-942587-settings-discount-amount-cents": 4000,
                      "redemption-942587-settings-discount-type": "fixed_amount",
                      "redemption-942587-settings-frame-color": "rgba(0,0,0,0)",
                      "redemption-942587-settings-reward": "{{40_local_currency}}",
                      "redemption-942587-settings-reward-color": "rgba(43,42,165,1)",
                      "redemption-942587-settings-reward-font-size": 55,
                      "redemption-942587-settings-success-message-text": "Reward Applied",
                      "redemption-944048-displayname": "80 zł off",
                      "redemption-944048-settings-button-color": "rgba(43,42,165,1)",
                      "redemption-944048-settings-button-text": "REDEEM MY SHELLS",
                      "redemption-944048-settings-button-text-color": "#FFFFFF",
                      "redemption-944048-settings-button-type": "filled_rectangle",
                      "redemption-944048-settings-call-to-action-button-text": "Redeem",
                      "redemption-944048-settings-cost": "2000",
                      "redemption-944048-settings-cost-color": "rgba(43,42,165,1)",
                      "redemption-944048-settings-cost-font-size": 20,
                      "redemption-944048-settings-cost-text": "x {{points}}",
                      "redemption-944048-settings-coupon-cost-font-size": "15",
                      "redemption-944048-settings-coupon-reward-font-size": "20",
                      "redemption-944048-settings-discount-amount-cents": "8000",
                      "redemption-944048-settings-discount-type": "fixed_amount",
                      "redemption-944048-settings-frame-color": "rgba(0,0,0,0)",
                      "redemption-944048-settings-reward": "{{80_local_currency}}",
                      "redemption-944048-settings-reward-color": "rgba(43,42,165,1)",
                      "redemption-944048-settings-reward-font-size": 55,
                      "redemption-944048-settings-success-message-text": "Reward Applied",
                      "reward-opt-in-join-now-button-label": "Complete program signup",
                      "rewards-disclaimer-text": "I agree to the program’s [terms](http://example.net/terms) and [privacy policy](http://example.net/privacy-policy)",
                      "rewards-disclaimer-text-color": "#00000",
                      "rewards-disclaimer-text-size": "12px",
                      "rewards-disclaimer-type": "no-disclaimer",
                      "rule-color": "rgba(43,42,165,1)",
                      "rule-dots-color": "rgba(0,0,0,0)",
                      "rule-font-size": 20,
                      "secondary-font-name-and-url": "founders-grotesk-regular@400|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK/founders-grotesk-regular/founders-grotesk-regular-400.css",
                      "selected-extensions": [
                        "942586",
                        "942587",
                        "944048"
                      ],
                      "selected-redemptions-modes": "regular",
                      "subscription-coupon-applied-message-body": "The discount was applied to your upcoming subscription order. You’ll be able to get another discount once the next order is processed.",
                      "subscription-coupon-applied-message-color": "#707997",
                      "subscription-coupon-applied-message-title": "",
                      "subscription-divider-color": "#c2cdf4",
                      "subscription-headline-color": "#666d8b",
                      "subscription-headline-font-size": "14",
                      "subscription-points-headline-text": "YOUR POINT BALANCE",
                      "subscription-points-subtitle-text": "{{current_point_balance}} Points",
                      "subscription-redemptions-description": "Choose a discount option that will automatically apply to your next subscription order.",
                      "subscription-redemptions-headline": "Redeem for Subscription Discount",
                      "subscription-subtitle-color": "#768cdc",
                      "subscription-subtitle-font-size": "20",
                      "undefined": "Only for brands using Shopify’s new customer accounts and have program eligibility set to “only members who signed up.”",
                      "view-layout": "full-layout"
                    },
                    staticContent: {
                      "cssEditorEnabled": true,
                      "currency": "PLN",
                      "isHidden": false,
                      "isMultiCurrencyEnabled": true,
                      "isOptInFlowEnabled": false,
                      "isShopifyNewAccountsVersion": false,
                      "merchantId": "181985",
                      "platformName": "shopify",
                      "storeId": "yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK",
                      "storeLoginUrl": "/account/login",
                      "subunitsPerUnit": 100
                    },
                    className: "CouponsRedemptionWidget",
                    dependencyGroupId: 2
                },
            
                "1053995": {
                    instanceId: "1053995",
                    instanceVersionId: "327451061",
                    templateAssetUrl: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widget-vip-tiers/app.v2.2.4-6882.js",
                    cssOverrideAssetUrl: "https://cdn-widget-assets.yotpo.com/VipTiersWidget/pc-_zsvJHOoRaZ3ebWa_rg/css-overrides/css-overrides.2025_03_12_13_18_03_502.css",
                    customizationCssUrl: "",
                    customizations: {
                      "background-color": "rgba(254,253,249,1)",
                      "background-enabled": "true",
                      "benefits-font-size": "14px",
                      "benefits-icon-color": "#89BABA",
                      "benefits-icon-type": "custom",
                      "benefits-icon-url": "https://cdn-widget-assets.yotpo.com/static_assets/pc-_zsvJHOoRaZ3ebWa_rg/images/image_2025_03_11_03_18_04_364",
                      "benefits-text-color": "rgba(43,42,165,1)",
                      "card-background-border-color": "rgba(0,0,0,0)",
                      "card-background-color": "rgba(252,250,238,1)",
                      "card-background-shadow": "false",
                      "card-separator-color": "#BCBCBC",
                      "card-separator-enabled": "false",
                      "current-status-bg-color": "rgba(252,250,238,1)",
                      "current-status-tag": "true",
                      "current-status-text": "YOUR CURRENT STATUS",
                      "current-status-text-color": "rgba(43,42,165,1)",
                      "current-tier-border-color": "rgba(0,0,0,0)",
                      "grid-lines-color": "#ACB5D4",
                      "headline-color": "rgba(43,42,165,1)",
                      "headline-font-size": 120,
                      "headline-text-color": "rgba(43,42,165,1)",
                      "layout": "card",
                      "primary-font-name-and-url": "founders-grotesk-regular@400|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK/founders-grotesk-regular/founders-grotesk-regular-400.css",
                      "progress-bar-current-status": "{{amount_spent}} Spent",
                      "progress-bar-enabled": "true",
                      "progress-bar-headline-font-size": "14px",
                      "progress-bar-primary-color": "rgba(43,42,165,1)",
                      "progress-bar-secondary-color": "rgba(43,42,165,1)",
                      "progress-bar-summary-current": "You have {{current_vip_tier_name}} through the next earning period.",
                      "progress-bar-summary-font-size": "14px",
                      "progress-bar-summary-maintain": "Spend {{spend_needed}} by {{tier_expiration_date}} to maintain {{current_vip_tier_name}}",
                      "progress-bar-summary-next": "Spend {{spend_needed}} to unlock {{next_vip_tier_name}}.",
                      "progress-bar-tier-status": "Tier status",
                      "progress-bar-you": "YOU",
                      "secondary-font-name-and-url": "founders-grotesk-regular@400|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK/founders-grotesk-regular/founders-grotesk-regular-400.css",
                      "selected-extensions": [
                        "30768",
                        "30769",
                        "30770",
                        "30846"
                      ],
                      "show-less-text": "- See less",
                      "show-more-text": "+ See more",
                      "tier-spacing": "small",
                      "tiers-30768-design-header-bg-color": "#FFFFFF",
                      "tiers-30768-design-icon-fill-color": "#0F8383",
                      "tiers-30768-design-icon-type": "custom",
                      "tiers-30768-design-icon-url": "https://cdn-widget-assets.yotpo.com/static_assets/pc-_zsvJHOoRaZ3ebWa_rg/images/image_2025_03_11_04_16_57_463",
                      "tiers-30768-design-include-header-bg": "false",
                      "tiers-30768-design-name-font-size": "24px",
                      "tiers-30768-design-name-text-color": "rgba(43,42,165,1)",
                      "tiers-30768-design-threshold-font-size": "14px",
                      "tiers-30768-design-threshold-text-color": "rgba(43,42,165,1)",
                      "tiers-30768-text-benefits": "BIRTHDAY GIFT ||EARN SHELLS WITH EVERY PURCHASE",
                      "tiers-30768-text-name": "NEW FRIEND",
                      "tiers-30768-text-rank": 1,
                      "tiers-30768-text-threshold": "JOIN",
                      "tiers-30769-design-header-bg-color": "#FFFFFF",
                      "tiers-30769-design-icon-fill-color": "#0F8383",
                      "tiers-30769-design-icon-type": "custom",
                      "tiers-30769-design-icon-url": "https://cdn-widget-assets.yotpo.com/static_assets/pc-_zsvJHOoRaZ3ebWa_rg/images/image_2025_03_11_04_17_26_894",
                      "tiers-30769-design-include-header-bg": "false",
                      "tiers-30769-design-name-font-size": "24px",
                      "tiers-30769-design-name-text-color": "rgba(43,42,165,1)",
                      "tiers-30769-design-threshold-font-size": "14px",
                      "tiers-30769-design-threshold-text-color": "rgba(43,42,165,1)",
                      "tiers-30769-text-benefits": "SPECIAL CLOSE CIRCLE BIRTHDAY GIFT||EARN MORE SHELLS PER SPEND||TIER ENTRY GIFT: 500 SHELLS",
                      "tiers-30769-text-name": "CLOSE CIRCLE",
                      "tiers-30769-text-rank": 2,
                      "tiers-30769-text-threshold": "SPEND {{amount_spent}}",
                      "tiers-30770-design-header-bg-color": "#FFFFFF",
                      "tiers-30770-design-icon-fill-color": "#0F8383",
                      "tiers-30770-design-icon-type": "custom",
                      "tiers-30770-design-icon-url": "https://cdn-widget-assets.yotpo.com/static_assets/pc-_zsvJHOoRaZ3ebWa_rg/images/image_2025_03_11_04_18_12_525",
                      "tiers-30770-design-include-header-bg": "false",
                      "tiers-30770-design-name-font-size": "24px",
                      "tiers-30770-design-name-text-color": "rgba(43,42,165,1)",
                      "tiers-30770-design-threshold-font-size": "14px",
                      "tiers-30770-design-threshold-text-color": "rgba(43,42,165,1)",
                      "tiers-30770-text-benefits": "EXCLUSIVE PARTNER IN CRIME BIRTHDAY GIFT||TIER ENTRY GIFT: 1,000 SHELLS ||FREE STANDARD SHIPPING ||EARLY ACCESS TO NEW COLLECTIONS||POINTS MULTIPLIER X1.25",
                      "tiers-30770-text-name": "PARTNER IN CRIME",
                      "tiers-30770-text-rank": 3,
                      "tiers-30770-text-threshold": "SPEND {{amount_spent}}",
                      "tiers-30846-design-header-bg-color": "#FFFFFF",
                      "tiers-30846-design-icon-fill-color": "#0F8383",
                      "tiers-30846-design-icon-type": "custom",
                      "tiers-30846-design-icon-url": "https://cdn-widget-assets.yotpo.com/static_assets/pc-_zsvJHOoRaZ3ebWa_rg/images/image_2025_03_11_04_18_48_624",
                      "tiers-30846-design-include-header-bg": "false",
                      "tiers-30846-design-name-font-size": "24px",
                      "tiers-30846-design-name-text-color": "rgba(43,42,165,1)",
                      "tiers-30846-design-threshold-font-size": "14px",
                      "tiers-30846-design-threshold-text-color": "rgba(43,42,165,1)",
                      "tiers-30846-text-benefits": "ULTIMATE BESTIES BIRTHDAY GIFT||TIER ENTRY GIFT: 3,000 SHELLS ||FREE EXPRESS SHIPPING ||EARLY ACCESS TO THE NEW COLLECTIONS||INVITATIONS TO VIP EVENTS||POINTS MULTIPLIER X1.5",
                      "tiers-30846-text-name": "BESTIES",
                      "tiers-30846-text-rank": 4,
                      "tiers-30846-text-threshold": "SPEND {{amount_spent}}",
                      "widget-headline": "BESTIES EARN EVEN MORE"
                    },
                    staticContent: {
                      "cssEditorEnabled": true,
                      "currency": "PLN",
                      "isHidden": false,
                      "isMultiCurrencyEnabled": true,
                      "merchantId": "181985",
                      "platformName": "shopify",
                      "storeId": "yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK"
                    },
                    className: "VipTiersWidget",
                    dependencyGroupId: 2
                },
            
                "1053994": {
                    instanceId: "1053994",
                    instanceVersionId: "327451080",
                    templateAssetUrl: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widget-hero-section/app.v1.7.13-7014.js",
                    cssOverrideAssetUrl: "https://cdn-widget-assets.yotpo.com/HeroSectionWidget/pc-_zsvJHOoRaZ3ebWa_rg/css-overrides/css-overrides.2025_03_12_02_23_04_459.css",
                    customizationCssUrl: "",
                    customizations: {
                      "background-image-url": "https://cdn-widget-assets.yotpo.com/static_assets/pc-_zsvJHOoRaZ3ebWa_rg/images/image_2025_03_10_00_00_52_800",
                      "description-color": "rgba(43,42,165,1)",
                      "description-font-size": 24,
                      "description-text-logged-in": "EVERY PURCHASE GETS YOU CLOSER TO BESTIES STATUS . EARN SHELLS \u0026 UNLOCK REWARDS!",
                      "description-text-logged-out": "COLLECT SHELLS \u0026 UNLOCK EXCLUSIVE PERKS WITH EVERY PURCHASE!",
                      "headline-color": "rgba(43,42,165,1)",
                      "headline-font-size": 120,
                      "headline-text-logged-in": "WELCOME TO THE CLUB",
                      "headline-text-logged-in-non-member": "You’re a step away from rewards!",
                      "headline-text-logged-in-subtitle-text-non-member": "Join our rewards program and earn points and exclusive rewards every time you shop.",
                      "headline-text-logged-out": "JOIN THE CLUB",
                      "login-button-color": "rgba(252,250,238,1)",
                      "login-button-text": "Log in",
                      "login-button-text-color": "rgba(0,0,0,1)",
                      "login-button-type": "filled_rectangle",
                      "member-optin-disclaimer": "To customize the disclaimer and button asking non-members to join your program, go to \u003cb\u003ePage Settings.\u003c/b\u003e",
                      "mobile-background-image-url": "https://cdn-widget-assets.yotpo.com/static_assets/pc-_zsvJHOoRaZ3ebWa_rg/images/image_2025_03_10_23_44_50_341",
                      "mode-is-page-settings": false,
                      "primary-font-name-and-url": "founders-grotesk-regular@400|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK/founders-grotesk-regular/founders-grotesk-regular-400.css",
                      "register-button-color": "rgba(252,250,238,1)",
                      "register-button-text": "Join now",
                      "register-button-text-color": "rgba(0,0,0,1)",
                      "register-button-type": "filled_rectangle",
                      "reward-opt-in-join-now-button-label": "Complete program signup",
                      "rewards-disclaimer-text": "I agree to the program’s [terms](http://example.net/terms) and [privacy policy](http://example.net/privacy-policy)",
                      "rewards-disclaimer-text-color": "#00000",
                      "rewards-disclaimer-text-size": "12px",
                      "rewards-disclaimer-type": "no-disclaimer",
                      "secondary-font-name-and-url": "founders-grotesk-regular@400|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK/founders-grotesk-regular/founders-grotesk-regular-400.css",
                      "text-background-color": "#D2E3E3",
                      "text-background-show-on-desktop": false,
                      "text-background-show-on-mobile": false,
                      "view-layout": "center-layout"
                    },
                    staticContent: {
                      "cssEditorEnabled": true,
                      "isHidden": false,
                      "isOptInFlowEnabled": false,
                      "isShopifyNewAccountsVersion": false,
                      "merchantId": "181985",
                      "platformName": "shopify",
                      "storeId": "yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK",
                      "storeLoginUrl": "//theodderside.com/account/login",
                      "storeRegistrationUrl": "//theodderside.com/account/register"
                    },
                    className: "HeroSectionWidget",
                    dependencyGroupId: 2
                },
            
                "1053993": {
                    instanceId: "1053993",
                    instanceVersionId: "328716400",
                    templateAssetUrl: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widget-loyalty-page/app.v0.6.3-7159.js",
                    cssOverrideAssetUrl: "",
                    customizationCssUrl: "",
                    customizations: {
                      "headline-color": "rgba(43,42,165,1)",
                      "headline-font-size": 40,
                      "page-background-color": "",
                      "primary-font-name-and-url": "founders-grotesk-regular@400|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK/founders-grotesk-regular/founders-grotesk-regular-400.css",
                      "reward-opt-in-join-now-button-label": "Complete program signup",
                      "rewards-disclaimer-text": "I agree to the program’s [terms](http://example.net/terms) and [privacy policy](http://example.net/privacy-policy)",
                      "rewards-disclaimer-text-color": "#00000",
                      "rewards-disclaimer-text-size": "12px",
                      "rewards-disclaimer-type": "no-disclaimer",
                      "secondary-font-name-and-url": "founders-grotesk-regular@400|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK/founders-grotesk-regular/founders-grotesk-regular-400.css",
                      "selected-widgets-ids": [
                        "1053994",
                        "1054000",
                        "1053998",
                        "1053996",
                        "1053995",
                        "1053999"
                      ],
                      "widget-1053994-type": "HeroSectionWidget",
                      "widget-1053995-type": "VipTiersWidget",
                      "widget-1053997-type": "VisualRedemptionWidget",
                      "widget-1053998-type": "CampaignWidget",
                      "widget-1053999-type": "ReferralShareWidget",
                      "widget-1054000-type": "MyRewardsWidget"
                    },
                    staticContent: {
                      "isHidden": false,
                      "isOptInFlowEnabled": false,
                      "platformName": "shopify",
                      "storeId": "yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK"
                    },
                    className: "LoyaltyPageWidget",
                    dependencyGroupId: null
                },
            
                "1024141": {
                    instanceId: "1024141",
                    instanceVersionId: "327451062",
                    templateAssetUrl: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widget-visual-redemption/app.v1.1.3-6746.js",
                    cssOverrideAssetUrl: "",
                    customizationCssUrl: "",
                    customizations: {
                      "description-color": "#6C6C6C",
                      "description-font-size": "16",
                      "headline-color": "#000000",
                      "headline-font-size": "26",
                      "layout-background-color": "#F6F1EE",
                      "primary-font-name-and-url": "Poppins@600|https://cdn-widgetsrepository.yotpo.com/web-fonts/css/poppins/v1/poppins_600.css",
                      "redemption-1-displayname": "Tile 1",
                      "redemption-1-settings-cost": "0 points",
                      "redemption-1-settings-cost-color": "#6C6C6C",
                      "redemption-1-settings-cost-font-size": "16",
                      "redemption-1-settings-frame-color": "#BCBCBC",
                      "redemption-1-settings-reward": "$0 off",
                      "redemption-1-settings-reward-color": "#000000",
                      "redemption-1-settings-reward-font-size": "20",
                      "redemption-2-displayname": "Tile 2",
                      "redemption-2-settings-cost": "0 points",
                      "redemption-2-settings-cost-color": "#6C6C6C",
                      "redemption-2-settings-cost-font-size": "16",
                      "redemption-2-settings-frame-color": "#BCBCBC",
                      "redemption-2-settings-reward": "$0 off",
                      "redemption-2-settings-reward-color": "#000000",
                      "redemption-2-settings-reward-font-size": "20",
                      "redemption-3-displayname": "Tile 3",
                      "redemption-3-settings-cost": "0 points",
                      "redemption-3-settings-cost-color": "#6C6C6C",
                      "redemption-3-settings-cost-font-size": "16",
                      "redemption-3-settings-frame-color": "#BCBCBC",
                      "redemption-3-settings-reward": "$0 off",
                      "redemption-3-settings-reward-color": "#000000",
                      "redemption-3-settings-reward-font-size": "20",
                      "rule-color": "#000000",
                      "rule-dots-color": "#6C6C6C",
                      "rule-font-size": "16",
                      "secondary-font-name-and-url": "Poppins@400|https://cdn-widgetsrepository.yotpo.com/web-fonts/css/poppins/v1/poppins_400.css",
                      "selected-extensions": [
                        "1",
                        "2",
                        "3"
                      ],
                      "view-layout": "full-layout",
                      "visual-redemption-description": "Redeeming your points is easy! Just log in, and choose an eligible reward at checkout.",
                      "visual-redemption-headline": "How to Use Your Points",
                      "visual-redemption-rule": "100 points equals $1"
                    },
                    staticContent: {
                      "cssEditorEnabled": true,
                      "currency": "PLN",
                      "isHidden": false,
                      "isMultiCurrencyEnabled": true,
                      "isShopifyNewAccountsVersion": false,
                      "platformName": "shopify",
                      "storeId": "yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK"
                    },
                    className: "VisualRedemptionWidget",
                    dependencyGroupId: 2
                },
            
                "1024140": {
                    instanceId: "1024140",
                    instanceVersionId: "347075656",
                    templateAssetUrl: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widget-referral-share/app.v0.4.22-7034.js",
                    cssOverrideAssetUrl: "https://cdn-widget-assets.yotpo.com/ReferralShareWidget/pc-_zsvJHOoRaZ3ebWa_rg/css-overrides/css-overrides.2025_01_20_03_13_11_178.css",
                    customizationCssUrl: "",
                    customizations: {
                      "background-color": "rgba(255,255,255,1)",
                      "customer-email-view-button-text": "Next",
                      "customer-email-view-description-discount-discount": "Give your friends {{friend_reward}} their first purchase of {{min_spent}}, and get {{customer_reward}} for each successful referral.",
                      "customer-email-view-description-discount-points": "Give your friends {{friend_reward}} their first purchase of {{min_spent}}, and get {{customer_reward}} points for each successful referral.",
                      "customer-email-view-description-nothing-discount": "Get {{customer_reward}} for each successful referral.",
                      "customer-email-view-description-nothing-points": "Get {{customer_reward}} points for each successful referral.",
                      "customer-email-view-description-points-discount": "Give your friends {{friend_reward}} points, and get {{customer_reward}} for each successful referral.",
                      "customer-email-view-description-points-points": "Give your friends {{friend_reward}} points, and get {{customer_reward}} points for each successful referral.",
                      "customer-email-view-header": "Refer a Friend",
                      "customer-email-view-input-placeholder": "Your email address",
                      "customer-email-view-title-discount-discount": "GIVE {{friend_reward}}, GET {{customer_reward}}",
                      "customer-email-view-title-discount-points": "GIVE {{friend_reward}}, GET {{customer_reward}} POINTS",
                      "customer-email-view-title-nothing-discount": "REFER A FRIEND, GET {{customer_reward}} FOR REFERRALS",
                      "customer-email-view-title-nothing-points": "REFER A FRIEND, GET {{customer_reward}} POINTS FOR REFERRALS",
                      "customer-email-view-title-points-discount": "GIVE {{friend_reward}} POINTS, GET {{customer_reward}}",
                      "customer-email-view-title-points-points": "GIVE {{friend_reward}} POINTS, GET {{customer_reward}} POINTS",
                      "customer-name-view-input-placeholder": "Your name",
                      "default-toggle": true,
                      "description-color": "rgba(0,0,0,1)",
                      "description-font-size": "20px",
                      "desktop-background-image-url": "https://cdn-widget-assets.yotpo.com/static_assets/pc-_zsvJHOoRaZ3ebWa_rg/images/image_2025_01_20_03_11_59_379",
                      "disabled-referral-code-error": "Looks like your referral link was deactivated",
                      "email-fill-color": "#F6F1EE",
                      "email-input-type": "rounded_rectangle",
                      "email-outline-color": "#000000",
                      "email-text-color": "#000000",
                      "final-view-button-text": "Refer more friends",
                      "final-view-description": "Remind your friends to check their email",
                      "final-view-error-description": "We were unable to share the referral link. Go back to the previous step to try again.",
                      "final-view-error-text": "Back",
                      "final-view-error-title": "Something went wrong",
                      "final-view-title": "You’re the best—thanks for sharing the love!",
                      "fonts-primary-font-name-and-url": "founders-grotesk-regular@400|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK/founders-grotesk-regular/founders-grotesk-regular-400.css",
                      "fonts-secondary-font-name-and-url": "founders-grotesk-regular@400|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK/founders-grotesk-regular/founders-grotesk-regular-400.css",
                      "header-color": "#000000",
                      "header-font-size": "20px",
                      "login-view-description-discount-discount": "Give your friends {{friend_reward}} their first purchase of {{min_spent}}, and get {{customer_reward}} for each successful referral.",
                      "login-view-description-discount-points": "Spread the love—invite your friends, and when they place their first order of 400 zł+, you’ll snag 500 HEARTBEATS. More besties, more perks—let’s make it happen!",
                      "login-view-description-nothing-discount": "Get {{customer_reward}} for each successful referral.",
                      "login-view-description-nothing-points": "Get {{customer_reward}} points for each successful referral.",
                      "login-view-description-points-discount": "Give your friends {{friend_reward}} points, and get {{customer_reward}} for each successful referral.",
                      "login-view-description-points-points": "Give your friends {{friend_reward}} points, and get {{customer_reward}} points for each successful referral.",
                      "login-view-header": " Pola 2:41pm Show options… Invite Your Friends \u0026 Earn HEARTBEATS!",
                      "login-view-log-in-button-text": "Log in",
                      "login-view-sign-up-button-text": "Join now",
                      "login-view-title-discount-discount": "GIVE {{friend_reward}}, GET {{customer_reward}}",
                      "login-view-title-discount-points": " GET 500 HEARTBEATS",
                      "login-view-title-nothing-discount": "REFER A FRIEND, GET {{customer_reward}} FOR REFERRALS",
                      "login-view-title-nothing-points": "REFER A FRIEND, GET {{customer_reward}} POINTS FOR REFERRALS",
                      "login-view-title-points-discount": "GIVE {{friend_reward}} POINTS, GET {{customer_reward}}",
                      "login-view-title-points-points": "GIVE {{friend_reward}} POINTS, GET {{customer_reward}} POINTS",
                      "main-share-option-desktop": "main_share_copy_link",
                      "main-share-option-mobile": "main_share_sms",
                      "mobile-background-image-url": "https://cdn-widget-assets.yotpo.com/static_assets/pc-_zsvJHOoRaZ3ebWa_rg/images/image_2025_01_20_03_12_03_788",
                      "more-share-ways-text": "MORE WAYS TO SHARE",
                      "primary-button-background-color": "rgba(0,0,0,1)",
                      "primary-button-font-size": "16px",
                      "primary-button-size": "standard",
                      "primary-button-text-color": "#FFFFFF",
                      "primary-button-type": "filled_rectangle",
                      "reduced-picture": true,
                      "referral-history-completed-points-text": "{{points}} POINTS",
                      "referral-history-completed-status-type": "text",
                      "referral-history-confirmed-status": "Completed",
                      "referral-history-pending-status": "Pending",
                      "referral-history-redeem-text": "You can redeem your points for a reward, or apply your reward code at checkout.",
                      "referral-history-sumup-line-points-text": "{{points}} POINTS",
                      "referral-history-sumup-line-text": "Your Rewards",
                      "referral-views-button-text": "Next",
                      "referral-views-copy-link-button-text": "Copy link",
                      "referral-views-description-discount-discount": "Give your friends {{friend_reward}} their first purchase of {{min_spent}}, and get {{customer_reward}} for each successful referral.",
                      "referral-views-description-discount-points": "Spread the love—invite your friends, and when they place their first order of 400 zł+, you’ll snag 500 HEARTBEATS. More besties, more perks—let’s make it happen!",
                      "referral-views-description-nothing-discount": "Get {{customer_reward}} for each successful referral.",
                      "referral-views-description-nothing-points": "Get {{customer_reward}} points for each successful referral.",
                      "referral-views-description-points-discount": "Give your friends {{friend_reward}} points, and get {{customer_reward}} for each successful referral.",
                      "referral-views-description-points-points": "Give your friends {{friend_reward}} points, and get {{customer_reward}} points for each successful referral.",
                      "referral-views-email-share-body": "How does a discount off your first order at {{company_name}} sound? Use the link below and once you've shopped, I'll get a reward too.\n{{referral_link}}",
                      "referral-views-email-share-subject": "Discount to a Store You'll Love!",
                      "referral-views-email-share-type": "personal_email",
                      "referral-views-friends-input-placeholder": "Friend’s email address",
                      "referral-views-header": "Invite Your Friends \u0026 Earn HEARTBEATS!",
                      "referral-views-personal-email-button-text": "Share via email",
                      "referral-views-sms-button-text": "Share via SMS",
                      "referral-views-title-discount-discount": "GIVE {{friend_reward}}, GET {{customer_reward}}",
                      "referral-views-title-discount-points": "GET 500 POINTS",
                      "referral-views-title-nothing-discount": "REFER A FRIEND, GET {{customer_reward}} FOR REFERRALS",
                      "referral-views-title-nothing-points": "REFER A FRIEND, GET {{customer_reward}} POINTS FOR REFERRALS",
                      "referral-views-title-points-discount": "GIVE {{friend_reward}} POINTS, GET {{customer_reward}}",
                      "referral-views-title-points-points": "GIVE {{friend_reward}} POINTS, GET {{customer_reward}} POINTS",
                      "referral-views-whatsapp-button-text": "Share via WhatsApp",
                      "secondary-button-background-color": "rgba(0,0,0,1)",
                      "secondary-button-text-color": "rgba(255,255,255,1)",
                      "secondary-button-type": "filled_rectangle",
                      "share-allow-copy-link": true,
                      "share-allow-email": true,
                      "share-allow-sms": true,
                      "share-allow-whatsapp": true,
                      "share-headline-text-color": "rgba(0,0,0,1)",
                      "share-icons-color": "rgba(0,0,0,1)",
                      "share-settings-copyLink": true,
                      "share-settings-default-checkbox": true,
                      "share-settings-default-mobile-checkbox": true,
                      "share-settings-email": true,
                      "share-settings-mobile-copyLink": true,
                      "share-settings-mobile-email": true,
                      "share-settings-mobile-sms": true,
                      "share-settings-mobile-whatsapp": true,
                      "share-settings-whatsapp": true,
                      "share-sms-message": "I love {{company_name}}! Shop through my link to get a reward {{referral_link}}",
                      "share-whatsapp-message": "I love {{company_name}}! Shop through my link to get a reward {{referral_link}}",
                      "tab-size": "small",
                      "tab-type": "lower_line",
                      "tab-view-primary-tab-text": "Refer a Friend",
                      "tab-view-secondary-tab-text": "Your Referrals",
                      "tile-color": "rgba(255,255,255,1)",
                      "title-color": "#000000",
                      "title-font-size": "36px",
                      "view-exit-intent-enabled": false,
                      "view-exit-intent-mobile-timeout-ms": 10000,
                      "view-is-popup": false,
                      "view-layout": "left",
                      "view-popup-delay-ms": 0,
                      "view-show-customer-name": false,
                      "view-show-popup-on-exit": false,
                      "view-show-referral-history": false,
                      "view-table-rectangular-dark-pending-color": "rgba( 0, 0, 0, 0.6 )",
                      "view-table-rectangular-light-pending-color": "#FFFFFF",
                      "view-table-selected-color": "#0F8383",
                      "view-table-theme": "dark",
                      "view-table-type": "lines",
                      "wadmin-text-and-share-choose-sreen": "step_3"
                    },
                    staticContent: {
                      "advocateLoggedInRequirement": true,
                      "advocateRewardType": "POINTS",
                      "companyName": "The Odder Side",
                      "cssEditorEnabled": true,
                      "currency": "PLN",
                      "friendRewardType": "NOTHING",
                      "hasPrimaryFontsFeature": true,
                      "isFreeMerchant": false,
                      "isHidden": false,
                      "isMultiCurrencyEnabled": true,
                      "merchantId": "181985",
                      "migrateTabColorToBackground": true,
                      "platformName": "shopify",
                      "referralHistoryEnabled": true,
                      "referralHost": "http://rwrd.io",
                      "storeId": "yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK"
                    },
                    className: "ReferralShareWidget",
                    dependencyGroupId: null
                },
            
                "1024139": {
                    instanceId: "1024139",
                    instanceVersionId: "328600576",
                    templateAssetUrl: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widget-vip-tiers/app.v2.3.1-7150.js",
                    cssOverrideAssetUrl: "",
                    customizationCssUrl: "",
                    customizations: {
                      "background-color": "#FFFFFF",
                      "background-enabled": "true",
                      "benefits-font-size": "14px",
                      "benefits-icon-color": "rgba(0,0,0,1)",
                      "benefits-icon-type": "default",
                      "benefits-text-color": "rgba(0,0,0,1)",
                      "card-background-border-color": "rgba(0,0,0,0)",
                      "card-background-color": "#FFFFFF",
                      "card-background-shadow": "true",
                      "card-separator-color": "#BCBCBC",
                      "card-separator-enabled": "false",
                      "current-status-bg-color": "rgba(0,0,0,1)",
                      "current-status-tag": "true",
                      "current-status-text": "Current status",
                      "current-status-text-color": "rgba(255,255,255,1)",
                      "current-tier-border-color": "rgba(0,0,0,1)",
                      "grid-lines-color": "#ACB5D4",
                      "headline-font-size": "26px",
                      "headline-text-color": "#000000",
                      "layout": "card",
                      "primary-font-name-and-url": "founders-grotesk-regular@400|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK/founders-grotesk-regular/founders-grotesk-regular-400.css",
                      "progress-bar-current-status": "{{amount_spent}} Spent",
                      "progress-bar-enabled": "true",
                      "progress-bar-headline-font-size": "14px",
                      "progress-bar-primary-color": "#000000",
                      "progress-bar-secondary-color": "rgba(0,0,0,1)",
                      "progress-bar-summary-current": "You are in {{current_vip_tier_name}} through the next earning period.",
                      "progress-bar-summary-font-size": "14px",
                      "progress-bar-summary-maintain": "Spend {{spend_needed}} by {{tier_expiration_date}} to maintain {{current_vip_tier_name}}",
                      "progress-bar-summary-next": "Spend {{spend_needed}} to reach {{next_vip_tier_name}} tier.",
                      "progress-bar-tier-status": "Tier status",
                      "progress-bar-you": "YOU",
                      "secondary-font-name-and-url": "founders-grotesk-regular@400|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK/founders-grotesk-regular/founders-grotesk-regular-400.css",
                      "selected-extensions": [
                        "30768",
                        "30769",
                        "30770",
                        "30846"
                      ],
                      "show-less-text": "- See less",
                      "show-more-text": "+ See more",
                      "tier-spacing": "small",
                      "tiers-30768-design-header-bg-color": "rgba(248,247,243,1)",
                      "tiers-30768-design-icon-fill-color": "rgba(0,0,0,1)",
                      "tiers-30768-design-icon-type": "default",
                      "tiers-30768-design-icon-url": "",
                      "tiers-30768-design-include-header-bg": "true",
                      "tiers-30768-design-name-font-size": "20px",
                      "tiers-30768-design-name-text-color": "#000000",
                      "tiers-30768-design-threshold-font-size": "16px",
                      "tiers-30768-design-threshold-text-color": "rgba(0,0,0,1)",
                      "tiers-30768-text-benefits": "Birthday Gift ||Earn HEARTBEATS with every purchase",
                      "tiers-30768-text-name": "NEW FRIEND ",
                      "tiers-30768-text-rank": 1,
                      "tiers-30768-text-threshold": "Join",
                      "tiers-30769-design-header-bg-color": "rgba(248,247,243,1)",
                      "tiers-30769-design-icon-fill-color": "rgba(0,0,0,1)",
                      "tiers-30769-design-icon-type": "default",
                      "tiers-30769-design-icon-url": "",
                      "tiers-30769-design-include-header-bg": "true",
                      "tiers-30769-design-name-font-size": "20px",
                      "tiers-30769-design-name-text-color": "#000000",
                      "tiers-30769-design-threshold-font-size": "16px",
                      "tiers-30769-design-threshold-text-color": "rgba(0,0,0,1)",
                      "tiers-30769-text-benefits": "Special Close Circle Birthday Gift||Earn more HEARTBEATS per spend||Tier Entry Gift: 500 HEARTBEATS",
                      "tiers-30769-text-name": "CLOSE CIRCLE",
                      "tiers-30769-text-rank": 2,
                      "tiers-30769-text-threshold": "Spend {{amount_spent}}",
                      "tiers-30770-design-header-bg-color": "rgba(248,247,243,1)",
                      "tiers-30770-design-icon-fill-color": "rgba(0,0,0,1)",
                      "tiers-30770-design-icon-type": "default",
                      "tiers-30770-design-icon-url": "",
                      "tiers-30770-design-include-header-bg": "true",
                      "tiers-30770-design-name-font-size": "20px",
                      "tiers-30770-design-name-text-color": "#000000",
                      "tiers-30770-design-threshold-font-size": "16px",
                      "tiers-30770-design-threshold-text-color": "rgba(0,0,0,1)",
                      "tiers-30770-text-benefits": "Exclusive Partner in Crime Birthday Gift||Even more HEARTBEATS per spend||Tier Entry Gift: 1,000 HEARTBEATS||Free Standard Shipping||Early Access to New Collections",
                      "tiers-30770-text-name": "PARTNER IN CRIME",
                      "tiers-30770-text-rank": 3,
                      "tiers-30770-text-threshold": "Spend {{amount_spent}}",
                      "tiers-30846-design-header-bg-color": "rgba(248,247,243,1)",
                      "tiers-30846-design-icon-fill-color": "rgba(0,0,0,1)",
                      "tiers-30846-design-icon-type": "default",
                      "tiers-30846-design-icon-url": "",
                      "tiers-30846-design-include-header-bg": "true",
                      "tiers-30846-design-name-font-size": "20px",
                      "tiers-30846-design-name-text-color": "#000000",
                      "tiers-30846-design-threshold-font-size": "16px",
                      "tiers-30846-design-threshold-text-color": "rgba(0,0,0,1)",
                      "tiers-30846-text-benefits": "Ultimate Besties Birthday Gift||Max HEARTBEATS per spend||Tier Entry Gift: 3,000 HEARTBEATS||Free Express Shipping ||Early Access to the New Collections|| Invitations to VIP Events",
                      "tiers-30846-text-name": "BESTIES ",
                      "tiers-30846-text-rank": "4",
                      "tiers-30846-text-threshold": "Spend {{amount_spent}}",
                      "widget-headline": "Besties Earn Even More"
                    },
                    staticContent: {
                      "cssEditorEnabled": true,
                      "currency": "PLN",
                      "isHidden": false,
                      "isMultiCurrencyEnabled": true,
                      "merchantId": "181985",
                      "platformName": "shopify",
                      "storeId": "yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK"
                    },
                    className: "VipTiersWidget",
                    dependencyGroupId: 2
                },
            
                "1024138": {
                    instanceId: "1024138",
                    instanceVersionId: "327451090",
                    templateAssetUrl: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widget-coupons-redemption/app.v1.1.13-7015.js",
                    cssOverrideAssetUrl: "https://cdn-widget-assets.yotpo.com/CouponsRedemptionWidget/pc-_zsvJHOoRaZ3ebWa_rg/css-overrides/css-overrides.2025_01_20_03_21_36_751.css",
                    customizationCssUrl: "",
                    customizations: {
                      "confirmation-step-cancel-option": "No",
                      "confirmation-step-confirm-option": "Yes",
                      "confirmation-step-title": "Are you sure?",
                      "coupon-background-type": "no-background",
                      "coupon-code-copied-message-body": "Thank you for redeeming your points. Please paste the code at checkout",
                      "coupon-code-copied-message-color": "#707997",
                      "coupon-code-copied-message-title": "",
                      "coupons-redemption-description": "Redeeming your HEARTBEATS is easy! Just click Redeem my HEARTBEATS, and select an eligible reward.",
                      "coupons-redemption-headline": "How to Use Your HEARTBEATS",
                      "coupons-redemption-rule": "25 HEARTBEATS equals {{1_local_currency}}",
                      "description-color": "rgba(0,0,0,1)",
                      "description-font-size": "16",
                      "discount-bigger-than-subscription-cost-text": "Your next subscription is lower than the redemption amount",
                      "donate-button-text": "Donate",
                      "donation-success-message-body": "Thank you for donating ${{donation_amount}} to {{company_name}}",
                      "donation-success-message-color": "#707997",
                      "donation-success-message-title": "Success",
                      "error-message-color": "#f04860",
                      "error-message-title": "",
                      "headline-color": "#000000",
                      "headline-font-size": "26",
                      "layout-add-background": "true",
                      "layout-background-color": "rgba(248,247,243,1)",
                      "local-enable-opt-in-flow": false,
                      "local-member-optin-disclaimer": "Add a disclaimer and button asking non-members to join your program.",
                      "local-member-optin-disclaimer-part2": "To customize them, go to \u003cb\u003ePage Settings.\u003c/b\u003e",
                      "login-button-color": "rgba(0,0,0,1)",
                      "login-button-text": "Redeem my HEARTBEATS",
                      "login-button-text-color": "white",
                      "login-button-type": "filled_rectangle",
                      "message-font-size": "14",
                      "missing-points-amount-text": "You don't have enough points to redeem",
                      "next-subscription-headline-text": "NEXT ORDER",
                      "next-subscription-subtitle-text": "{{product_name}} {{next_order_amount}}",
                      "no-subscription-subtitle-text": "No ongoing subscriptions",
                      "point-balance-text": "You have {{current_point_balance}} HEARTBEATS",
                      "points-balance-color": "rgba(0,0,0,1)",
                      "points-balance-font-size": "16",
                      "points-balance-number-color": "rgba(0,0,0,1)",
                      "primary-font-name-and-url": "founders-grotesk-regular@400|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK/founders-grotesk-regular/founders-grotesk-regular-400.css",
                      "redeem-button-color": "#0F8383",
                      "redeem-button-text": "Redeem",
                      "redeem-button-text-color": "#FFFFFF",
                      "redeem-button-type": "rounded_filled_rectangle",
                      "redeem-frame-color": "#BCBCBC",
                      "redemption-942586-displayname": "60 zł off",
                      "redemption-942586-settings-button-color": "rgba(0,0,0,1)",
                      "redemption-942586-settings-button-text": "Redeem",
                      "redemption-942586-settings-button-text-color": "#FFFFFF",
                      "redemption-942586-settings-button-type": "filled_rectangle",
                      "redemption-942586-settings-call-to-action-button-text": "Redeem",
                      "redemption-942586-settings-cost": 600,
                      "redemption-942586-settings-cost-color": "rgba(0,0,0,1)",
                      "redemption-942586-settings-cost-font-size": "16",
                      "redemption-942586-settings-cost-text": "{{points}} HEARTBEATS",
                      "redemption-942586-settings-coupon-cost-font-size": "15",
                      "redemption-942586-settings-coupon-reward-font-size": "20",
                      "redemption-942586-settings-discount-amount-cents": 6000,
                      "redemption-942586-settings-discount-type": "fixed_amount",
                      "redemption-942586-settings-frame-color": "rgba(0,0,0,0)",
                      "redemption-942586-settings-reward": "{{20_local_currency}} off",
                      "redemption-942586-settings-reward-color": "rgba(0,0,0,1)",
                      "redemption-942586-settings-reward-font-size": 28,
                      "redemption-942586-settings-success-message-text": "Reward Applied",
                      "redemption-942587-displayname": "90 zł off",
                      "redemption-942587-settings-button-color": "rgba(0,0,0,1)",
                      "redemption-942587-settings-button-text": "Redeem",
                      "redemption-942587-settings-button-text-color": "#FFFFFF",
                      "redemption-942587-settings-button-type": "filled_rectangle",
                      "redemption-942587-settings-call-to-action-button-text": "Redeem",
                      "redemption-942587-settings-cost": 900,
                      "redemption-942587-settings-cost-color": "rgba(0,0,0,1)",
                      "redemption-942587-settings-cost-font-size": "16",
                      "redemption-942587-settings-cost-text": "{{points}} HEARTBEATS",
                      "redemption-942587-settings-coupon-cost-font-size": "15",
                      "redemption-942587-settings-coupon-reward-font-size": "20",
                      "redemption-942587-settings-discount-amount-cents": 9000,
                      "redemption-942587-settings-discount-type": "fixed_amount",
                      "redemption-942587-settings-frame-color": "rgba(0,0,0,0)",
                      "redemption-942587-settings-reward": "{{40_local_currency}} off",
                      "redemption-942587-settings-reward-color": "rgba(0,0,0,1)",
                      "redemption-942587-settings-reward-font-size": 28,
                      "redemption-942587-settings-success-message-text": "Reward Applied",
                      "redemption-944048-displayname": "120 zł off",
                      "redemption-944048-settings-button-color": "rgba(0,0,0,1)",
                      "redemption-944048-settings-button-text": "Redeem",
                      "redemption-944048-settings-button-text-color": "#FFFFFF",
                      "redemption-944048-settings-button-type": "filled_rectangle",
                      "redemption-944048-settings-call-to-action-button-text": "Redeem",
                      "redemption-944048-settings-cost": "1200",
                      "redemption-944048-settings-cost-color": "rgba(0,0,0,1)",
                      "redemption-944048-settings-cost-font-size": "16",
                      "redemption-944048-settings-cost-text": "{{points}} HEARTBEATS",
                      "redemption-944048-settings-coupon-cost-font-size": "15",
                      "redemption-944048-settings-coupon-reward-font-size": "20",
                      "redemption-944048-settings-discount-amount-cents": "12000",
                      "redemption-944048-settings-discount-type": "fixed_amount",
                      "redemption-944048-settings-frame-color": "rgba(0,0,0,0)",
                      "redemption-944048-settings-reward": "80 zł off",
                      "redemption-944048-settings-reward-color": "rgba(0,0,0,1)",
                      "redemption-944048-settings-reward-font-size": 28,
                      "redemption-944048-settings-success-message-text": "Reward Applied",
                      "redemption-944952-displayname": "120 zł off",
                      "redemption-944952-settings-button-color": "#0F8383",
                      "redemption-944952-settings-button-text": "Redeem",
                      "redemption-944952-settings-button-text-color": "#FFFFFF",
                      "redemption-944952-settings-button-type": "rounded_filled_rectangle",
                      "redemption-944952-settings-call-to-action-button-text": "Redeem",
                      "redemption-944952-settings-cost": "3000",
                      "redemption-944952-settings-cost-color": "#6C6C6C",
                      "redemption-944952-settings-cost-font-size": "16",
                      "redemption-944952-settings-cost-text": "{{points}} points",
                      "redemption-944952-settings-coupon-cost-font-size": "15",
                      "redemption-944952-settings-coupon-reward-font-size": "20",
                      "redemption-944952-settings-discount-amount-cents": "12000",
                      "redemption-944952-settings-discount-type": "fixed_amount",
                      "redemption-944952-settings-reward": "120 zł off",
                      "redemption-944952-settings-reward-color": "#000000",
                      "redemption-944952-settings-reward-font-size": "20",
                      "redemption-944952-settings-success-message-text": "Reward Applied",
                      "reward-opt-in-join-now-button-label": "Complete program signup",
                      "rewards-disclaimer-text": "I agree to the program’s [terms](http://example.net/terms) and [privacy policy](http://example.net/privacy-policy)",
                      "rewards-disclaimer-text-color": "#00000",
                      "rewards-disclaimer-text-size": "12px",
                      "rewards-disclaimer-type": "no-disclaimer",
                      "rule-color": "rgba(0,0,0,1)",
                      "rule-dots-color": "rgba(0,0,0,1)",
                      "rule-font-size": 16,
                      "secondary-font-name-and-url": "founders-grotesk-regular@400|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK/founders-grotesk-regular/founders-grotesk-regular-400.css",
                      "selected-extensions": [
                        "942586",
                        "942587",
                        "944048",
                        "944952"
                      ],
                      "selected-redemptions-modes": "regular",
                      "subscription-coupon-applied-message-body": "The discount was applied to your upcoming subscription order. You’ll be able to get another discount once the next order is processed.",
                      "subscription-coupon-applied-message-color": "#707997",
                      "subscription-coupon-applied-message-title": "",
                      "subscription-divider-color": "#c2cdf4",
                      "subscription-headline-color": "#666d8b",
                      "subscription-headline-font-size": "14",
                      "subscription-points-headline-text": "YOUR POINT BALANCE",
                      "subscription-points-subtitle-text": "{{current_point_balance}} Points",
                      "subscription-redemptions-description": "Choose a discount option that will automatically apply to your next subscription order.",
                      "subscription-redemptions-headline": "Redeem for Subscription Discount",
                      "subscription-subtitle-color": "#768cdc",
                      "subscription-subtitle-font-size": "20",
                      "undefined": "Only for brands using Shopify’s new customer accounts and have program eligibility set to “only members who signed up.”",
                      "view-layout": "full-layout"
                    },
                    staticContent: {
                      "cssEditorEnabled": true,
                      "currency": "PLN",
                      "isHidden": false,
                      "isMultiCurrencyEnabled": true,
                      "isOptInFlowEnabled": false,
                      "isShopifyNewAccountsVersion": false,
                      "merchantId": "181985",
                      "platformName": "shopify",
                      "storeId": "yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK",
                      "storeLoginUrl": "/account/login",
                      "subunitsPerUnit": 100
                    },
                    className: "CouponsRedemptionWidget",
                    dependencyGroupId: 2
                },
            
                "1024137": {
                    instanceId: "1024137",
                    instanceVersionId: "347075650",
                    templateAssetUrl: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widget-loyalty-campaigns/app.v1.2.5-6990.js",
                    cssOverrideAssetUrl: "https://cdn-widget-assets.yotpo.com/CampaignWidget/pc-_zsvJHOoRaZ3ebWa_rg/css-overrides/css-overrides.2025_01_20_03_13_11_424.css",
                    customizationCssUrl: "",
                    customizations: {
                      "campaign-description-font-color": "#6C6C6C",
                      "campaign-description-size": "16px",
                      "campaign-item-1436740-background-color": "transparent",
                      "campaign-item-1436740-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-1436740-background-type": "color",
                      "campaign-item-1436740-border-color": "rgba(0,0,0,1)",
                      "campaign-item-1436740-description-font-color": "rgba(0,0,0,1)",
                      "campaign-item-1436740-description-font-size": "16",
                      "campaign-item-1436740-exclude_audience_names": [],
                      "campaign-item-1436740-hover-view-tile-message": "Because every step brings you closer to Besties status.",
                      "campaign-item-1436740-icon-color": "#60a3a3",
                      "campaign-item-1436740-icon-type": "noIcon",
                      "campaign-item-1436740-include_audience_ids": "1",
                      "campaign-item-1436740-include_audience_names": [
                        "All customers"
                      ],
                      "campaign-item-1436740-special-reward-enabled": "false",
                      "campaign-item-1436740-special-reward-headline-background-color": "#D2E3E3",
                      "campaign-item-1436740-special-reward-headline-text": "Just for you!",
                      "campaign-item-1436740-special-reward-headline-title-font-color": "#000000",
                      "campaign-item-1436740-special-reward-headline-title-font-size": "12",
                      "campaign-item-1436740-special-reward-tile-border-color": "#000000",
                      "campaign-item-1436740-tile-description": "",
                      "campaign-item-1436740-tile-reward": "1 HEARTBEAT for every 1 zł spent",
                      "campaign-item-1436740-title-font-color": "#000000",
                      "campaign-item-1436740-title-font-size": 20,
                      "campaign-item-1436740-type": "PointsForPurchasesCampaign",
                      "campaign-item-1462605-action-tile-ask-year": "true",
                      "campaign-item-1462605-action-tile-birthday-required-field-message": "Oops! Looks like you missed this one.",
                      "campaign-item-1462605-action-tile-birthday-thank-you-message": "Thanks! Can’t wait to celebrate with you.",
                      "campaign-item-1462605-action-tile-european-date-format": "false",
                      "campaign-item-1462605-action-tile-message-text": "If your birthday is coming up within 30 days, your reward might take a little longer—expect it within a month.",
                      "campaign-item-1462605-action-tile-month-names": "January,February,March,April,May,June,July,August,September,October,November,December",
                      "campaign-item-1462605-action-tile-title": "Because besties always celebrate each other.",
                      "campaign-item-1462605-background-color": "transparent",
                      "campaign-item-1462605-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-1462605-background-type": "color",
                      "campaign-item-1462605-border-color": "rgba(0,0,0,1)",
                      "campaign-item-1462605-description-font-color": "rgba(0,0,0,1)",
                      "campaign-item-1462605-description-font-size": "16",
                      "campaign-item-1462605-exclude_audience_names": [],
                      "campaign-item-1462605-icon-color": "#60a3a3",
                      "campaign-item-1462605-icon-type": "noIcon",
                      "campaign-item-1462605-include_audience_ids": "1",
                      "campaign-item-1462605-include_audience_names": [
                        "All customers"
                      ],
                      "campaign-item-1462605-special-reward-enabled": "false",
                      "campaign-item-1462605-special-reward-headline-background-color": "#D2E3E3",
                      "campaign-item-1462605-special-reward-headline-text": "Just for you!",
                      "campaign-item-1462605-special-reward-headline-title-font-color": "#000000",
                      "campaign-item-1462605-special-reward-headline-title-font-size": "12",
                      "campaign-item-1462605-special-reward-tile-border-color": "#000000",
                      "campaign-item-1462605-tile-description": "Birthday reward",
                      "campaign-item-1462605-tile-reward": "600 HEARTBEATS ",
                      "campaign-item-1462605-title-font-color": "#000000",
                      "campaign-item-1462605-title-font-size": 20,
                      "campaign-item-1462605-type": "BirthdayCampaign",
                      "campaign-item-1466325-action-tile-action-text": "@the_odderside",
                      "campaign-item-1466325-action-tile-title": "Stay in the loop and get rewarded.",
                      "campaign-item-1466325-background-color": "transparent",
                      "campaign-item-1466325-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-1466325-background-type": "color",
                      "campaign-item-1466325-border-color": "rgba(0,0,0,1)",
                      "campaign-item-1466325-description-font-color": "rgba(0,0,0,1)",
                      "campaign-item-1466325-description-font-size": "16",
                      "campaign-item-1466325-exclude_audience_names": [],
                      "campaign-item-1466325-icon-color": "#60a3a3",
                      "campaign-item-1466325-icon-type": "noIcon",
                      "campaign-item-1466325-include_audience_ids": "1",
                      "campaign-item-1466325-include_audience_names": [
                        "All customers"
                      ],
                      "campaign-item-1466325-special-reward-enabled": "false",
                      "campaign-item-1466325-special-reward-headline-background-color": "#D2E3E3",
                      "campaign-item-1466325-special-reward-headline-text": "Just for you!",
                      "campaign-item-1466325-special-reward-headline-title-font-color": "#000000",
                      "campaign-item-1466325-special-reward-headline-title-font-size": "12",
                      "campaign-item-1466325-special-reward-tile-border-color": "#000000",
                      "campaign-item-1466325-tile-description": " Instagram Follow",
                      "campaign-item-1466325-tile-reward": "20 HEARTBEATS ",
                      "campaign-item-1466325-title-font-color": "#000000",
                      "campaign-item-1466325-title-font-size": 20,
                      "campaign-item-1466325-type": "InstagramFollowCampaign",
                      "campaign-item-1466686-action-tile-action-text": "Give us a follow",
                      "campaign-item-1466686-action-tile-title": "Stay in the loop and get rewarded.",
                      "campaign-item-1466686-background-color": "transparent",
                      "campaign-item-1466686-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-1466686-background-type": "color",
                      "campaign-item-1466686-border-color": "rgba(0,0,0,1)",
                      "campaign-item-1466686-description-font-color": "rgba(0,0,0,1)",
                      "campaign-item-1466686-description-font-size": "16",
                      "campaign-item-1466686-exclude_audience_names": [],
                      "campaign-item-1466686-icon-color": "#60a3a3",
                      "campaign-item-1466686-icon-type": "noIcon",
                      "campaign-item-1466686-include_audience_ids": "1",
                      "campaign-item-1466686-include_audience_names": [
                        "All customers"
                      ],
                      "campaign-item-1466686-special-reward-enabled": "false",
                      "campaign-item-1466686-special-reward-headline-background-color": "#D2E3E3",
                      "campaign-item-1466686-special-reward-headline-text": "Just for you!",
                      "campaign-item-1466686-special-reward-headline-title-font-color": "#000000",
                      "campaign-item-1466686-special-reward-headline-title-font-size": "12",
                      "campaign-item-1466686-special-reward-tile-border-color": "#000000",
                      "campaign-item-1466686-tile-description": "TikTok Follow ",
                      "campaign-item-1466686-tile-reward": "20 HEARTBEATS ",
                      "campaign-item-1466686-title-font-color": "#000000",
                      "campaign-item-1466686-title-font-size": 20,
                      "campaign-item-1466686-type": "FacebookPageVisitCampaign",
                      "campaign-item-1569313-background-color": "transparent",
                      "campaign-item-1569313-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-1569313-background-type": "color",
                      "campaign-item-1569313-border-color": "rgba(0,0,0,1)",
                      "campaign-item-1569313-description-font-color": "rgba(0,0,0,1)",
                      "campaign-item-1569313-description-font-size": "16",
                      "campaign-item-1569313-exclude_audience_names": [],
                      "campaign-item-1569313-hover-view-tile-message": "Start your journey and become part of the crew.",
                      "campaign-item-1569313-icon-color": "#60a3a3",
                      "campaign-item-1569313-icon-type": "noIcon",
                      "campaign-item-1569313-include_audience_ids": "1",
                      "campaign-item-1569313-include_audience_names": [
                        "All customers"
                      ],
                      "campaign-item-1569313-special-reward-enabled": "false",
                      "campaign-item-1569313-special-reward-headline-background-color": "#D2E3E3",
                      "campaign-item-1569313-special-reward-headline-text": "Just for you!",
                      "campaign-item-1569313-special-reward-headline-title-font-color": "#000000",
                      "campaign-item-1569313-special-reward-headline-title-font-size": "12",
                      "campaign-item-1569313-special-reward-tile-border-color": "#000000",
                      "campaign-item-1569313-tile-description": "Join the club      ",
                      "campaign-item-1569313-tile-reward": "200 HEARTBEATS",
                      "campaign-item-1569313-title-font-color": "#000000",
                      "campaign-item-1569313-title-font-size": 20,
                      "campaign-item-1569313-type": "CreateAccountCampaign",
                      "campaign-item-1569314-action-tile-action-text": "Like us on FB",
                      "campaign-item-1569314-action-tile-title": "Every like counts—just like every friendship moment.",
                      "campaign-item-1569314-background-color": "transparent",
                      "campaign-item-1569314-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-1569314-background-type": "color",
                      "campaign-item-1569314-border-color": "rgba(0,0,0,1)",
                      "campaign-item-1569314-description-font-color": "rgba(0,0,0,1)",
                      "campaign-item-1569314-description-font-size": "16",
                      "campaign-item-1569314-exclude_audience_names": [],
                      "campaign-item-1569314-icon-color": "#60a3a3",
                      "campaign-item-1569314-icon-type": "noIcon",
                      "campaign-item-1569314-include_audience_ids": "1",
                      "campaign-item-1569314-include_audience_names": [
                        "All customers"
                      ],
                      "campaign-item-1569314-special-reward-enabled": "false",
                      "campaign-item-1569314-special-reward-headline-background-color": "#D2E3E3",
                      "campaign-item-1569314-special-reward-headline-text": "Just for you!",
                      "campaign-item-1569314-special-reward-headline-title-font-color": "#000000",
                      "campaign-item-1569314-special-reward-headline-title-font-size": "12",
                      "campaign-item-1569314-special-reward-tile-border-color": "#000000",
                      "campaign-item-1569314-tile-description": "Facebook Follow",
                      "campaign-item-1569314-tile-reward": "20 HEARTBEATS",
                      "campaign-item-1569314-title-font-color": "#000000",
                      "campaign-item-1569314-title-font-size": 20,
                      "campaign-item-1569314-type": "FacebookPageVisitCampaign",
                      "campaign-item-1569340-action-tile-action-text": "Click Here",
                      "campaign-item-1569340-action-tile-title": "Get the latest drops, early access, and extra perks.",
                      "campaign-item-1569340-background-color": "transparent",
                      "campaign-item-1569340-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-1569340-background-type": "color",
                      "campaign-item-1569340-border-color": "rgba(0,0,0,1)",
                      "campaign-item-1569340-description-font-color": "rgba(0,0,0,1)",
                      "campaign-item-1569340-description-font-size": "16",
                      "campaign-item-1569340-exclude_audience_names": [],
                      "campaign-item-1569340-icon-color": "#60a3a3",
                      "campaign-item-1569340-icon-type": "noIcon",
                      "campaign-item-1569340-include_audience_ids": "1",
                      "campaign-item-1569340-include_audience_names": [
                        "All customers"
                      ],
                      "campaign-item-1569340-special-reward-enabled": "false",
                      "campaign-item-1569340-special-reward-headline-background-color": "#D2E3E3",
                      "campaign-item-1569340-special-reward-headline-text": "Just for you!",
                      "campaign-item-1569340-special-reward-headline-title-font-color": "#000000",
                      "campaign-item-1569340-special-reward-headline-title-font-size": "12",
                      "campaign-item-1569340-special-reward-tile-border-color": "#000000",
                      "campaign-item-1569340-tile-description": "Sign up to our Newsletter",
                      "campaign-item-1569340-tile-reward": "40 HEARTBEATS",
                      "campaign-item-1569340-title-font-color": "#000000",
                      "campaign-item-1569340-title-font-size": 20,
                      "campaign-item-1569340-type": "CustomActionCampaign",
                      "campaign-item-1569340-view-show-custom-action-button": "false",
                      "campaign-title-font-color": "#000000",
                      "campaign-title-size": "20px",
                      "completed-tile-headline": "Completed",
                      "completed-tile-message": "You've already used this option",
                      "container-headline": "Ways to Earn",
                      "general-hover-tile-button-color": "rgba(255,255,255,1)",
                      "general-hover-tile-button-text-color": "rgba(0,0,0,1)",
                      "general-hover-tile-button-type": "filled_rectangle",
                      "general-hover-tile-color-overlay": "rgba(0,0,0,1)",
                      "general-hover-tile-text-color": "rgba(255,255,255,1)",
                      "headline-font-color": "#000000",
                      "headline-font-size": "26px",
                      "layout-background-color": "#FFFFFF",
                      "layout-background-enabled": "true",
                      "logged-in-non-member-button-text": "Join now",
                      "logged-in-non-member-link-destination": "banner_section",
                      "logged-out-is-redirect-after-login-to-current-page": "true",
                      "logged-out-message": "Already a member?",
                      "logged-out-sign-in-text": "Log in",
                      "logged-out-sign-up-text": "Sign up",
                      "main-text-font-name-and-url": "founders-grotesk-regular@400|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK/founders-grotesk-regular/founders-grotesk-regular-400.css",
                      "secondary-text-font-name-and-url": "founders-grotesk-regular@400|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK/founders-grotesk-regular/founders-grotesk-regular-400.css",
                      "selected-audiences": "1",
                      "selected-extensions": [
                        "1436740",
                        "1569313",
                        "1462605",
                        "1466686",
                        "1466325",
                        "1569314",
                        "1569340"
                      ],
                      "special-reward-enabled": "false",
                      "special-reward-headline-background-color": "#D2E3E3",
                      "special-reward-headline-text": "Special for you",
                      "special-reward-headline-title-font-color": "#000000",
                      "special-reward-headline-title-font-size": "12",
                      "special-reward-tile-border-color": "#000000",
                      "tile-border-color": "#BCBCBC",
                      "tile-spacing-type": "small",
                      "tiles-background-color": "#FFFFFF",
                      "time-between-rewards-days": "You'll be eligible again in *|days|* days",
                      "time-between-rewards-hours": "You'll be eligible again in *|hours|* hours"
                    },
                    staticContent: {
                      "companyName": "The Odder Side",
                      "cssEditorEnabled": true,
                      "currency": "PLN",
                      "facebookAppId": "1647129615540489",
                      "isHidden": false,
                      "isMultiCurrencyEnabled": true,
                      "isOptInFlowEnabled": false,
                      "isSegmentationsPickerEnabled": true,
                      "isShopifyNewAccountsVersion": false,
                      "merchantId": "181985",
                      "platformName": "shopify",
                      "storeAccountLoginUrl": "//theodderside.com/account/login",
                      "storeAccountRegistrationUrl": "//theodderside.com/account/register",
                      "storeId": "yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK"
                    },
                    className: "CampaignWidget",
                    dependencyGroupId: 2
                },
            
                "1024136": {
                    instanceId: "1024136",
                    instanceVersionId: "347175230",
                    templateAssetUrl: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widget-my-rewards/app.v1.4.4-7021.js",
                    cssOverrideAssetUrl: "https://cdn-widget-assets.yotpo.com/MyRewardsWidget/pc-_zsvJHOoRaZ3ebWa_rg/css-overrides/css-overrides.2025_01_20_03_02_44_246.css",
                    customizationCssUrl: "",
                    customizations: {
                      "layout-add-background": "true",
                      "layout-background-color": "rgba(248,247,243,1)",
                      "logged-in-description-color": "rgba(0,0,0,1)",
                      "logged-in-description-font-size": "22",
                      "logged-in-description-text": "{{current_point_balance}} points",
                      "logged-in-description-tier-status-text": "{{current_vip_tier_name}} tier",
                      "logged-in-headline-color": "#000000",
                      "logged-in-headline-font-size": "40",
                      "logged-in-headline-text": "Hi {{first_name}}!",
                      "logged-in-primary-button-cta-type": "redemptionWidget",
                      "logged-in-primary-button-text": "Redeem points",
                      "logged-in-secondary-button-text": "Rewards history",
                      "logged-out-headline-color": "#000000",
                      "logged-out-headline-font-size": "26",
                      "logged-out-headline-text": "How it Works",
                      "logged-out-selected-step-name": "step_1",
                      "primary-button-background-color": "#000000",
                      "primary-button-text-color": "#FFFFFF",
                      "primary-button-type": "filled_rectangle",
                      "primary-font-name-and-url": "founders-grotesk-regular@400|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK/founders-grotesk-regular/founders-grotesk-regular-400.css",
                      "reward-step-1-displayname": "Step 1",
                      "reward-step-1-settings-description": "Create an account and start with 200 HEARTBEATS—because every friendship starts with a first step!",
                      "reward-step-1-settings-description-color": "rgba(0,0,0,1)",
                      "reward-step-1-settings-description-font-size": "16",
                      "reward-step-1-settings-icon": "custom",
                      "reward-step-1-settings-icon-color": "#000000",
                      "reward-step-1-settings-icon-url": "https://cdn-widget-assets.yotpo.com/static_assets/pc-_zsvJHOoRaZ3ebWa_rg/images/image_2025_01_20_03_00_17_503",
                      "reward-step-1-settings-title": "Join the club",
                      "reward-step-1-settings-title-color": "rgba(0,0,0,1)",
                      "reward-step-1-settings-title-font-size": "20",
                      "reward-step-2-displayname": "Step 2",
                      "reward-step-2-settings-description": "Collect HEARTBEATS every time you shop \u0026 move closer to Besties status!",
                      "reward-step-2-settings-description-color": "rgba(0,0,0,1)",
                      "reward-step-2-settings-description-font-size": "16",
                      "reward-step-2-settings-icon": "custom",
                      "reward-step-2-settings-icon-color": "#000000",
                      "reward-step-2-settings-icon-url": "https://cdn-widget-assets.yotpo.com/static_assets/pc-_zsvJHOoRaZ3ebWa_rg/images/image_2025_01_20_03_00_28_058",
                      "reward-step-2-settings-title": "Earn HEARTBEATS",
                      "reward-step-2-settings-title-color": "rgba(0,0,0,1)",
                      "reward-step-2-settings-title-font-size": "20",
                      "reward-step-3-displayname": "Step 3",
                      "reward-step-3-settings-description": "Use your HEARTBEATS to get exclusive perks—because real friends deserve special treatment!\n",
                      "reward-step-3-settings-description-color": "rgba(0,0,0,1)",
                      "reward-step-3-settings-description-font-size": "16",
                      "reward-step-3-settings-icon": "custom",
                      "reward-step-3-settings-icon-color": "#000000",
                      "reward-step-3-settings-icon-url": "https://cdn-widget-assets.yotpo.com/static_assets/pc-_zsvJHOoRaZ3ebWa_rg/images/image_2025_01_20_03_00_36_793",
                      "reward-step-3-settings-title": "Unlock rewards",
                      "reward-step-3-settings-title-color": "rgba(0,0,0,1)",
                      "reward-step-3-settings-title-font-size": "20",
                      "rewards-history-approved-text": "Approved",
                      "rewards-history-background-color": "rgba(248,247,243,0.8)",
                      "rewards-history-headline-color": "rgba(0,0,0,1)",
                      "rewards-history-headline-font-size": "26",
                      "rewards-history-headline-text": "Rewards History",
                      "rewards-history-pending-text": "Pending",
                      "rewards-history-refunded-text": "Refunded",
                      "rewards-history-reversed-text": "Reversed",
                      "rewards-history-table-action-col-text": "Action",
                      "rewards-history-table-date-col-text": "Date",
                      "rewards-history-table-expiration-col-text": "Points expire on",
                      "rewards-history-table-points-col-text": "Points",
                      "rewards-history-table-status-col-text": "Status",
                      "rewards-history-table-store-col-text": "Store",
                      "secondary-button-background-color": "#000000",
                      "secondary-button-text-color": "rgba(255,255,255,1)",
                      "secondary-button-type": "filled_rectangle",
                      "secondary-font-name-and-url": "founders-grotesk-regular@400|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK/founders-grotesk-regular/founders-grotesk-regular-400.css",
                      "show-logged-in-description-points-balance": true,
                      "show-logged-in-description-tier-status": false,
                      "view-grid-points-column-color": "rgba(0,0,0,1)",
                      "view-grid-rectangular-background-color": "#F6F1EE",
                      "view-grid-type": "stripes"
                    },
                    staticContent: {
                      "cssEditorEnabled": true,
                      "currency": "PLN",
                      "isHidden": false,
                      "isMultiCurrencyEnabled": true,
                      "isMultiStoreMerchant": false,
                      "isOptInFlowEnabled": false,
                      "isShopifyNewAccountsVersion": false,
                      "isVipTiersEnabled": true,
                      "merchantId": "181985",
                      "platformName": "shopify",
                      "storeId": "yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK"
                    },
                    className: "MyRewardsWidget",
                    dependencyGroupId: 2
                },
            
                "1024135": {
                    instanceId: "1024135",
                    instanceVersionId: "328736228",
                    templateAssetUrl: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widget-hero-section/app.v1.7.20-7160.js",
                    cssOverrideAssetUrl: "",
                    customizationCssUrl: "",
                    customizations: {
                      "background-image-url": "https://cdn-widget-assets.yotpo.com/static_assets/pc-_zsvJHOoRaZ3ebWa_rg/images/image_2025_01_20_03_01_51_641",
                      "description-color": "#000000",
                      "description-font-size": 20,
                      "description-text-logged-in": "Every purchase gets you closer to the main stage—earn HEARTBEATS \u0026 unlock rewards!",
                      "description-text-logged-out": "Join the club, collect HEARTBEATS \u0026 unlock exclusive perks with every purchase!",
                      "headline-color": "#000000",
                      "headline-font-size": 36,
                      "headline-text-logged-in": "Welcome to the club",
                      "headline-text-logged-in-non-member": "You’re a step away from rewards!",
                      "headline-text-logged-in-subtitle-text-non-member": "Join our rewards program and earn points and exclusive rewards every time you shop.",
                      "headline-text-logged-out": "Join the club",
                      "login-button-color": "#000000",
                      "login-button-text": "Log in",
                      "login-button-text-color": "rgba(255,255,255,1)",
                      "login-button-type": "filled_rectangle",
                      "member-optin-disclaimer": "To customize the disclaimer and button asking non-members to join your program, go to \u003cb\u003ePage Settings.\u003c/b\u003e",
                      "mobile-background-image-url": "https://cdn-widget-assets.yotpo.com/static_assets/pc-_zsvJHOoRaZ3ebWa_rg/images/image_2025_01_20_03_01_54_750",
                      "mode-is-page-settings": false,
                      "primary-font-name-and-url": "founders-grotesk-regular@400|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK/founders-grotesk-regular/founders-grotesk-regular-400.css",
                      "register-button-color": "#000000",
                      "register-button-text": "Join now",
                      "register-button-text-color": "#ffffff",
                      "register-button-type": "filled_rectangle",
                      "reward-opt-in-join-now-button-label": "Complete program signup",
                      "rewards-disclaimer-text": "I agree to the program’s [terms](http://example.net/terms) and [privacy policy](http://example.net/privacy-policy)",
                      "rewards-disclaimer-text-color": "#00000",
                      "rewards-disclaimer-text-size": "12px",
                      "rewards-disclaimer-type": "no-disclaimer",
                      "secondary-font-name-and-url": "founders-grotesk-regular@400|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK/founders-grotesk-regular/founders-grotesk-regular-400.css",
                      "text-background-color": "rgba(255,255,255,0.7)",
                      "text-background-show-on-desktop": true,
                      "text-background-show-on-mobile": "true",
                      "view-layout": "center-layout"
                    },
                    staticContent: {
                      "cssEditorEnabled": true,
                      "isHidden": false,
                      "isOptInFlowEnabled": false,
                      "isShopifyNewAccountsVersion": false,
                      "merchantId": "181985",
                      "platformName": "shopify",
                      "storeId": "yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK",
                      "storeLoginUrl": "//theodderside.com/account/login",
                      "storeRegistrationUrl": "//theodderside.com/account/register"
                    },
                    className: "HeroSectionWidget",
                    dependencyGroupId: 2
                },
            
                "1011645": {
                    instanceId: "1011645",
                    instanceVersionId: "347175227",
                    templateAssetUrl: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widget-my-rewards/app.v1.4.4-7021.js",
                    cssOverrideAssetUrl: "https://cdn-widget-assets.yotpo.com/MyRewardsWidget/pc-_zsvJHOoRaZ3ebWa_rg/css-overrides/css-overrides.2025_01_20_03_02_44_246.css",
                    customizationCssUrl: "",
                    customizations: {
                      "layout-add-background": "true",
                      "layout-background-color": "rgba(248,247,243,1)",
                      "logged-in-description-color": "rgba(0,0,0,1)",
                      "logged-in-description-font-size": "22",
                      "logged-in-description-text": "{{current_point_balance}} points",
                      "logged-in-description-tier-status-text": "{{current_vip_tier_name}} tier",
                      "logged-in-headline-color": "#000000",
                      "logged-in-headline-font-size": "40",
                      "logged-in-headline-text": "Hi {{first_name}}!",
                      "logged-in-primary-button-cta-type": "redemptionWidget",
                      "logged-in-primary-button-text": "Redeem points",
                      "logged-in-secondary-button-text": "Rewards history",
                      "logged-out-headline-color": "#000000",
                      "logged-out-headline-font-size": "26",
                      "logged-out-headline-text": "How it Works",
                      "logged-out-selected-step-name": "step_1",
                      "primary-button-background-color": "#000000",
                      "primary-button-text-color": "#FFFFFF",
                      "primary-button-type": "filled_rectangle",
                      "primary-font-name-and-url": "founders-grotesk-regular@400|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK/founders-grotesk-regular/founders-grotesk-regular-400.css",
                      "reward-step-1-displayname": "Step 1",
                      "reward-step-1-settings-description": "Create an account and\nearn 200 points.",
                      "reward-step-1-settings-description-color": "rgba(0,0,0,1)",
                      "reward-step-1-settings-description-font-size": "16",
                      "reward-step-1-settings-icon": "custom",
                      "reward-step-1-settings-icon-color": "#000000",
                      "reward-step-1-settings-icon-url": "https://cdn-widget-assets.yotpo.com/static_assets/pc-_zsvJHOoRaZ3ebWa_rg/images/image_2025_01_20_03_00_17_503",
                      "reward-step-1-settings-title": "Sign up",
                      "reward-step-1-settings-title-color": "rgba(0,0,0,1)",
                      "reward-step-1-settings-title-font-size": "20",
                      "reward-step-2-displayname": "Step 2",
                      "reward-step-2-settings-description": "Earn points every time\nyou shop.",
                      "reward-step-2-settings-description-color": "rgba(0,0,0,1)",
                      "reward-step-2-settings-description-font-size": "16",
                      "reward-step-2-settings-icon": "custom",
                      "reward-step-2-settings-icon-color": "#000000",
                      "reward-step-2-settings-icon-url": "https://cdn-widget-assets.yotpo.com/static_assets/pc-_zsvJHOoRaZ3ebWa_rg/images/image_2025_01_20_03_00_28_058",
                      "reward-step-2-settings-title": "Earn points",
                      "reward-step-2-settings-title-color": "rgba(0,0,0,1)",
                      "reward-step-2-settings-title-font-size": "20",
                      "reward-step-3-displayname": "Step 3",
                      "reward-step-3-settings-description": "Redeem points for\nexclusive rewards.",
                      "reward-step-3-settings-description-color": "rgba(0,0,0,1)",
                      "reward-step-3-settings-description-font-size": "16",
                      "reward-step-3-settings-icon": "custom",
                      "reward-step-3-settings-icon-color": "#000000",
                      "reward-step-3-settings-icon-url": "https://cdn-widget-assets.yotpo.com/static_assets/pc-_zsvJHOoRaZ3ebWa_rg/images/image_2025_01_20_03_00_36_793",
                      "reward-step-3-settings-title": "Redeem points",
                      "reward-step-3-settings-title-color": "rgba(0,0,0,1)",
                      "reward-step-3-settings-title-font-size": "20",
                      "rewards-history-approved-text": "Approved",
                      "rewards-history-background-color": "rgba(248,247,243,0.8)",
                      "rewards-history-headline-color": "rgba(0,0,0,1)",
                      "rewards-history-headline-font-size": "26",
                      "rewards-history-headline-text": "Rewards History",
                      "rewards-history-pending-text": "Pending",
                      "rewards-history-refunded-text": "Refunded",
                      "rewards-history-reversed-text": "Reversed",
                      "rewards-history-table-action-col-text": "Action",
                      "rewards-history-table-date-col-text": "Date",
                      "rewards-history-table-expiration-col-text": "Points expire on",
                      "rewards-history-table-points-col-text": "Points",
                      "rewards-history-table-status-col-text": "Status",
                      "rewards-history-table-store-col-text": "Store",
                      "secondary-button-background-color": "#000000",
                      "secondary-button-text-color": "rgba(255,255,255,1)",
                      "secondary-button-type": "filled_rectangle",
                      "secondary-font-name-and-url": "founders-grotesk-regular@400|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK/founders-grotesk-regular/founders-grotesk-regular-400.css",
                      "show-logged-in-description-points-balance": true,
                      "show-logged-in-description-tier-status": false,
                      "view-grid-points-column-color": "rgba(0,0,0,1)",
                      "view-grid-rectangular-background-color": "#F6F1EE",
                      "view-grid-type": "stripes"
                    },
                    staticContent: {
                      "cssEditorEnabled": true,
                      "currency": "PLN",
                      "isHidden": false,
                      "isMultiCurrencyEnabled": true,
                      "isMultiStoreMerchant": false,
                      "isOptInFlowEnabled": false,
                      "isShopifyNewAccountsVersion": false,
                      "isVipTiersEnabled": true,
                      "merchantId": "181985",
                      "platformName": "shopify",
                      "storeId": "yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK"
                    },
                    className: "MyRewardsWidget",
                    dependencyGroupId: 2
                },
            
                "1011644": {
                    instanceId: "1011644",
                    instanceVersionId: "347075652",
                    templateAssetUrl: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widget-loyalty-campaigns/app.v1.2.5-6990.js",
                    cssOverrideAssetUrl: "https://cdn-widget-assets.yotpo.com/CampaignWidget/pc-_zsvJHOoRaZ3ebWa_rg/css-overrides/css-overrides.2025_01_20_03_13_11_424.css",
                    customizationCssUrl: "",
                    customizations: {
                      "campaign-description-font-color": "#6C6C6C",
                      "campaign-description-size": "16px",
                      "campaign-item-1436740-background-color": "transparent",
                      "campaign-item-1436740-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-1436740-background-type": "color",
                      "campaign-item-1436740-border-color": "rgba(0,0,0,1)",
                      "campaign-item-1436740-description-font-color": "rgba(0,0,0,1)",
                      "campaign-item-1436740-description-font-size": "16",
                      "campaign-item-1436740-exclude_audience_names": [],
                      "campaign-item-1436740-hover-view-tile-message": "Earn 1 point for every zł1 spent",
                      "campaign-item-1436740-icon-color": "#60a3a3",
                      "campaign-item-1436740-icon-type": "noIcon",
                      "campaign-item-1436740-include_audience_ids": "1",
                      "campaign-item-1436740-include_audience_names": [
                        "All customers"
                      ],
                      "campaign-item-1436740-special-reward-enabled": "false",
                      "campaign-item-1436740-special-reward-headline-background-color": "#D2E3E3",
                      "campaign-item-1436740-special-reward-headline-text": "Just for you!",
                      "campaign-item-1436740-special-reward-headline-title-font-color": "#000000",
                      "campaign-item-1436740-special-reward-headline-title-font-size": "12",
                      "campaign-item-1436740-special-reward-tile-border-color": "#000000",
                      "campaign-item-1436740-tile-description": "Make a purchase",
                      "campaign-item-1436740-tile-reward": "1 point for every zł1 spent",
                      "campaign-item-1436740-title-font-color": "#000000",
                      "campaign-item-1436740-title-font-size": 20,
                      "campaign-item-1436740-type": "PointsForPurchasesCampaign",
                      "campaign-item-1462605-action-tile-ask-year": "true",
                      "campaign-item-1462605-action-tile-birthday-required-field-message": "This field is required",
                      "campaign-item-1462605-action-tile-birthday-thank-you-message": "Thanks! We're looking forward to helping you celebrate :)",
                      "campaign-item-1462605-action-tile-european-date-format": "false",
                      "campaign-item-1462605-action-tile-message-text": "If your birthday is within the next 30 days, your reward will be granted in delay, up to 30 days.",
                      "campaign-item-1462605-action-tile-month-names": "January,February,March,April,May,June,July,August,September,October,November,December",
                      "campaign-item-1462605-action-tile-title": "Earn 600 points on your birthday",
                      "campaign-item-1462605-background-color": "transparent",
                      "campaign-item-1462605-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-1462605-background-type": "color",
                      "campaign-item-1462605-border-color": "rgba(0,0,0,1)",
                      "campaign-item-1462605-description-font-color": "rgba(0,0,0,1)",
                      "campaign-item-1462605-description-font-size": "16",
                      "campaign-item-1462605-exclude_audience_names": [],
                      "campaign-item-1462605-icon-color": "#60a3a3",
                      "campaign-item-1462605-icon-type": "noIcon",
                      "campaign-item-1462605-include_audience_ids": "1",
                      "campaign-item-1462605-include_audience_names": [
                        "All customers"
                      ],
                      "campaign-item-1462605-special-reward-enabled": "false",
                      "campaign-item-1462605-special-reward-headline-background-color": "#D2E3E3",
                      "campaign-item-1462605-special-reward-headline-text": "Just for you!",
                      "campaign-item-1462605-special-reward-headline-title-font-color": "#000000",
                      "campaign-item-1462605-special-reward-headline-title-font-size": "12",
                      "campaign-item-1462605-special-reward-tile-border-color": "#000000",
                      "campaign-item-1462605-tile-description": "Birthday reward",
                      "campaign-item-1462605-tile-reward": "600 points",
                      "campaign-item-1462605-title-font-color": "#000000",
                      "campaign-item-1462605-title-font-size": 20,
                      "campaign-item-1462605-type": "BirthdayCampaign",
                      "campaign-item-1466325-action-tile-action-text": "@the_odderside",
                      "campaign-item-1466325-action-tile-title": "Earn 20 points when you follow us on Instagram",
                      "campaign-item-1466325-background-color": "transparent",
                      "campaign-item-1466325-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-1466325-background-type": "color",
                      "campaign-item-1466325-border-color": "rgba(0,0,0,1)",
                      "campaign-item-1466325-description-font-color": "rgba(0,0,0,1)",
                      "campaign-item-1466325-description-font-size": "16",
                      "campaign-item-1466325-exclude_audience_names": [],
                      "campaign-item-1466325-icon-color": "#60a3a3",
                      "campaign-item-1466325-icon-type": "noIcon",
                      "campaign-item-1466325-include_audience_ids": "1",
                      "campaign-item-1466325-include_audience_names": [
                        "All customers"
                      ],
                      "campaign-item-1466325-special-reward-enabled": "false",
                      "campaign-item-1466325-special-reward-headline-background-color": "#D2E3E3",
                      "campaign-item-1466325-special-reward-headline-text": "Just for you!",
                      "campaign-item-1466325-special-reward-headline-title-font-color": "#000000",
                      "campaign-item-1466325-special-reward-headline-title-font-size": "12",
                      "campaign-item-1466325-special-reward-tile-border-color": "#000000",
                      "campaign-item-1466325-tile-description": "Follow us on Instagram",
                      "campaign-item-1466325-tile-reward": "20 points",
                      "campaign-item-1466325-title-font-color": "#000000",
                      "campaign-item-1466325-title-font-size": 20,
                      "campaign-item-1466325-type": "InstagramFollowCampaign",
                      "campaign-item-1466686-action-tile-action-text": "Visit Page",
                      "campaign-item-1466686-action-tile-title": "Earn 20 points when you visit our page",
                      "campaign-item-1466686-background-color": "transparent",
                      "campaign-item-1466686-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-1466686-background-type": "color",
                      "campaign-item-1466686-border-color": "rgba(0,0,0,1)",
                      "campaign-item-1466686-description-font-color": "rgba(0,0,0,1)",
                      "campaign-item-1466686-description-font-size": "16",
                      "campaign-item-1466686-exclude_audience_names": [],
                      "campaign-item-1466686-icon-color": "#60a3a3",
                      "campaign-item-1466686-icon-type": "noIcon",
                      "campaign-item-1466686-include_audience_ids": "1",
                      "campaign-item-1466686-include_audience_names": [
                        "All customers"
                      ],
                      "campaign-item-1466686-special-reward-enabled": "false",
                      "campaign-item-1466686-special-reward-headline-background-color": "#D2E3E3",
                      "campaign-item-1466686-special-reward-headline-text": "Just for you!",
                      "campaign-item-1466686-special-reward-headline-title-font-color": "#000000",
                      "campaign-item-1466686-special-reward-headline-title-font-size": "12",
                      "campaign-item-1466686-special-reward-tile-border-color": "#000000",
                      "campaign-item-1466686-tile-description": "Visit our page",
                      "campaign-item-1466686-tile-reward": "20 points",
                      "campaign-item-1466686-title-font-color": "#000000",
                      "campaign-item-1466686-title-font-size": 20,
                      "campaign-item-1466686-type": "FacebookPageVisitCampaign",
                      "campaign-item-1569313-background-color": "transparent",
                      "campaign-item-1569313-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-1569313-background-type": "color",
                      "campaign-item-1569313-border-color": "rgba(0,0,0,1)",
                      "campaign-item-1569313-description-font-color": "rgba(0,0,0,1)",
                      "campaign-item-1569313-description-font-size": "16",
                      "campaign-item-1569313-exclude_audience_names": [],
                      "campaign-item-1569313-hover-view-tile-message": "Earn 200 points when you join our rewards program",
                      "campaign-item-1569313-icon-color": "#60a3a3",
                      "campaign-item-1569313-icon-type": "noIcon",
                      "campaign-item-1569313-include_audience_ids": "1",
                      "campaign-item-1569313-include_audience_names": [
                        "All customers"
                      ],
                      "campaign-item-1569313-special-reward-enabled": "false",
                      "campaign-item-1569313-special-reward-headline-background-color": "#D2E3E3",
                      "campaign-item-1569313-special-reward-headline-text": "Just for you!",
                      "campaign-item-1569313-special-reward-headline-title-font-color": "#000000",
                      "campaign-item-1569313-special-reward-headline-title-font-size": "12",
                      "campaign-item-1569313-special-reward-tile-border-color": "#000000",
                      "campaign-item-1569313-tile-description": "Join our program",
                      "campaign-item-1569313-tile-reward": "200 points",
                      "campaign-item-1569313-title-font-color": "#000000",
                      "campaign-item-1569313-title-font-size": 20,
                      "campaign-item-1569313-type": "CreateAccountCampaign",
                      "campaign-item-1569314-action-tile-action-text": "Visit Page",
                      "campaign-item-1569314-action-tile-title": "Earn 20 points when you visit our page",
                      "campaign-item-1569314-background-color": "transparent",
                      "campaign-item-1569314-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-1569314-background-type": "color",
                      "campaign-item-1569314-border-color": "rgba(0,0,0,1)",
                      "campaign-item-1569314-description-font-color": "rgba(0,0,0,1)",
                      "campaign-item-1569314-description-font-size": "16",
                      "campaign-item-1569314-exclude_audience_names": [],
                      "campaign-item-1569314-icon-color": "#60a3a3",
                      "campaign-item-1569314-icon-type": "noIcon",
                      "campaign-item-1569314-include_audience_ids": "1",
                      "campaign-item-1569314-include_audience_names": [
                        "All customers"
                      ],
                      "campaign-item-1569314-special-reward-enabled": "false",
                      "campaign-item-1569314-special-reward-headline-background-color": "#D2E3E3",
                      "campaign-item-1569314-special-reward-headline-text": "Just for you!",
                      "campaign-item-1569314-special-reward-headline-title-font-color": "#000000",
                      "campaign-item-1569314-special-reward-headline-title-font-size": "12",
                      "campaign-item-1569314-special-reward-tile-border-color": "#000000",
                      "campaign-item-1569314-tile-description": "Visit our page",
                      "campaign-item-1569314-tile-reward": "20 points",
                      "campaign-item-1569314-title-font-color": "#000000",
                      "campaign-item-1569314-title-font-size": 20,
                      "campaign-item-1569314-type": "FacebookPageVisitCampaign",
                      "campaign-item-1569340-action-tile-action-text": "Click Here",
                      "campaign-item-1569340-action-tile-title": "Earn 40 points when you complete this action",
                      "campaign-item-1569340-background-color": "transparent",
                      "campaign-item-1569340-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-1569340-background-type": "color",
                      "campaign-item-1569340-border-color": "rgba(0,0,0,1)",
                      "campaign-item-1569340-description-font-color": "rgba(0,0,0,1)",
                      "campaign-item-1569340-description-font-size": "16",
                      "campaign-item-1569340-exclude_audience_names": [],
                      "campaign-item-1569340-icon-color": "#60a3a3",
                      "campaign-item-1569340-icon-type": "noIcon",
                      "campaign-item-1569340-include_audience_ids": "1",
                      "campaign-item-1569340-include_audience_names": [
                        "All customers"
                      ],
                      "campaign-item-1569340-special-reward-enabled": "false",
                      "campaign-item-1569340-special-reward-headline-background-color": "#D2E3E3",
                      "campaign-item-1569340-special-reward-headline-text": "Just for you!",
                      "campaign-item-1569340-special-reward-headline-title-font-color": "#000000",
                      "campaign-item-1569340-special-reward-headline-title-font-size": "12",
                      "campaign-item-1569340-special-reward-tile-border-color": "#000000",
                      "campaign-item-1569340-tile-description": "Sign up to our Newsletter",
                      "campaign-item-1569340-tile-reward": "40 Points",
                      "campaign-item-1569340-title-font-color": "#000000",
                      "campaign-item-1569340-title-font-size": 20,
                      "campaign-item-1569340-type": "CustomActionCampaign",
                      "campaign-item-1569340-view-show-custom-action-button": "false",
                      "campaign-title-font-color": "#000000",
                      "campaign-title-size": "20px",
                      "completed-tile-headline": "Completed",
                      "completed-tile-message": "You've already used this option",
                      "container-headline": "Ways to Earn",
                      "general-hover-tile-button-color": "rgba(255,255,255,1)",
                      "general-hover-tile-button-text-color": "rgba(0,0,0,1)",
                      "general-hover-tile-button-type": "filled_rectangle",
                      "general-hover-tile-color-overlay": "rgba(0,0,0,1)",
                      "general-hover-tile-text-color": "rgba(255,255,255,1)",
                      "headline-font-color": "#000000",
                      "headline-font-size": "26px",
                      "layout-background-color": "#FFFFFF",
                      "layout-background-enabled": "true",
                      "logged-in-non-member-button-text": "Join now",
                      "logged-in-non-member-link-destination": "banner_section",
                      "logged-out-is-redirect-after-login-to-current-page": "true",
                      "logged-out-message": "Already a member?",
                      "logged-out-sign-in-text": "Log in",
                      "logged-out-sign-up-text": "Sign up",
                      "main-text-font-name-and-url": "founders-grotesk-regular@400|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK/founders-grotesk-regular/founders-grotesk-regular-400.css",
                      "secondary-text-font-name-and-url": "founders-grotesk-regular@400|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK/founders-grotesk-regular/founders-grotesk-regular-400.css",
                      "selected-audiences": "1",
                      "selected-extensions": [
                        "1436740",
                        "1569313",
                        "1462605",
                        "1466686",
                        "1466325",
                        "1569314",
                        "1569340"
                      ],
                      "special-reward-enabled": "false",
                      "special-reward-headline-background-color": "#D2E3E3",
                      "special-reward-headline-text": "Special for you",
                      "special-reward-headline-title-font-color": "#000000",
                      "special-reward-headline-title-font-size": "12",
                      "special-reward-tile-border-color": "#000000",
                      "tile-border-color": "#BCBCBC",
                      "tile-spacing-type": "small",
                      "tiles-background-color": "#FFFFFF",
                      "time-between-rewards-days": "You'll be eligible again in *|days|* days",
                      "time-between-rewards-hours": "You'll be eligible again in *|hours|* hours"
                    },
                    staticContent: {
                      "companyName": "The Odder Side",
                      "cssEditorEnabled": true,
                      "currency": "PLN",
                      "facebookAppId": "1647129615540489",
                      "isHidden": false,
                      "isMultiCurrencyEnabled": true,
                      "isOptInFlowEnabled": false,
                      "isSegmentationsPickerEnabled": true,
                      "isShopifyNewAccountsVersion": false,
                      "merchantId": "181985",
                      "platformName": "shopify",
                      "storeAccountLoginUrl": "//theodderside.com/account/login",
                      "storeAccountRegistrationUrl": "//theodderside.com/account/register",
                      "storeId": "yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK"
                    },
                    className: "CampaignWidget",
                    dependencyGroupId: 2
                },
            
                "1011643": {
                    instanceId: "1011643",
                    instanceVersionId: "347075657",
                    templateAssetUrl: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widget-referral-share/app.v0.4.22-7034.js",
                    cssOverrideAssetUrl: "https://cdn-widget-assets.yotpo.com/ReferralShareWidget/pc-_zsvJHOoRaZ3ebWa_rg/css-overrides/css-overrides.2025_01_20_03_13_11_178.css",
                    customizationCssUrl: "",
                    customizations: {
                      "background-color": "rgba(255,255,255,1)",
                      "customer-email-view-button-text": "Next",
                      "customer-email-view-description-discount-discount": "Give your friends {{friend_reward}} their first purchase of {{min_spent}}, and get {{customer_reward}} for each successful referral.",
                      "customer-email-view-description-discount-points": "Give your friends {{friend_reward}} their first purchase of {{min_spent}}, and get {{customer_reward}} points for each successful referral.",
                      "customer-email-view-description-nothing-discount": "Get {{customer_reward}} for each successful referral.",
                      "customer-email-view-description-nothing-points": "Get {{customer_reward}} points for each successful referral.",
                      "customer-email-view-description-points-discount": "Give your friends {{friend_reward}} points, and get {{customer_reward}} for each successful referral.",
                      "customer-email-view-description-points-points": "Give your friends {{friend_reward}} points, and get {{customer_reward}} points for each successful referral.",
                      "customer-email-view-header": "Refer a Friend",
                      "customer-email-view-input-placeholder": "Your email address",
                      "customer-email-view-title-discount-discount": "GIVE {{friend_reward}}, GET {{customer_reward}}",
                      "customer-email-view-title-discount-points": "GIVE {{friend_reward}}, GET {{customer_reward}} POINTS",
                      "customer-email-view-title-nothing-discount": "REFER A FRIEND, GET {{customer_reward}} FOR REFERRALS",
                      "customer-email-view-title-nothing-points": "REFER A FRIEND, GET {{customer_reward}} POINTS FOR REFERRALS",
                      "customer-email-view-title-points-discount": "GIVE {{friend_reward}} POINTS, GET {{customer_reward}}",
                      "customer-email-view-title-points-points": "GIVE {{friend_reward}} POINTS, GET {{customer_reward}} POINTS",
                      "customer-name-view-input-placeholder": "Your name",
                      "default-toggle": true,
                      "description-color": "rgba(0,0,0,1)",
                      "description-font-size": "20px",
                      "desktop-background-image-url": "https://cdn-widget-assets.yotpo.com/static_assets/pc-_zsvJHOoRaZ3ebWa_rg/images/image_2025_01_20_03_11_59_379",
                      "disabled-referral-code-error": "Looks like your referral link was deactivated",
                      "email-fill-color": "#F6F1EE",
                      "email-input-type": "rounded_rectangle",
                      "email-outline-color": "#000000",
                      "email-text-color": "#000000",
                      "final-view-button-text": "Refer more friends",
                      "final-view-description": "Remind your friends to check their email",
                      "final-view-error-description": "We were unable to share the referral link. Go back to the previous step to try again.",
                      "final-view-error-text": "Back",
                      "final-view-error-title": "Something went wrong",
                      "final-view-title": "Thank you for referring!",
                      "fonts-primary-font-name-and-url": "founders-grotesk-regular@400|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK/founders-grotesk-regular/founders-grotesk-regular-400.css",
                      "fonts-secondary-font-name-and-url": "founders-grotesk-regular@400|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK/founders-grotesk-regular/founders-grotesk-regular-400.css",
                      "header-color": "#000000",
                      "header-font-size": "20px",
                      "login-view-description-discount-discount": "Give your friends {{friend_reward}} their first purchase of {{min_spent}}, and get {{customer_reward}} for each successful referral.",
                      "login-view-description-discount-points": "Give your friends {{60_local_currency}} their first purchase of {{min_spent}}, and get {{customer_reward}} points for each successful referral.",
                      "login-view-description-nothing-discount": "Get {{customer_reward}} for each successful referral.",
                      "login-view-description-nothing-points": "Get {{customer_reward}} points for each successful referral.",
                      "login-view-description-points-discount": "Give your friends {{friend_reward}} points, and get {{customer_reward}} for each successful referral.",
                      "login-view-description-points-points": "Give your friends {{friend_reward}} points, and get {{customer_reward}} points for each successful referral.",
                      "login-view-header": "Refer a Friend",
                      "login-view-log-in-button-text": "Log in",
                      "login-view-sign-up-button-text": "Join now",
                      "login-view-title-discount-discount": "GIVE {{friend_reward}}, GET {{customer_reward}}",
                      "login-view-title-discount-points": "GIVE {{60_local_currency}}, GET {{customer_reward}} POINTS",
                      "login-view-title-nothing-discount": "REFER A FRIEND, GET {{customer_reward}} FOR REFERRALS",
                      "login-view-title-nothing-points": "REFER A FRIEND, GET {{customer_reward}} POINTS FOR REFERRALS",
                      "login-view-title-points-discount": "GIVE {{friend_reward}} POINTS, GET {{customer_reward}}",
                      "login-view-title-points-points": "GIVE {{friend_reward}} POINTS, GET {{customer_reward}} POINTS",
                      "main-share-option-desktop": "main_share_copy_link",
                      "main-share-option-mobile": "main_share_sms",
                      "mobile-background-image-url": "https://cdn-widget-assets.yotpo.com/static_assets/pc-_zsvJHOoRaZ3ebWa_rg/images/image_2025_01_20_03_12_03_788",
                      "more-share-ways-text": "MORE WAYS TO SHARE",
                      "primary-button-background-color": "rgba(0,0,0,1)",
                      "primary-button-font-size": "16px",
                      "primary-button-size": "standard",
                      "primary-button-text-color": "#FFFFFF",
                      "primary-button-type": "filled_rectangle",
                      "reduced-picture": true,
                      "referral-history-completed-points-text": "{{points}} POINTS",
                      "referral-history-completed-status-type": "text",
                      "referral-history-confirmed-status": "Completed",
                      "referral-history-pending-status": "Pending",
                      "referral-history-redeem-text": "You can redeem your points for a reward, or apply your reward code at checkout.",
                      "referral-history-sumup-line-points-text": "{{points}} POINTS",
                      "referral-history-sumup-line-text": "Your Rewards",
                      "referral-views-button-text": "Next",
                      "referral-views-copy-link-button-text": "Copy link",
                      "referral-views-description-discount-discount": "Give your friends {{friend_reward}} their first purchase of {{min_spent}}, and get {{customer_reward}} for each successful referral.",
                      "referral-views-description-discount-points": "Give your friends {{60_local_currency}} their first purchase of {{min_spent}}, and get {{customer_reward}} points for each successful referral.",
                      "referral-views-description-nothing-discount": "Get {{customer_reward}} for each successful referral.",
                      "referral-views-description-nothing-points": "Get {{customer_reward}} points for each successful referral.",
                      "referral-views-description-points-discount": "Give your friends {{friend_reward}} points, and get {{customer_reward}} for each successful referral.",
                      "referral-views-description-points-points": "Give your friends {{friend_reward}} points, and get {{customer_reward}} points for each successful referral.",
                      "referral-views-email-share-body": "How does a discount off your first order at {{company_name}} sound? Use the link below and once you've shopped, I'll get a reward too.\n{{referral_link}}",
                      "referral-views-email-share-subject": "Discount to a Store You'll Love!",
                      "referral-views-email-share-type": "personal_email",
                      "referral-views-friends-input-placeholder": "Friend’s email address",
                      "referral-views-header": "Refer a Friend",
                      "referral-views-personal-email-button-text": "Share via email",
                      "referral-views-sms-button-text": "Share via SMS",
                      "referral-views-title-discount-discount": "GIVE {{friend_reward}}, GET {{customer_reward}}",
                      "referral-views-title-discount-points": "GIVE {{60_local_currency}}, GET {{customer_reward}} POINTS",
                      "referral-views-title-nothing-discount": "REFER A FRIEND, GET {{customer_reward}} FOR REFERRALS",
                      "referral-views-title-nothing-points": "REFER A FRIEND, GET {{customer_reward}} POINTS FOR REFERRALS",
                      "referral-views-title-points-discount": "GIVE {{friend_reward}} POINTS, GET {{customer_reward}}",
                      "referral-views-title-points-points": "GIVE {{friend_reward}} POINTS, GET {{customer_reward}} POINTS",
                      "referral-views-whatsapp-button-text": "Share via WhatsApp",
                      "secondary-button-background-color": "rgba(0,0,0,1)",
                      "secondary-button-text-color": "rgba(255,255,255,1)",
                      "secondary-button-type": "filled_rectangle",
                      "share-allow-copy-link": true,
                      "share-allow-email": true,
                      "share-allow-sms": true,
                      "share-allow-whatsapp": true,
                      "share-headline-text-color": "rgba(0,0,0,1)",
                      "share-icons-color": "rgba(0,0,0,1)",
                      "share-settings-copyLink": true,
                      "share-settings-default-checkbox": true,
                      "share-settings-default-mobile-checkbox": true,
                      "share-settings-email": true,
                      "share-settings-mobile-copyLink": true,
                      "share-settings-mobile-email": true,
                      "share-settings-mobile-sms": true,
                      "share-settings-mobile-whatsapp": true,
                      "share-settings-whatsapp": true,
                      "share-sms-message": "I love {{company_name}}! Shop through my link to get a reward {{referral_link}}",
                      "share-whatsapp-message": "I love {{company_name}}! Shop through my link to get a reward {{referral_link}}",
                      "tab-size": "small",
                      "tab-type": "lower_line",
                      "tab-view-primary-tab-text": "Refer a Friend",
                      "tab-view-secondary-tab-text": "Your Referrals",
                      "tile-color": "rgba(255,255,255,1)",
                      "title-color": "#000000",
                      "title-font-size": "36px",
                      "view-exit-intent-enabled": false,
                      "view-exit-intent-mobile-timeout-ms": 10000,
                      "view-is-popup": false,
                      "view-layout": "left",
                      "view-popup-delay-ms": 0,
                      "view-show-customer-name": false,
                      "view-show-popup-on-exit": false,
                      "view-show-referral-history": false,
                      "view-table-rectangular-dark-pending-color": "rgba( 0, 0, 0, 0.6 )",
                      "view-table-rectangular-light-pending-color": "#FFFFFF",
                      "view-table-selected-color": "#0F8383",
                      "view-table-theme": "dark",
                      "view-table-type": "lines",
                      "wadmin-text-and-share-choose-sreen": "step_1"
                    },
                    staticContent: {
                      "advocateLoggedInRequirement": true,
                      "advocateRewardType": "POINTS",
                      "companyName": "The Odder Side",
                      "cssEditorEnabled": true,
                      "currency": "PLN",
                      "friendRewardType": "NOTHING",
                      "hasPrimaryFontsFeature": true,
                      "isFreeMerchant": false,
                      "isHidden": false,
                      "isMultiCurrencyEnabled": true,
                      "merchantId": "181985",
                      "migrateTabColorToBackground": true,
                      "platformName": "shopify",
                      "referralHistoryEnabled": true,
                      "referralHost": "http://rwrd.io",
                      "storeId": "yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK"
                    },
                    className: "ReferralShareWidget",
                    dependencyGroupId: null
                },
            
                "1011642": {
                    instanceId: "1011642",
                    instanceVersionId: "328737067",
                    templateAssetUrl: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widget-hero-section/app.v1.7.20-7160.js",
                    cssOverrideAssetUrl: "",
                    customizationCssUrl: "",
                    customizations: {
                      "background-image-url": "https://cdn-widget-assets.yotpo.com/static_assets/pc-_zsvJHOoRaZ3ebWa_rg/images/image_2025_01_20_03_01_51_641",
                      "description-color": "#000000",
                      "description-font-size": 20,
                      "description-text-logged-in": "As a member, you'll earn points and exclusive rewards every time you shop.",
                      "description-text-logged-out": "Become a member and earn points and exclusive rewards every time you shop.",
                      "headline-color": "#000000",
                      "headline-font-size": 36,
                      "headline-text-logged-in": "Welcome to the club",
                      "headline-text-logged-in-non-member": "You’re a step away from rewards!",
                      "headline-text-logged-in-subtitle-text-non-member": "Join our rewards program and earn points and exclusive rewards every time you shop.",
                      "headline-text-logged-out": "Join the club",
                      "login-button-color": "#000000",
                      "login-button-text": "Log in",
                      "login-button-text-color": "rgba(255,255,255,1)",
                      "login-button-type": "filled_rectangle",
                      "member-optin-disclaimer": "To customize the disclaimer and button asking non-members to join your program, go to \u003cb\u003ePage Settings.\u003c/b\u003e",
                      "mobile-background-image-url": "https://cdn-widget-assets.yotpo.com/static_assets/pc-_zsvJHOoRaZ3ebWa_rg/images/image_2025_01_20_03_01_54_750",
                      "mode-is-page-settings": false,
                      "primary-font-name-and-url": "founders-grotesk-regular@400|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK/founders-grotesk-regular/founders-grotesk-regular-400.css",
                      "register-button-color": "#000000",
                      "register-button-text": "Join now",
                      "register-button-text-color": "#ffffff",
                      "register-button-type": "filled_rectangle",
                      "reward-opt-in-join-now-button-label": "Complete program signup",
                      "rewards-disclaimer-text": "I agree to the program’s [terms](http://example.net/terms) and [privacy policy](http://example.net/privacy-policy)",
                      "rewards-disclaimer-text-color": "#00000",
                      "rewards-disclaimer-text-size": "12px",
                      "rewards-disclaimer-type": "no-disclaimer",
                      "secondary-font-name-and-url": "founders-grotesk-regular@400|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK/founders-grotesk-regular/founders-grotesk-regular-400.css",
                      "text-background-color": "rgba(255,255,255,0.7)",
                      "text-background-show-on-desktop": true,
                      "text-background-show-on-mobile": "true",
                      "view-layout": "center-layout"
                    },
                    staticContent: {
                      "cssEditorEnabled": true,
                      "isHidden": false,
                      "isOptInFlowEnabled": false,
                      "isShopifyNewAccountsVersion": false,
                      "merchantId": "181985",
                      "platformName": "shopify",
                      "storeId": "yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK",
                      "storeLoginUrl": "//theodderside.com/account/login",
                      "storeRegistrationUrl": "//theodderside.com/account/register"
                    },
                    className: "HeroSectionWidget",
                    dependencyGroupId: 2
                },
            
                "1011641": {
                    instanceId: "1011641",
                    instanceVersionId: "327451060",
                    templateAssetUrl: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widget-visual-redemption/app.v1.1.3-6746.js",
                    cssOverrideAssetUrl: "",
                    customizationCssUrl: "",
                    customizations: {
                      "description-color": "#6C6C6C",
                      "description-font-size": "16",
                      "headline-color": "#000000",
                      "headline-font-size": "26",
                      "layout-background-color": "#F6F1EE",
                      "primary-font-name-and-url": "Poppins@600|https://cdn-widgetsrepository.yotpo.com/web-fonts/css/poppins/v1/poppins_600.css",
                      "redemption-1-displayname": "Tile 1",
                      "redemption-1-settings-cost": "0 points",
                      "redemption-1-settings-cost-color": "#6C6C6C",
                      "redemption-1-settings-cost-font-size": "16",
                      "redemption-1-settings-frame-color": "#BCBCBC",
                      "redemption-1-settings-reward": "$0 off",
                      "redemption-1-settings-reward-color": "#000000",
                      "redemption-1-settings-reward-font-size": "20",
                      "redemption-2-displayname": "Tile 2",
                      "redemption-2-settings-cost": "0 points",
                      "redemption-2-settings-cost-color": "#6C6C6C",
                      "redemption-2-settings-cost-font-size": "16",
                      "redemption-2-settings-frame-color": "#BCBCBC",
                      "redemption-2-settings-reward": "$0 off",
                      "redemption-2-settings-reward-color": "#000000",
                      "redemption-2-settings-reward-font-size": "20",
                      "redemption-3-displayname": "Tile 3",
                      "redemption-3-settings-cost": "0 points",
                      "redemption-3-settings-cost-color": "#6C6C6C",
                      "redemption-3-settings-cost-font-size": "16",
                      "redemption-3-settings-frame-color": "#BCBCBC",
                      "redemption-3-settings-reward": "$0 off",
                      "redemption-3-settings-reward-color": "#000000",
                      "redemption-3-settings-reward-font-size": "20",
                      "rule-color": "#000000",
                      "rule-dots-color": "#6C6C6C",
                      "rule-font-size": "16",
                      "secondary-font-name-and-url": "Poppins@400|https://cdn-widgetsrepository.yotpo.com/web-fonts/css/poppins/v1/poppins_400.css",
                      "selected-extensions": [
                        "1",
                        "2",
                        "3"
                      ],
                      "view-layout": "full-layout",
                      "visual-redemption-description": "Redeeming your points is easy! Just log in, and choose an eligible reward at checkout.",
                      "visual-redemption-headline": "How to Use Your Points",
                      "visual-redemption-rule": "100 points equals $1"
                    },
                    staticContent: {
                      "cssEditorEnabled": true,
                      "currency": "PLN",
                      "isHidden": false,
                      "isMultiCurrencyEnabled": true,
                      "isShopifyNewAccountsVersion": false,
                      "platformName": "shopify",
                      "storeId": "yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK"
                    },
                    className: "VisualRedemptionWidget",
                    dependencyGroupId: 2
                },
            
                "1011640": {
                    instanceId: "1011640",
                    instanceVersionId: "328600747",
                    templateAssetUrl: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widget-vip-tiers/app.v2.3.1-7150.js",
                    cssOverrideAssetUrl: "",
                    customizationCssUrl: "",
                    customizations: {
                      "background-color": "#FFFFFF",
                      "background-enabled": "true",
                      "benefits-font-size": "14px",
                      "benefits-icon-color": "rgba(0,0,0,1)",
                      "benefits-icon-type": "default",
                      "benefits-text-color": "rgba(0,0,0,1)",
                      "card-background-border-color": "rgba(0,0,0,0)",
                      "card-background-color": "#FFFFFF",
                      "card-background-shadow": "true",
                      "card-separator-color": "#BCBCBC",
                      "card-separator-enabled": "false",
                      "current-status-bg-color": "rgba(0,0,0,1)",
                      "current-status-tag": "true",
                      "current-status-text": "Current status",
                      "current-status-text-color": "rgba(255,255,255,1)",
                      "current-tier-border-color": "rgba(0,0,0,1)",
                      "grid-lines-color": "#ACB5D4",
                      "headline-font-size": "26px",
                      "headline-text-color": "#000000",
                      "layout": "card",
                      "primary-font-name-and-url": "founders-grotesk-regular@400|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK/founders-grotesk-regular/founders-grotesk-regular-400.css",
                      "progress-bar-current-status": "{{amount_spent}} Spent",
                      "progress-bar-enabled": "true",
                      "progress-bar-headline-font-size": "14px",
                      "progress-bar-primary-color": "#000000",
                      "progress-bar-secondary-color": "rgba(0,0,0,1)",
                      "progress-bar-summary-current": "You are in {{current_vip_tier_name}} through the next earning period.",
                      "progress-bar-summary-font-size": "14px",
                      "progress-bar-summary-maintain": "Spend {{spend_needed}} by {{tier_expiration_date}} to maintain {{current_vip_tier_name}}",
                      "progress-bar-summary-next": "Spend {{spend_needed}} to reach {{next_vip_tier_name}} tier.",
                      "progress-bar-tier-status": "Tier status",
                      "progress-bar-you": "YOU",
                      "secondary-font-name-and-url": "founders-grotesk-regular@400|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK/founders-grotesk-regular/founders-grotesk-regular-400.css",
                      "selected-extensions": [
                        "30768",
                        "30769",
                        "30770",
                        "30846"
                      ],
                      "show-less-text": "- See less",
                      "show-more-text": "+ See more",
                      "tier-spacing": "small",
                      "tiers-30768-design-header-bg-color": "rgba(248,247,243,1)",
                      "tiers-30768-design-icon-fill-color": "rgba(0,0,0,1)",
                      "tiers-30768-design-icon-type": "default",
                      "tiers-30768-design-icon-url": "",
                      "tiers-30768-design-include-header-bg": "true",
                      "tiers-30768-design-name-font-size": "20px",
                      "tiers-30768-design-name-text-color": "#000000",
                      "tiers-30768-design-threshold-font-size": "16px",
                      "tiers-30768-design-threshold-text-color": "rgba(0,0,0,1)",
                      "tiers-30768-text-benefits": "Birthday Gift ||Earn points when you spend",
                      "tiers-30768-text-name": "Bronze",
                      "tiers-30768-text-rank": 1,
                      "tiers-30768-text-threshold": "Join",
                      "tiers-30769-design-header-bg-color": "rgba(248,247,243,1)",
                      "tiers-30769-design-icon-fill-color": "rgba(0,0,0,1)",
                      "tiers-30769-design-icon-type": "default",
                      "tiers-30769-design-icon-url": "",
                      "tiers-30769-design-include-header-bg": "true",
                      "tiers-30769-design-name-font-size": "20px",
                      "tiers-30769-design-name-text-color": "#000000",
                      "tiers-30769-design-threshold-font-size": "16px",
                      "tiers-30769-design-threshold-text-color": "rgba(0,0,0,1)",
                      "tiers-30769-text-benefits": "Silver Birthday Gift ||Earn points when you spend||Tier Entry Gift 500 Points",
                      "tiers-30769-text-name": "Silver",
                      "tiers-30769-text-rank": 2,
                      "tiers-30769-text-threshold": "Spend {{amount_spent}}",
                      "tiers-30770-design-header-bg-color": "rgba(248,247,243,1)",
                      "tiers-30770-design-icon-fill-color": "rgba(0,0,0,1)",
                      "tiers-30770-design-icon-type": "default",
                      "tiers-30770-design-icon-url": "",
                      "tiers-30770-design-include-header-bg": "true",
                      "tiers-30770-design-name-font-size": "20px",
                      "tiers-30770-design-name-text-color": "#000000",
                      "tiers-30770-design-threshold-font-size": "16px",
                      "tiers-30770-design-threshold-text-color": "rgba(0,0,0,1)",
                      "tiers-30770-text-benefits": "Gold Birthday Gift||Earn more points when you spend||Tier Entry Gift 1000 Points||Free Standard Shipping||Early Access to see the items in the New Collections",
                      "tiers-30770-text-name": "Gold",
                      "tiers-30770-text-rank": 3,
                      "tiers-30770-text-threshold": "Spend {{amount_spent}}",
                      "tiers-30846-design-header-bg-color": "rgba(248,247,243,1)",
                      "tiers-30846-design-icon-fill-color": "rgba(0,0,0,1)",
                      "tiers-30846-design-icon-type": "default",
                      "tiers-30846-design-icon-url": "",
                      "tiers-30846-design-include-header-bg": "true",
                      "tiers-30846-design-name-font-size": "20px",
                      "tiers-30846-design-name-text-color": "#000000",
                      "tiers-30846-design-threshold-font-size": "16px",
                      "tiers-30846-design-threshold-text-color": "rgba(0,0,0,1)",
                      "tiers-30846-text-benefits": "Platinum Birthday Gift ||Earn even more points when you spend||Tier Entry Gift 3000 Points||Free Express Shipping ||Early Access to the New Collections||Invitations to our VIP Events with a +1",
                      "tiers-30846-text-name": "Platinum ",
                      "tiers-30846-text-rank": "4",
                      "tiers-30846-text-threshold": "Spend {{amount_spent}}",
                      "widget-headline": "VIPs Earn Even More"
                    },
                    staticContent: {
                      "cssEditorEnabled": true,
                      "currency": "PLN",
                      "isHidden": false,
                      "isMultiCurrencyEnabled": true,
                      "merchantId": "181985",
                      "platformName": "shopify",
                      "storeId": "yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK"
                    },
                    className: "VipTiersWidget",
                    dependencyGroupId: 2
                },
            
                "1011639": {
                    instanceId: "1011639",
                    instanceVersionId: "327451085",
                    templateAssetUrl: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widget-coupons-redemption/app.v1.1.13-7015.js",
                    cssOverrideAssetUrl: "https://cdn-widget-assets.yotpo.com/CouponsRedemptionWidget/pc-_zsvJHOoRaZ3ebWa_rg/css-overrides/css-overrides.2025_01_20_03_21_36_751.css",
                    customizationCssUrl: "",
                    customizations: {
                      "confirmation-step-cancel-option": "No",
                      "confirmation-step-confirm-option": "Yes",
                      "confirmation-step-title": "Are you sure?",
                      "coupon-background-type": "no-background",
                      "coupon-code-copied-message-body": "Thank you for redeeming your points. Please paste the code at checkout",
                      "coupon-code-copied-message-color": "#707997",
                      "coupon-code-copied-message-title": "",
                      "coupons-redemption-description": "Redeeming your points is easy! Just click Redeem my points, and select an eligible reward.",
                      "coupons-redemption-headline": "How to Use Your Points",
                      "coupons-redemption-rule": "100 points equals {{1_local_currency}}",
                      "description-color": "rgba(0,0,0,1)",
                      "description-font-size": "16",
                      "discount-bigger-than-subscription-cost-text": "Your next subscription is lower than the redemption amount",
                      "donate-button-text": "Donate",
                      "donation-success-message-body": "Thank you for donating ${{donation_amount}} to {{company_name}}",
                      "donation-success-message-color": "#707997",
                      "donation-success-message-title": "Success",
                      "error-message-color": "#f04860",
                      "error-message-title": "",
                      "headline-color": "#000000",
                      "headline-font-size": "26",
                      "layout-add-background": "true",
                      "layout-background-color": "rgba(248,247,243,1)",
                      "local-enable-opt-in-flow": false,
                      "local-member-optin-disclaimer": "Add a disclaimer and button asking non-members to join your program.",
                      "local-member-optin-disclaimer-part2": "To customize them, go to \u003cb\u003ePage Settings.\u003c/b\u003e",
                      "login-button-color": "rgba(0,0,0,1)",
                      "login-button-text": "Redeem my points",
                      "login-button-text-color": "white",
                      "login-button-type": "filled_rectangle",
                      "message-font-size": "14",
                      "missing-points-amount-text": "You don't have enough points to redeem",
                      "next-subscription-headline-text": "NEXT ORDER",
                      "next-subscription-subtitle-text": "{{product_name}} {{next_order_amount}}",
                      "no-subscription-subtitle-text": "No ongoing subscriptions",
                      "point-balance-text": "You have {{current_point_balance}} points",
                      "points-balance-color": "rgba(0,0,0,1)",
                      "points-balance-font-size": "16",
                      "points-balance-number-color": "rgba(0,0,0,1)",
                      "primary-font-name-and-url": "founders-grotesk-regular@400|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK/founders-grotesk-regular/founders-grotesk-regular-400.css",
                      "redeem-button-color": "#0F8383",
                      "redeem-button-text": "Redeem",
                      "redeem-button-text-color": "#FFFFFF",
                      "redeem-button-type": "rounded_filled_rectangle",
                      "redeem-frame-color": "#BCBCBC",
                      "redemption-942586-displayname": "60 zł off",
                      "redemption-942586-settings-button-color": "rgba(0,0,0,1)",
                      "redemption-942586-settings-button-text": "Redeem",
                      "redemption-942586-settings-button-text-color": "#FFFFFF",
                      "redemption-942586-settings-button-type": "filled_rectangle",
                      "redemption-942586-settings-call-to-action-button-text": "Redeem",
                      "redemption-942586-settings-cost": 600,
                      "redemption-942586-settings-cost-color": "rgba(0,0,0,1)",
                      "redemption-942586-settings-cost-font-size": "16",
                      "redemption-942586-settings-cost-text": "{{points}} points",
                      "redemption-942586-settings-coupon-cost-font-size": "15",
                      "redemption-942586-settings-coupon-reward-font-size": "20",
                      "redemption-942586-settings-discount-amount-cents": 6000,
                      "redemption-942586-settings-discount-type": "fixed_amount",
                      "redemption-942586-settings-frame-color": "rgba(0,0,0,0)",
                      "redemption-942586-settings-reward": "{{60_local_currency}} off",
                      "redemption-942586-settings-reward-color": "rgba(0,0,0,1)",
                      "redemption-942586-settings-reward-font-size": 28,
                      "redemption-942586-settings-success-message-text": "Reward Applied",
                      "redemption-942587-displayname": "90 zł off",
                      "redemption-942587-settings-button-color": "rgba(0,0,0,1)",
                      "redemption-942587-settings-button-text": "Redeem",
                      "redemption-942587-settings-button-text-color": "#FFFFFF",
                      "redemption-942587-settings-button-type": "filled_rectangle",
                      "redemption-942587-settings-call-to-action-button-text": "Redeem",
                      "redemption-942587-settings-cost": 900,
                      "redemption-942587-settings-cost-color": "rgba(0,0,0,1)",
                      "redemption-942587-settings-cost-font-size": "16",
                      "redemption-942587-settings-cost-text": "{{points}} points",
                      "redemption-942587-settings-coupon-cost-font-size": "15",
                      "redemption-942587-settings-coupon-reward-font-size": "20",
                      "redemption-942587-settings-discount-amount-cents": 9000,
                      "redemption-942587-settings-discount-type": "fixed_amount",
                      "redemption-942587-settings-frame-color": "rgba(0,0,0,0)",
                      "redemption-942587-settings-reward": "{{90_local_currency}} off",
                      "redemption-942587-settings-reward-color": "rgba(0,0,0,1)",
                      "redemption-942587-settings-reward-font-size": 28,
                      "redemption-942587-settings-success-message-text": "Reward Applied",
                      "redemption-944048-displayname": "120 zł off",
                      "redemption-944048-settings-button-color": "rgba(0,0,0,1)",
                      "redemption-944048-settings-button-text": "Redeem",
                      "redemption-944048-settings-button-text-color": "#FFFFFF",
                      "redemption-944048-settings-button-type": "filled_rectangle",
                      "redemption-944048-settings-call-to-action-button-text": "Redeem",
                      "redemption-944048-settings-cost": "1200",
                      "redemption-944048-settings-cost-color": "rgba(0,0,0,1)",
                      "redemption-944048-settings-cost-font-size": "16",
                      "redemption-944048-settings-cost-text": "{{points}} points",
                      "redemption-944048-settings-coupon-cost-font-size": "15",
                      "redemption-944048-settings-coupon-reward-font-size": "20",
                      "redemption-944048-settings-discount-amount-cents": "12000",
                      "redemption-944048-settings-discount-type": "fixed_amount",
                      "redemption-944048-settings-frame-color": "rgba(0,0,0,0)",
                      "redemption-944048-settings-reward": "120 zł off",
                      "redemption-944048-settings-reward-color": "rgba(0,0,0,1)",
                      "redemption-944048-settings-reward-font-size": 28,
                      "redemption-944048-settings-success-message-text": "Reward Applied",
                      "reward-opt-in-join-now-button-label": "Complete program signup",
                      "rewards-disclaimer-text": "I agree to the program’s [terms](http://example.net/terms) and [privacy policy](http://example.net/privacy-policy)",
                      "rewards-disclaimer-text-color": "#00000",
                      "rewards-disclaimer-text-size": "12px",
                      "rewards-disclaimer-type": "no-disclaimer",
                      "rule-color": "rgba(0,0,0,1)",
                      "rule-dots-color": "rgba(0,0,0,1)",
                      "rule-font-size": 16,
                      "secondary-font-name-and-url": "founders-grotesk-regular@400|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK/founders-grotesk-regular/founders-grotesk-regular-400.css",
                      "selected-extensions": [
                        "942586",
                        "942587",
                        "944048"
                      ],
                      "selected-redemptions-modes": "regular",
                      "subscription-coupon-applied-message-body": "The discount was applied to your upcoming subscription order. You’ll be able to get another discount once the next order is processed.",
                      "subscription-coupon-applied-message-color": "#707997",
                      "subscription-coupon-applied-message-title": "",
                      "subscription-divider-color": "#c2cdf4",
                      "subscription-headline-color": "#666d8b",
                      "subscription-headline-font-size": "14",
                      "subscription-points-headline-text": "YOUR POINT BALANCE",
                      "subscription-points-subtitle-text": "{{current_point_balance}} Points",
                      "subscription-redemptions-description": "Choose a discount option that will automatically apply to your next subscription order.",
                      "subscription-redemptions-headline": "Redeem for Subscription Discount",
                      "subscription-subtitle-color": "#768cdc",
                      "subscription-subtitle-font-size": "20",
                      "undefined": "Only for brands using Shopify’s new customer accounts and have program eligibility set to “only members who signed up.”",
                      "view-layout": "full-layout"
                    },
                    staticContent: {
                      "cssEditorEnabled": true,
                      "currency": "PLN",
                      "isHidden": false,
                      "isMultiCurrencyEnabled": true,
                      "isOptInFlowEnabled": false,
                      "isShopifyNewAccountsVersion": false,
                      "merchantId": "181985",
                      "platformName": "shopify",
                      "storeId": "yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK",
                      "storeLoginUrl": "/account/login",
                      "subunitsPerUnit": 100
                    },
                    className: "CouponsRedemptionWidget",
                    dependencyGroupId: 2
                },
            
                "899590": {
                    instanceId: "899590",
                    instanceVersionId: "349764710",
                    templateAssetUrl: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widget-referral-friend/app.v0.2.17-7276.js",
                    cssOverrideAssetUrl: "",
                    customizationCssUrl: "",
                    customizations: {
                      "background-color": "rgba(254,253,249,1)",
                      "background-image-url": "https://cdn-widget-assets.yotpo.com/static_assets/pc-_zsvJHOoRaZ3ebWa_rg/images/image_2025_03_14_09_51_46_921",
                      "background-image-url-mobile": "https://cdn-widget-assets.yotpo.com/static_assets/pc-_zsvJHOoRaZ3ebWa_rg/images/image_2025_03_14_09_51_54_345",
                      "copy-code-copied-text": "COPIED",
                      "copy-code-icon-color": "rgba(0,0,0,1)",
                      "coupon-background-color": "#fafbfc",
                      "default-toggle": true,
                      "disclaimer-text": "I agree to the program’s [terms](http://example.net/terms) and [privacy policy](http://example.net/privacy-policy)",
                      "disclaimer-text-size": "12px",
                      "disclaimer-type": "no-disclaimer",
                      "email-activation": "true",
                      "email-capture-description-color": "#000000",
                      "email-capture-description-font-size": "14px",
                      "email-capture-description-text": "Enter your email to get your discount.",
                      "email-capture-title-color": "#000000",
                      "email-capture-title-font-size": "20px",
                      "email-capture-title-text": "Hey, friend! Your friend sent you {{reward}} your first purchase of {{min_spent}} or more.",
                      "email-verification-button-background-color": "#0F8383",
                      "email-verification-button-text": "Next",
                      "email-verification-button-text-color": "#FFFFFF",
                      "email-verification-button-type": "rounded_filled_rectangle",
                      "email-verification-resend-button-color": "#0F8383",
                      "email-verification-resend-button-font-size": "12px",
                      "email-verification-resend-link-sent-text": "Code sent",
                      "email-verification-resend-link-text": "Resend code",
                      "email-verification-resend-text": "Didn't get an email?",
                      "email-verification-resend-text-color": "#000000",
                      "email-verification-resend-text-font-size": "12px",
                      "email-verification-subtitle-color": "#000000",
                      "email-verification-subtitle-font-size": "14px",
                      "email-verification-subtitle-text": "Enter the code we sent to your email.",
                      "email-verification-title-color": "#000000",
                      "email-verification-title-font-size": "20px",
                      "email-verification-title-text": "Enter verification code",
                      "error-already-used-coupon-text": "Wygląda na to, że ta oferta została już przez Ciebie wykorzystana.",
                      "error-general-failure-text": "Wystąpił błąd podczas generowania Twojej nagrody.",
                      "error-incorrect-verification-code-text": "Incorrect code. Try entering the code again.",
                      "error-message-invalid-email": "Wprowadź poprawny adres email.",
                      "error-message-text-color": "#C10000",
                      "error-message-verification-code-text-color": "#C10000",
                      "error-not-eligible-coupon-text": "Wygląda na to, że nie możesz skorzystać z tej oferty.\n",
                      "next-button-background-color": "rgba(43,42,165,1)",
                      "next-button-text": "DALEJ",
                      "next-button-text-color": "rgba(252,250,238,1)",
                      "next-button-type": "filled_rectangle",
                      "no-reward-subtitle-text": "Wprowadź swój email, abyśmy mogli powiadomić Twojego znajomego, że otrzymałeś/otrzymałaś jego polecenie.\n",
                      "no-reward-title-text": "WITAJ W THE ODDER SIDE!",
                      "nothing-reward-subtitle-text": "Sprawdź nasze produkty i możliwości zdobywania nagród za zakupy w naszym programie lojalnościowym.",
                      "nothing-reward-title-text": "Czy wiesz, że możesz zdobywać punkty za każde zamówienie?",
                      "points-reward-subtitle-text": "Log in or create an account to use them",
                      "points-reward-title-text": "You’ve got {{points}} points to spend on rewards 🎉",
                      "points-subtitle-text": "Enter your email to get started",
                      "points-title-text": "Hey, friend! Your friend sent you {{points}} points to spend",
                      "popup-background-color": "rgba(254,253,249,1)",
                      "primary-font-name-and-url": "founders-grotesk-regular@400|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK/founders-grotesk-regular/founders-grotesk-regular-400.css",
                      "reward-option-auto-apply-title-text": "You got it! Your discount will  be automatically applied at checkout.",
                      "reward-option-title-text": "You got it! Just copy this code and paste it at checkout to use your discount.",
                      "rewards-page-button-background-color": "#0F8383",
                      "rewards-page-button-text": "Check out rewards program",
                      "rewards-page-button-text-color": "#0F8383",
                      "rewards-page-button-type": "rounded_rectangle",
                      "secondary-font-name-and-url": "founders-grotesk-regular@400|https://cdn-widgetsrepository.yotpo.com/brandkit/custom-fonts/yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK/founders-grotesk-regular/founders-grotesk-regular-400.css",
                      "show-email-capture": false,
                      "sign-up-button-background-color": "#0F8383",
                      "sign-up-button-text": "Go to account page",
                      "sign-up-button-text-color": "#FFFFFF",
                      "sign-up-button-type": "rounded_filled_rectangle",
                      "start-button-background-color": "rgba(43,42,165,1)",
                      "start-button-text": "Przejdź do zakupów",
                      "start-button-text-color": "rgba(252,250,238,1)",
                      "start-button-type": "filled_rectangle",
                      "subtitle-color": "#000000",
                      "subtitle-font-size": "14px",
                      "subtitle-text": "You can also copy and save this code for later.",
                      "text-design-choose-screen": "email_capture_display",
                      "title-color": "#000000",
                      "title-font-size": "20px",
                      "title-text": "Your discount will be automatically applied at checkout!"
                    },
                    staticContent: {
                      "cssEditorEnabled": false,
                      "currency": "PLN",
                      "forceEmailCapture": false,
                      "friendVerificationEnabled": "disabled",
                      "hideFriendCoupon": false,
                      "isHidden": false,
                      "isMultiCurrencyEnabled": false,
                      "merchantId": "181985",
                      "platformName": "shopify",
                      "rewardType": "NOTHING",
                      "selfExecutable": true,
                      "shouldAutoApplyCoupon": true,
                      "shouldShowInfoMessage": false,
                      "showRewardsButton": false,
                      "storeId": "yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK",
                      "urlMatch": "https?://(?!yap.yotpo.com).*sref_id=.*"
                    },
                    className: "ReferralFriendWidget",
                    dependencyGroupId: null
                },
            
                "637132": {
                    instanceId: "637132",
                    instanceVersionId: "255167764",
                    templateAssetUrl: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widget-customer-preview/app.v0.2.8-6189.js",
                    cssOverrideAssetUrl: "",
                    customizationCssUrl: "",
                    customizations: {
                      "view-background-color": "transparent",
                      "view-primary-color": "#2e4f7c",
                      "view-primary-font": "Nunito Sans@700|https://cdn-widgetsrepository.yotpo.com/web-fonts/css/nunito_sans/v1/nunito_sans_700.css",
                      "view-text-color": "#202020",
                      "welcome-text": "Good morning"
                    },
                    staticContent: {
                      "currency": "PLN",
                      "hideIfMatchingQueryParam": [
                        "oseid"
                      ],
                      "isHidden": true,
                      "platformName": "shopify",
                      "selfExecutable": true,
                      "storeId": "yysF3CWS5U6CpdeR0AMYKVxVn0uJeeDC9c7cmwRK",
                      "storeLoginUrl": "http://theodderside.com/account/login",
                      "storeRegistrationUrl": "http://theodderside.com/account/register",
                      "storeRewardsPageUrl": "http://theodderside.com/pages/rewards",
                      "urlMatch": "^(?!.*\\.yotpo\\.com).*$"
                    },
                    className: "CustomerPreview",
                    dependencyGroupId: null
                },
            
            },
            guidStaticContent: {},
            dependencyGroups: {
                      "2": [
                        "https://cdn-widget-assets.yotpo.com/widget-vue-core/app.v0.1.0-2295.js"
                      ]
                    }
        },
        initializer: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widgets-initializer/app.v0.9.5-7207.js",
        analytics: "https://cdn-widgetsrepository.yotpo.com/widget-assets/yotpo-pixel/2024-04-18_14-53-12/bundle.js"
    }
    
    
    const initWidgets = function (config, initializeWidgets = true) {
        const widgetInitializer = yotpoWidgetsContainer['yotpo_widget_initializer'](config);
        return widgetInitializer.initWidgets(initializeWidgets);
    };
    const initWidget = function (config, instanceId, widgetPlaceHolder) {
        const widgetInitializer = yotpoWidgetsContainer['yotpo_widget_initializer'](config);
        if (widgetInitializer.initWidget) {
            return widgetInitializer.initWidget(instanceId, widgetPlaceHolder);
        }
        console.error("initWidget is not supported widgetInitializer");
    };
    const onInitializerLoad = function (config) {
        const prevInitWidgets = yotpoWidgetsContainer.initWidgets;
        yotpoWidgetsContainer.initWidgets = function (initializeWidgets = true) {
            if (prevInitWidgets) {
                if (typeof Promise !== 'undefined' && Promise.all) {
                    return Promise.all([prevInitWidgets(initializeWidgets), initWidgets(config, initializeWidgets)]);
                }
                console.warn('[deprecated] promise is not supported in initWidgets');
                prevInitWidgets(initializeWidgets);
            }
            return initWidgets(config, initializeWidgets);
        }
        const prevInitWidget = yotpoWidgetsContainer.initWidget;
        yotpoWidgetsContainer.initWidget = function (instanceId, widgetPlaceHolder) {
            if (prevInitWidget) {
              prevInitWidget(instanceId, widgetPlaceHolder)
            }
            return initWidget(config, instanceId, widgetPlaceHolder);
        }
        const guidWidgetContainer = getGuidWidgetsContainer();
        guidWidgetContainer.initWidgets = function () {
            return initWidgets(config);
        }
        guidWidgetContainer.initWidgets();
    };
    function getGuidWidgetsContainer () {
        if (!yotpoWidgetsContainer.guids) {
            yotpoWidgetsContainer.guids = {};
        }
        if (!yotpoWidgetsContainer.guids[guid]) {
            yotpoWidgetsContainer.guids[guid] = {};
        }
        return yotpoWidgetsContainer.guids[guid];
    }

    

    const guidWidgetContainer = getGuidWidgetsContainer();
    guidWidgetContainer.config = loader.config;
    if (!guidWidgetContainer.yotpo_widget_scripts_loaded) {
        guidWidgetContainer.yotpo_widget_scripts_loaded = true;
        guidWidgetContainer.onInitializerLoad = function () { onInitializerLoad(loader.config) };
        
        
        loader.loadDep(loader.analytics, function () {}, 'defer');
        
        
        
        loader.loadDep(loader.initializer, function () { guidWidgetContainer.onInitializerLoad() }, 'async');
        
    }
})()

